/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return createRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* harmony default export */ __webpack_exports__["default"] = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(global,factory){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if(typeof exports !== 'undefined'){factory(exports);}else {var mod={exports:{}};factory(mod.exports);global.decko = mod.exports;}})(this,function(exports){'use strict';exports.__esModule = true;var EMPTY={};var HOP=Object.prototype.hasOwnProperty;var fns={memoize:function memoize(fn){var opt=arguments.length <= 1 || arguments[1] === undefined?EMPTY:arguments[1];var cache=opt.cache || {};return function(){for(var _len=arguments.length,a=Array(_len),_key=0;_key < _len;_key++) {a[_key] = arguments[_key];}var k=String(a[0]);if(opt.caseSensitive === false)k = k.toLowerCase();return HOP.call(cache,k)?cache[k]:cache[k] = fn.apply(this,a);};},debounce:function debounce(fn,opts){if(typeof opts === 'function'){var p=fn;fn = opts;opts = p;}var delay=opts && opts.delay || opts || 0,args=undefined,context=undefined,timer=undefined;return function(){for(var _len2=arguments.length,a=Array(_len2),_key2=0;_key2 < _len2;_key2++) {a[_key2] = arguments[_key2];}args = a;context = this;if(!timer)timer = setTimeout(function(){fn.apply(context,args);args = context = timer = null;},delay);};},bind:function bind(target,key,_ref){var fn=_ref.value;return {configurable:true,get:function get(){var value=fn.bind(this);Object.defineProperty(this,key,{value:value,configurable:true,writable:true});return value;}};}};var memoize=multiMethod(fns.memoize),debounce=multiMethod(fns.debounce),bind=multiMethod(function(f,c){return f.bind(c);},function(){return fns.bind;});exports.memoize = memoize;exports.debounce = debounce;exports.bind = bind;exports['default'] = {memoize:memoize,debounce:debounce,bind:bind};function multiMethod(inner,deco){deco = deco || inner.decorate || decorator(inner);var d=deco();return function(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3 < _len3;_key3++) {args[_key3] = arguments[_key3];}var l=args.length;return (l < 2?deco:l > 2?d:inner).apply(undefined,args);};}function decorator(fn){return function(opt){return typeof opt === 'function'?fn(opt):function(target,key,desc){desc.value = fn(desc.value,opt,target,key,desc);};};}});

//# sourceMappingURL=decko.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(0)) :
  typeof define === 'function' && define.amd ? define(['exports', 'preact'], factory) :
  (factory((global.preactMdl = global.preactMdl || {}),global.preact));
}(this, function (exports,preact) { 'use strict';

  var asyncGenerator = function () {
    function AwaitValue(value) {
      this.value = value;
    }

    function AsyncGenerator(gen) {
      var front, back;

      function send(key, arg) {
        return new Promise(function (resolve, reject) {
          var request = {
            key: key,
            arg: arg,
            resolve: resolve,
            reject: reject,
            next: null
          };

          if (back) {
            back = back.next = request;
          } else {
            front = back = request;
            resume(key, arg);
          }
        });
      }

      function resume(key, arg) {
        try {
          var result = gen[key](arg);
          var value = result.value;

          if (value instanceof AwaitValue) {
            Promise.resolve(value.value).then(function (arg) {
              resume("next", arg);
            }, function (arg) {
              resume("throw", arg);
            });
          } else {
            settle(result.done ? "return" : "normal", result.value);
          }
        } catch (err) {
          settle("throw", err);
        }
      }

      function settle(type, value) {
        switch (type) {
          case "return":
            front.resolve({
              value: value,
              done: true
            });
            break;

          case "throw":
            front.reject(value);
            break;

          default:
            front.resolve({
              value: value,
              done: false
            });
            break;
        }

        front = front.next;

        if (front) {
          resume(front.key, front.arg);
        } else {
          back = null;
        }
      }

      this._invoke = send;

      if (typeof gen.return !== "function") {
        this.return = undefined;
      }
    }

    if (typeof Symbol === "function" && Symbol.asyncIterator) {
      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      };
    }

    AsyncGenerator.prototype.next = function (arg) {
      return this._invoke("next", arg);
    };

    AsyncGenerator.prototype.throw = function (arg) {
      return this._invoke("throw", arg);
    };

    AsyncGenerator.prototype.return = function (arg) {
      return this._invoke("return", arg);
    };

    return {
      wrap: function (fn) {
        return function () {
          return new AsyncGenerator(fn.apply(this, arguments));
        };
      },
      await: function (value) {
        return new AwaitValue(value);
      }
    };
  }();

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var objectWithoutProperties = function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  var possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  var options = {};

  function mdl() {
  	return options.mdl || options.componentHandler || window.componentHandler;
  }

  var RIPPLE_CLASS = 'js-ripple-effect';

  var MDL_PREFIX = function (s) {
  	return MDL_NO_PREFIX[s] ? s : 'mdl-' + s;
  };

  var MDL_NO_PREFIX = { 'is-active': true };

  var uidCounter = 1;

  function uid() {
  	return ++uidCounter;
  }

  function extend(base, props) {
  	for (var i in props) {
  		if (props.hasOwnProperty(i)) base[i] = props[i];
  	}return base;
  }

  function setClass(attributes, value, append) {
  	var cl = getClass(attributes);
  	if (attributes.className) delete attributes.className;
  	if (append) value = cl ? cl + ' ' + value : value;
  	attributes.class = value;
  }

  function getClass(attributes) {
  	return attributes.class || attributes.className;
  }

  var propMaps = {
  	disabled: function (_ref) {
  		var attributes = _ref.attributes;

  		if (attributes.hasOwnProperty('disabled') && !attributes.disabled) {
  			attributes.disabled = null;
  		}
  	},
  	badge: function (_ref2) {
  		var attributes = _ref2.attributes;

  		attributes['data-badge'] = attributes.badge;
  		delete attributes.badge;
  		setClass(attributes, 'mdl-badge', true);
  	},
  	active: function (_ref3) {
  		var attributes = _ref3.attributes;

  		if (attributes.active) {
  			setClass(attributes, 'is-active', true);
  		}
  	},
  	shadow: function (_ref4) {
  		var attributes = _ref4.attributes;

  		var d = parseFloat(attributes.shadow) | 0,
  		    c = getClass(attributes).replace(/\smdl-[^ ]+--shadow\b/g, '');
  		setClass(attributes, c + (c ? ' ' : '') + ('mdl-shadow--' + d + 'dp'));
  	}
  };

  var MaterialComponent = function (_Component) {
  	inherits(MaterialComponent, _Component);

  	function MaterialComponent() {
  		var _temp, _this, _ret;

  		classCallCheck(this, MaterialComponent);

  		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
  			args[_key] = arguments[_key];
  		}

  		return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.component = 'none', _this.js = false, _this.ripple = false, _this.mdlClasses = null, _this.upgradedBase = null, _temp), possibleConstructorReturn(_this, _ret);
  	}

  	MaterialComponent.prototype.mdlRender = function mdlRender(props) {
  		return preact.h(
  			'div',
  			props,
  			props.children
  		);
  	};

  	MaterialComponent.prototype.render = function render(props, state) {
  		var r = this.mdlRender(props, state);
  		if (this.nodeName) r.nodeName = this.nodeName;
  		if (!r.attributes) r.attributes = {};
  		r.attributes.class = this.createMdlClasses(props).concat(r.attributes.class || [], r.attributes.className || []).join(' ');
  		for (var i in propMaps) {
  			if (propMaps.hasOwnProperty(i)) {
  				if (props.hasOwnProperty(i)) {
  					propMaps[i](r);
  				}
  			}
  		}if (this.base && this.upgradedBase) {
  			this.preserveMdlDom(this.base, r);
  		}
  		return r;
  	};

  	MaterialComponent.prototype.preserveMdlDom = function preserveMdlDom(base, r) {
  		if (!base || !base.hasAttribute || !r) return;

  		var c = base.childNodes,
  		    persist = ['mdl-js-ripple-effect--ignore-events', 'mdl-js-ripple-effect', 'is-upgraded', 'is-dirty'],
  		    v = base.getAttribute('data-upgraded'),
  		    a = r.attributes,
  		    cl = getClass(a) || '',
  		    foundRipple = false;

  		if (!a) a = {};

  		if (v) {
  			a['data-upgraded'] = v;
  			upgradeQueue.add(base);
  		}

  		if (base.hasAttribute('ink-enabled')) {
  			if (!r.attributes) r.attributes = {};
  			r.attributes['ink-enabled'] = 'true';
  		}

  		for (var i = 0; i < persist.length; i++) {
  			if (base.classList.contains(persist[i])) {
  				if (typeof a.class === 'string') {
  					if (cl.indexOf(persist[i]) === -1) {
  						cl += ' ' + persist[i];
  					}
  				} else {
  					(cl || (cl = {}))[persist[i]] = true;
  				}
  			}
  		}

  		setClass(a, cl);
  	};

  	MaterialComponent.prototype.createMdlClasses = function createMdlClasses(props) {
  		var name = this.component,
  		    c = [],
  		    mapping = this.propClassMapping || {},
  		    js = props.js !== false && (this.js || this.ripple);
  		if (name) c.push(name);
  		if (this.mdlClasses) c.push.apply(c, this.mdlClasses);
  		if (this.ripple && props.ripple !== false) {
  			c.push(RIPPLE_CLASS);
  		}
  		if (js) c.push('js-' + name);
  		for (var i in props) {
  			if (props.hasOwnProperty(i) && props[i] === true) {
  				c.push(MDL_NO_PREFIX[i] ? i : mapping[i] || name + '--' + i);
  			}
  		}
  		return c.map(MDL_PREFIX);
  	};

  	MaterialComponent.prototype.componentDidMount = function componentDidMount() {
  		if (this.base !== this.upgradedBase) {
  			if (this.upgradedBase) {
  				mdl().downgradeElements(this.upgradedBase);
  			}
  			this.upgradedBase = null;
  			if (this.base && this.base.parentElement) {
  				this.upgradedBase = this.base;
  				mdl().upgradeElement(this.base);
  			}
  		}
  	};

  	MaterialComponent.prototype.componentWillUnmount = function componentWillUnmount() {
  		if (this.upgradedBase) {
  			mdl().downgradeElements(this.upgradedBase);
  			this.upgradedBase = null;
  		}
  	};

  	return MaterialComponent;
  }(preact.Component);

  var upgradeQueue = {
  	items: [],
  	add: function (base) {
  		if (upgradeQueue.items.push(base) === 1) {
  			requestAnimationFrame(upgradeQueue.process);
  		}
  	},
  	process: function () {
  		var p = upgradeQueue.items;
  		for (var i = p.length; i--;) {
  			var el = p[i],
  			    v = el.getAttribute('data-upgraded'),
  			    u = v && v.split(',');
  			if (!u) continue;
  			for (var j = u.length; j--;) {
  				var c = u[j],
  				    a = c && el[c];
  				if (a) {
  					if (a.updateClasses_) {
  						a.updateClasses_();
  					}
  					if (a.onFocus_ && a.input_ && a.input_.matches && a.input_.matches(':focus')) {
  						a.onFocus_();
  					}
  				}
  			}
  		}
  		p.length = 0;
  	}
  };

  var Icon = function (_MaterialComponent) {
  	inherits(Icon, _MaterialComponent);

  	function Icon() {
  		classCallCheck(this, Icon);
  		return possibleConstructorReturn(this, _MaterialComponent.apply(this, arguments));
  	}

  	Icon.prototype.mdlRender = function mdlRender(props) {
  		var c = getClass(props) || '',
  		    icon = String(props.icon || props.children).replace(/[ -]/g, '_');
  		delete props.icon;
  		delete props.className;
  		if (typeof c === 'string') {
  			c = 'material-icons ' + c;
  		} else {
  			c['material-icons'] = true;
  		}
  		return preact.h(
  			'i',
  			_extends({}, props, { 'class': c }),
  			icon
  		);
  	};

  	return Icon;
  }(MaterialComponent);

  var Button = function (_MaterialComponent2) {
  	inherits(Button, _MaterialComponent2);

  	function Button() {
  		var _temp2, _this3, _ret2;

  		classCallCheck(this, Button);

  		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
  			args[_key2] = arguments[_key2];
  		}

  		return _ret2 = (_temp2 = (_this3 = possibleConstructorReturn(this, _MaterialComponent2.call.apply(_MaterialComponent2, [this].concat(args))), _this3), _this3.component = 'button', _this3.nodeName = 'button', _this3.js = true, _this3.ripple = true, _temp2), possibleConstructorReturn(_this3, _ret2);
  	}

  	return Button;
  }(MaterialComponent);

  var Card = function (_MaterialComponent3) {
  	inherits(Card, _MaterialComponent3);

  	function Card() {
  		var _temp3, _this4, _ret3;

  		classCallCheck(this, Card);

  		for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
  			args[_key3] = arguments[_key3];
  		}

  		return _ret3 = (_temp3 = (_this4 = possibleConstructorReturn(this, _MaterialComponent3.call.apply(_MaterialComponent3, [this].concat(args))), _this4), _this4.component = 'card', _temp3), possibleConstructorReturn(_this4, _ret3);
  	}

  	return Card;
  }(MaterialComponent);

  var CardTitle = function (_MaterialComponent4) {
  	inherits(CardTitle, _MaterialComponent4);

  	function CardTitle() {
  		var _temp4, _this5, _ret4;

  		classCallCheck(this, CardTitle);

  		for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
  			args[_key4] = arguments[_key4];
  		}

  		return _ret4 = (_temp4 = (_this5 = possibleConstructorReturn(this, _MaterialComponent4.call.apply(_MaterialComponent4, [this].concat(args))), _this5), _this5.component = 'card__title', _this5.propClassMapping = {
  			expand: 'card--expand'
  		}, _temp4), possibleConstructorReturn(_this5, _ret4);
  	}

  	return CardTitle;
  }(MaterialComponent);

  var CardTitleText = function (_MaterialComponent5) {
  	inherits(CardTitleText, _MaterialComponent5);

  	function CardTitleText() {
  		var _temp5, _this6, _ret5;

  		classCallCheck(this, CardTitleText);

  		for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
  			args[_key5] = arguments[_key5];
  		}

  		return _ret5 = (_temp5 = (_this6 = possibleConstructorReturn(this, _MaterialComponent5.call.apply(_MaterialComponent5, [this].concat(args))), _this6), _this6.component = 'card__title-text', _this6.nodeName = 'h2', _temp5), possibleConstructorReturn(_this6, _ret5);
  	}

  	return CardTitleText;
  }(MaterialComponent);

  var CardMedia = function (_MaterialComponent6) {
  	inherits(CardMedia, _MaterialComponent6);

  	function CardMedia() {
  		var _temp6, _this7, _ret6;

  		classCallCheck(this, CardMedia);

  		for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
  			args[_key6] = arguments[_key6];
  		}

  		return _ret6 = (_temp6 = (_this7 = possibleConstructorReturn(this, _MaterialComponent6.call.apply(_MaterialComponent6, [this].concat(args))), _this7), _this7.component = 'card__media', _temp6), possibleConstructorReturn(_this7, _ret6);
  	}

  	return CardMedia;
  }(MaterialComponent);

  var CardText = function (_MaterialComponent7) {
  	inherits(CardText, _MaterialComponent7);

  	function CardText() {
  		var _temp7, _this8, _ret7;

  		classCallCheck(this, CardText);

  		for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
  			args[_key7] = arguments[_key7];
  		}

  		return _ret7 = (_temp7 = (_this8 = possibleConstructorReturn(this, _MaterialComponent7.call.apply(_MaterialComponent7, [this].concat(args))), _this8), _this8.component = 'card__supporting-text', _temp7), possibleConstructorReturn(_this8, _ret7);
  	}

  	return CardText;
  }(MaterialComponent);

  var CardActions = function (_MaterialComponent8) {
  	inherits(CardActions, _MaterialComponent8);

  	function CardActions() {
  		var _temp8, _this9, _ret8;

  		classCallCheck(this, CardActions);

  		for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
  			args[_key8] = arguments[_key8];
  		}

  		return _ret8 = (_temp8 = (_this9 = possibleConstructorReturn(this, _MaterialComponent8.call.apply(_MaterialComponent8, [this].concat(args))), _this9), _this9.component = 'card__actions', _temp8), possibleConstructorReturn(_this9, _ret8);
  	}

  	return CardActions;
  }(MaterialComponent);

  var CardMenu = function (_MaterialComponent9) {
  	inherits(CardMenu, _MaterialComponent9);

  	function CardMenu() {
  		var _temp9, _this10, _ret9;

  		classCallCheck(this, CardMenu);

  		for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
  			args[_key9] = arguments[_key9];
  		}

  		return _ret9 = (_temp9 = (_this10 = possibleConstructorReturn(this, _MaterialComponent9.call.apply(_MaterialComponent9, [this].concat(args))), _this10), _this10.component = 'card__menu', _temp9), possibleConstructorReturn(_this10, _ret9);
  	}

  	return CardMenu;
  }(MaterialComponent);

  extend(Card, {
  	Title: CardTitle,
  	TitleText: CardTitleText,
  	Media: CardMedia,
  	Text: CardText,
  	Actions: CardActions,
  	Menu: CardMenu
  });

  var Dialog = function (_MaterialComponent10) {
  	inherits(Dialog, _MaterialComponent10);

  	function Dialog() {
  		var _temp10, _this11, _ret10;

  		classCallCheck(this, Dialog);

  		for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
  			args[_key10] = arguments[_key10];
  		}

  		return _ret10 = (_temp10 = (_this11 = possibleConstructorReturn(this, _MaterialComponent10.call.apply(_MaterialComponent10, [this].concat(args))), _this11), _this11.component = 'dialog', _this11.nodeName = 'dialog', _this11.show = function () {
  			_this11.base.show();
  		}, _this11.showModal = function () {
  			_this11.base.showModal();
  		}, _this11.close = function () {
  			_this11.base.close && _this11.base.close();
  		}, _temp10), possibleConstructorReturn(_this11, _ret10);
  	}

  	return Dialog;
  }(MaterialComponent);

  var DialogTitle = function (_MaterialComponent11) {
  	inherits(DialogTitle, _MaterialComponent11);

  	function DialogTitle() {
  		var _temp11, _this12, _ret11;

  		classCallCheck(this, DialogTitle);

  		for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
  			args[_key11] = arguments[_key11];
  		}

  		return _ret11 = (_temp11 = (_this12 = possibleConstructorReturn(this, _MaterialComponent11.call.apply(_MaterialComponent11, [this].concat(args))), _this12), _this12.component = 'dialog__title', _temp11), possibleConstructorReturn(_this12, _ret11);
  	}

  	return DialogTitle;
  }(MaterialComponent);

  var DialogContent = function (_MaterialComponent12) {
  	inherits(DialogContent, _MaterialComponent12);

  	function DialogContent() {
  		var _temp12, _this13, _ret12;

  		classCallCheck(this, DialogContent);

  		for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
  			args[_key12] = arguments[_key12];
  		}

  		return _ret12 = (_temp12 = (_this13 = possibleConstructorReturn(this, _MaterialComponent12.call.apply(_MaterialComponent12, [this].concat(args))), _this13), _this13.component = 'dialog__content', _temp12), possibleConstructorReturn(_this13, _ret12);
  	}

  	return DialogContent;
  }(MaterialComponent);

  var DialogActions = function (_MaterialComponent13) {
  	inherits(DialogActions, _MaterialComponent13);

  	function DialogActions() {
  		var _temp13, _this14, _ret13;

  		classCallCheck(this, DialogActions);

  		for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
  			args[_key13] = arguments[_key13];
  		}

  		return _ret13 = (_temp13 = (_this14 = possibleConstructorReturn(this, _MaterialComponent13.call.apply(_MaterialComponent13, [this].concat(args))), _this14), _this14.component = 'dialog__actions', _temp13), possibleConstructorReturn(_this14, _ret13);
  	}

  	return DialogActions;
  }(MaterialComponent);

  extend(Dialog, {
  	Title: DialogTitle,
  	Content: DialogContent,
  	Actions: DialogActions
  });

  var Layout = function (_MaterialComponent14) {
  	inherits(Layout, _MaterialComponent14);

  	function Layout() {
  		var _temp14, _this15, _ret14;

  		classCallCheck(this, Layout);

  		for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
  			args[_key14] = arguments[_key14];
  		}

  		return _ret14 = (_temp14 = (_this15 = possibleConstructorReturn(this, _MaterialComponent14.call.apply(_MaterialComponent14, [this].concat(args))), _this15), _this15.component = 'layout', _this15.js = true, _temp14), possibleConstructorReturn(_this15, _ret14);
  	}

  	return Layout;
  }(MaterialComponent);

  var LayoutHeader = function (_MaterialComponent15) {
  	inherits(LayoutHeader, _MaterialComponent15);

  	function LayoutHeader() {
  		var _temp15, _this16, _ret15;

  		classCallCheck(this, LayoutHeader);

  		for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
  			args[_key15] = arguments[_key15];
  		}

  		return _ret15 = (_temp15 = (_this16 = possibleConstructorReturn(this, _MaterialComponent15.call.apply(_MaterialComponent15, [this].concat(args))), _this16), _this16.component = 'layout__header', _this16.nodeName = 'header', _temp15), possibleConstructorReturn(_this16, _ret15);
  	}

  	return LayoutHeader;
  }(MaterialComponent);

  var LayoutHeaderRow = function (_MaterialComponent16) {
  	inherits(LayoutHeaderRow, _MaterialComponent16);

  	function LayoutHeaderRow() {
  		var _temp16, _this17, _ret16;

  		classCallCheck(this, LayoutHeaderRow);

  		for (var _len16 = arguments.length, args = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
  			args[_key16] = arguments[_key16];
  		}

  		return _ret16 = (_temp16 = (_this17 = possibleConstructorReturn(this, _MaterialComponent16.call.apply(_MaterialComponent16, [this].concat(args))), _this17), _this17.component = 'layout__header-row', _temp16), possibleConstructorReturn(_this17, _ret16);
  	}

  	return LayoutHeaderRow;
  }(MaterialComponent);

  var LayoutTitle = function (_MaterialComponent17) {
  	inherits(LayoutTitle, _MaterialComponent17);

  	function LayoutTitle() {
  		var _temp17, _this18, _ret17;

  		classCallCheck(this, LayoutTitle);

  		for (var _len17 = arguments.length, args = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
  			args[_key17] = arguments[_key17];
  		}

  		return _ret17 = (_temp17 = (_this18 = possibleConstructorReturn(this, _MaterialComponent17.call.apply(_MaterialComponent17, [this].concat(args))), _this18), _this18.component = 'layout-title', _this18.nodeName = 'span', _temp17), possibleConstructorReturn(_this18, _ret17);
  	}

  	return LayoutTitle;
  }(MaterialComponent);

  var LayoutSpacer = function (_MaterialComponent18) {
  	inherits(LayoutSpacer, _MaterialComponent18);

  	function LayoutSpacer() {
  		var _temp18, _this19, _ret18;

  		classCallCheck(this, LayoutSpacer);

  		for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
  			args[_key18] = arguments[_key18];
  		}

  		return _ret18 = (_temp18 = (_this19 = possibleConstructorReturn(this, _MaterialComponent18.call.apply(_MaterialComponent18, [this].concat(args))), _this19), _this19.component = 'layout-spacer', _temp18), possibleConstructorReturn(_this19, _ret18);
  	}

  	return LayoutSpacer;
  }(MaterialComponent);

  var LayoutDrawer = function (_MaterialComponent19) {
  	inherits(LayoutDrawer, _MaterialComponent19);

  	function LayoutDrawer() {
  		var _temp19, _this20, _ret19;

  		classCallCheck(this, LayoutDrawer);

  		for (var _len19 = arguments.length, args = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
  			args[_key19] = arguments[_key19];
  		}

  		return _ret19 = (_temp19 = (_this20 = possibleConstructorReturn(this, _MaterialComponent19.call.apply(_MaterialComponent19, [this].concat(args))), _this20), _this20.component = 'layout__drawer', _temp19), possibleConstructorReturn(_this20, _ret19);
  	}

  	return LayoutDrawer;
  }(MaterialComponent);

  var LayoutContent = function (_MaterialComponent20) {
  	inherits(LayoutContent, _MaterialComponent20);

  	function LayoutContent() {
  		var _temp20, _this21, _ret20;

  		classCallCheck(this, LayoutContent);

  		for (var _len20 = arguments.length, args = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
  			args[_key20] = arguments[_key20];
  		}

  		return _ret20 = (_temp20 = (_this21 = possibleConstructorReturn(this, _MaterialComponent20.call.apply(_MaterialComponent20, [this].concat(args))), _this21), _this21.component = 'layout__content', _this21.nodeName = 'main', _temp20), possibleConstructorReturn(_this21, _ret20);
  	}

  	return LayoutContent;
  }(MaterialComponent);

  var LayoutTabBar = function (_MaterialComponent21) {
  	inherits(LayoutTabBar, _MaterialComponent21);

  	function LayoutTabBar() {
  		var _temp21, _this22, _ret21;

  		classCallCheck(this, LayoutTabBar);

  		for (var _len21 = arguments.length, args = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
  			args[_key21] = arguments[_key21];
  		}

  		return _ret21 = (_temp21 = (_this22 = possibleConstructorReturn(this, _MaterialComponent21.call.apply(_MaterialComponent21, [this].concat(args))), _this22), _this22.component = 'layout__tab-bar', _this22.js = true, _this22.ripple = false, _temp21), possibleConstructorReturn(_this22, _ret21);
  	}

  	return LayoutTabBar;
  }(MaterialComponent);

  var LayoutTab = function (_MaterialComponent22) {
  	inherits(LayoutTab, _MaterialComponent22);

  	function LayoutTab() {
  		var _temp22, _this23, _ret22;

  		classCallCheck(this, LayoutTab);

  		for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
  			args[_key22] = arguments[_key22];
  		}

  		return _ret22 = (_temp22 = (_this23 = possibleConstructorReturn(this, _MaterialComponent22.call.apply(_MaterialComponent22, [this].concat(args))), _this23), _this23.component = 'layout__tab', _this23.nodeName = 'a', _temp22), possibleConstructorReturn(_this23, _ret22);
  	}

  	return LayoutTab;
  }(MaterialComponent);

  var LayoutTabPanel = function (_MaterialComponent23) {
  	inherits(LayoutTabPanel, _MaterialComponent23);

  	function LayoutTabPanel() {
  		var _temp23, _this24, _ret23;

  		classCallCheck(this, LayoutTabPanel);

  		for (var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
  			args[_key23] = arguments[_key23];
  		}

  		return _ret23 = (_temp23 = (_this24 = possibleConstructorReturn(this, _MaterialComponent23.call.apply(_MaterialComponent23, [this].concat(args))), _this24), _this24.component = 'layout__tab-panel', _temp23), possibleConstructorReturn(_this24, _ret23);
  	}

  	LayoutTabPanel.prototype.mdlRender = function mdlRender(props) {
  		return preact.h(
  			'section',
  			props,
  			preact.h(
  				'div',
  				{ 'class': 'page-content' },
  				props.children
  			)
  		);
  	};

  	return LayoutTabPanel;
  }(MaterialComponent);

  extend(Layout, {
  	Header: LayoutHeader,
  	HeaderRow: LayoutHeaderRow,
  	Title: LayoutTitle,
  	Spacer: LayoutSpacer,
  	Drawer: LayoutDrawer,
  	Content: LayoutContent,
  	TabBar: LayoutTabBar,
  	Tab: LayoutTab,
  	TabPanel: LayoutTabPanel
  });

  var Navigation = function (_MaterialComponent24) {
  	inherits(Navigation, _MaterialComponent24);

  	function Navigation() {
  		var _temp24, _this25, _ret24;

  		classCallCheck(this, Navigation);

  		for (var _len24 = arguments.length, args = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
  			args[_key24] = arguments[_key24];
  		}

  		return _ret24 = (_temp24 = (_this25 = possibleConstructorReturn(this, _MaterialComponent24.call.apply(_MaterialComponent24, [this].concat(args))), _this25), _this25.component = 'navigation', _this25.nodeName = 'nav', _this25.propClassMapping = {
  			'large-screen-only': 'layout--large-screen-only'
  		}, _temp24), possibleConstructorReturn(_this25, _ret24);
  	}

  	Navigation.prototype.mdlRender = function mdlRender(props, state) {
  		var r = _MaterialComponent24.prototype.mdlRender.call(this, props, state);
  		r.children.forEach(function (item) {
  			if (!item) return item;
  			var c = item.attributes && getClass(item.attributes) || '';
  			if (!c.match(/\bmdl-navigation__link\b/g)) {
  				if (!item.attributes) item.attributes = {};
  				setClass(item.attributes, ' mdl-navigation__link', true);
  			}
  		});
  		return r;
  	};

  	return Navigation;
  }(MaterialComponent);

  var NavigationLink = function (_MaterialComponent25) {
  	inherits(NavigationLink, _MaterialComponent25);

  	function NavigationLink() {
  		classCallCheck(this, NavigationLink);

  		for (var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
  			args[_key25] = arguments[_key25];
  		}

  		var _this26 = possibleConstructorReturn(this, _MaterialComponent25.call.apply(_MaterialComponent25, [this].concat(args)));

  		_this26.component = 'navigation__link';
  		_this26.nodeName = 'a';

  		_this26.handleClick = _this26.handleClick.bind(_this26);
  		return _this26;
  	}

  	NavigationLink.prototype.handleClick = function handleClick(e) {
  		var _props = this.props,
  		    route = _props.route,
  		    href = _props.href,
  		    onClick = _props.onClick,
  		    onclick = _props.onclick;

  		onClick = onClick || onclick;
  		if (typeof onClick === 'function' && onClick({ type: 'click', target: this }) === false) {} else if (typeof route === 'function') {
  			route(href);
  		}
  		e.preventDefault();
  		return false;
  	};

  	NavigationLink.prototype.mdlRender = function mdlRender(_ref5, state) {
  		var children = _ref5.children,
  		    props = objectWithoutProperties(_ref5, ['children']);

  		return preact.h(
  			'a',
  			_extends({}, props, { onclick: this.handleClick }),
  			children
  		);
  	};

  	return NavigationLink;
  }(MaterialComponent);

  Navigation.Link = NavigationLink;

  var Tabs = function (_MaterialComponent26) {
  	inherits(Tabs, _MaterialComponent26);

  	function Tabs() {
  		var _temp25, _this27, _ret25;

  		classCallCheck(this, Tabs);

  		for (var _len26 = arguments.length, args = Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
  			args[_key26] = arguments[_key26];
  		}

  		return _ret25 = (_temp25 = (_this27 = possibleConstructorReturn(this, _MaterialComponent26.call.apply(_MaterialComponent26, [this].concat(args))), _this27), _this27.component = 'tabs', _this27.js = true, _this27.ripple = false, _temp25), possibleConstructorReturn(_this27, _ret25);
  	}

  	return Tabs;
  }(MaterialComponent);

  var TabBar = function (_MaterialComponent27) {
  	inherits(TabBar, _MaterialComponent27);

  	function TabBar() {
  		var _temp26, _this28, _ret26;

  		classCallCheck(this, TabBar);

  		for (var _len27 = arguments.length, args = Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
  			args[_key27] = arguments[_key27];
  		}

  		return _ret26 = (_temp26 = (_this28 = possibleConstructorReturn(this, _MaterialComponent27.call.apply(_MaterialComponent27, [this].concat(args))), _this28), _this28.component = 'tabs__tab-bar', _temp26), possibleConstructorReturn(_this28, _ret26);
  	}

  	return TabBar;
  }(MaterialComponent);

  var Tab = function (_MaterialComponent28) {
  	inherits(Tab, _MaterialComponent28);

  	function Tab() {
  		var _temp27, _this29, _ret27;

  		classCallCheck(this, Tab);

  		for (var _len28 = arguments.length, args = Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
  			args[_key28] = arguments[_key28];
  		}

  		return _ret27 = (_temp27 = (_this29 = possibleConstructorReturn(this, _MaterialComponent28.call.apply(_MaterialComponent28, [this].concat(args))), _this29), _this29.component = 'tabs__tab', _this29.nodeName = 'a', _temp27), possibleConstructorReturn(_this29, _ret27);
  	}

  	return Tab;
  }(MaterialComponent);

  var TabPanel = function (_MaterialComponent29) {
  	inherits(TabPanel, _MaterialComponent29);

  	function TabPanel() {
  		var _temp28, _this30, _ret28;

  		classCallCheck(this, TabPanel);

  		for (var _len29 = arguments.length, args = Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
  			args[_key29] = arguments[_key29];
  		}

  		return _ret28 = (_temp28 = (_this30 = possibleConstructorReturn(this, _MaterialComponent29.call.apply(_MaterialComponent29, [this].concat(args))), _this30), _this30.component = 'tabs__panel', _this30.nodeName = 'section', _temp28), possibleConstructorReturn(_this30, _ret28);
  	}

  	return TabPanel;
  }(MaterialComponent);

  extend(Tabs, {
  	TabBar: TabBar,
  	Bar: TabBar,
  	Tab: Tab,
  	TabPanel: TabPanel,
  	Panel: TabPanel
  });

  var MegaFooter = function (_MaterialComponent30) {
  	inherits(MegaFooter, _MaterialComponent30);

  	function MegaFooter() {
  		var _temp29, _this31, _ret29;

  		classCallCheck(this, MegaFooter);

  		for (var _len30 = arguments.length, args = Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
  			args[_key30] = arguments[_key30];
  		}

  		return _ret29 = (_temp29 = (_this31 = possibleConstructorReturn(this, _MaterialComponent30.call.apply(_MaterialComponent30, [this].concat(args))), _this31), _this31.component = 'mega-footer', _this31.nodeName = 'footer', _temp29), possibleConstructorReturn(_this31, _ret29);
  	}

  	return MegaFooter;
  }(MaterialComponent);

  var MegaFooterMiddleSection = function (_MaterialComponent31) {
  	inherits(MegaFooterMiddleSection, _MaterialComponent31);

  	function MegaFooterMiddleSection() {
  		var _temp30, _this32, _ret30;

  		classCallCheck(this, MegaFooterMiddleSection);

  		for (var _len31 = arguments.length, args = Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
  			args[_key31] = arguments[_key31];
  		}

  		return _ret30 = (_temp30 = (_this32 = possibleConstructorReturn(this, _MaterialComponent31.call.apply(_MaterialComponent31, [this].concat(args))), _this32), _this32.component = 'mega-footer__middle-section', _temp30), possibleConstructorReturn(_this32, _ret30);
  	}

  	return MegaFooterMiddleSection;
  }(MaterialComponent);

  var MegaFooterDropDownSection = function (_MaterialComponent32) {
  	inherits(MegaFooterDropDownSection, _MaterialComponent32);

  	function MegaFooterDropDownSection() {
  		var _temp31, _this33, _ret31;

  		classCallCheck(this, MegaFooterDropDownSection);

  		for (var _len32 = arguments.length, args = Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
  			args[_key32] = arguments[_key32];
  		}

  		return _ret31 = (_temp31 = (_this33 = possibleConstructorReturn(this, _MaterialComponent32.call.apply(_MaterialComponent32, [this].concat(args))), _this33), _this33.component = 'mega-footer__drop-down-section', _temp31), possibleConstructorReturn(_this33, _ret31);
  	}

  	return MegaFooterDropDownSection;
  }(MaterialComponent);

  var MegaFooterHeading = function (_MaterialComponent33) {
  	inherits(MegaFooterHeading, _MaterialComponent33);

  	function MegaFooterHeading() {
  		var _temp32, _this34, _ret32;

  		classCallCheck(this, MegaFooterHeading);

  		for (var _len33 = arguments.length, args = Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
  			args[_key33] = arguments[_key33];
  		}

  		return _ret32 = (_temp32 = (_this34 = possibleConstructorReturn(this, _MaterialComponent33.call.apply(_MaterialComponent33, [this].concat(args))), _this34), _this34.component = 'mega-footer__heading', _this34.nodeName = 'h1', _temp32), possibleConstructorReturn(_this34, _ret32);
  	}

  	return MegaFooterHeading;
  }(MaterialComponent);

  var MegaFooterLinkList = function (_MaterialComponent34) {
  	inherits(MegaFooterLinkList, _MaterialComponent34);

  	function MegaFooterLinkList() {
  		var _temp33, _this35, _ret33;

  		classCallCheck(this, MegaFooterLinkList);

  		for (var _len34 = arguments.length, args = Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
  			args[_key34] = arguments[_key34];
  		}

  		return _ret33 = (_temp33 = (_this35 = possibleConstructorReturn(this, _MaterialComponent34.call.apply(_MaterialComponent34, [this].concat(args))), _this35), _this35.component = 'mega-footer__link-list', _this35.nodeName = 'ul', _temp33), possibleConstructorReturn(_this35, _ret33);
  	}

  	return MegaFooterLinkList;
  }(MaterialComponent);

  var MegaFooterBottomSection = function (_MaterialComponent35) {
  	inherits(MegaFooterBottomSection, _MaterialComponent35);

  	function MegaFooterBottomSection() {
  		var _temp34, _this36, _ret34;

  		classCallCheck(this, MegaFooterBottomSection);

  		for (var _len35 = arguments.length, args = Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
  			args[_key35] = arguments[_key35];
  		}

  		return _ret34 = (_temp34 = (_this36 = possibleConstructorReturn(this, _MaterialComponent35.call.apply(_MaterialComponent35, [this].concat(args))), _this36), _this36.component = 'mega-footer__bottom-section', _temp34), possibleConstructorReturn(_this36, _ret34);
  	}

  	return MegaFooterBottomSection;
  }(MaterialComponent);

  extend(MegaFooter, {
  	MiddleSection: MegaFooterMiddleSection,
  	DropDownSection: MegaFooterDropDownSection,
  	Heading: MegaFooterHeading,
  	LinkList: MegaFooterLinkList,
  	BottomSection: MegaFooterBottomSection
  });

  var MiniFooter = function (_MaterialComponent36) {
  	inherits(MiniFooter, _MaterialComponent36);

  	function MiniFooter() {
  		var _temp35, _this37, _ret35;

  		classCallCheck(this, MiniFooter);

  		for (var _len36 = arguments.length, args = Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
  			args[_key36] = arguments[_key36];
  		}

  		return _ret35 = (_temp35 = (_this37 = possibleConstructorReturn(this, _MaterialComponent36.call.apply(_MaterialComponent36, [this].concat(args))), _this37), _this37.component = 'mini-footer', _this37.nodeName = 'footer', _temp35), possibleConstructorReturn(_this37, _ret35);
  	}

  	return MiniFooter;
  }(MaterialComponent);

  var MiniFooterLeftSection = function (_MaterialComponent37) {
  	inherits(MiniFooterLeftSection, _MaterialComponent37);

  	function MiniFooterLeftSection() {
  		var _temp36, _this38, _ret36;

  		classCallCheck(this, MiniFooterLeftSection);

  		for (var _len37 = arguments.length, args = Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
  			args[_key37] = arguments[_key37];
  		}

  		return _ret36 = (_temp36 = (_this38 = possibleConstructorReturn(this, _MaterialComponent37.call.apply(_MaterialComponent37, [this].concat(args))), _this38), _this38.component = 'mini-footer__left-section', _temp36), possibleConstructorReturn(_this38, _ret36);
  	}

  	return MiniFooterLeftSection;
  }(MaterialComponent);

  var MiniFooterLinkList = function (_MaterialComponent38) {
  	inherits(MiniFooterLinkList, _MaterialComponent38);

  	function MiniFooterLinkList() {
  		var _temp37, _this39, _ret37;

  		classCallCheck(this, MiniFooterLinkList);

  		for (var _len38 = arguments.length, args = Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
  			args[_key38] = arguments[_key38];
  		}

  		return _ret37 = (_temp37 = (_this39 = possibleConstructorReturn(this, _MaterialComponent38.call.apply(_MaterialComponent38, [this].concat(args))), _this39), _this39.component = 'mini-footer__link-list', _this39.nodeName = 'ul', _temp37), possibleConstructorReturn(_this39, _ret37);
  	}

  	return MiniFooterLinkList;
  }(MaterialComponent);

  extend(MiniFooter, {
  	LeftSection: MiniFooterLeftSection,
  	LinkList: MiniFooterLinkList
  });

  var Grid = function (_MaterialComponent39) {
  	inherits(Grid, _MaterialComponent39);

  	function Grid() {
  		var _temp38, _this40, _ret38;

  		classCallCheck(this, Grid);

  		for (var _len39 = arguments.length, args = Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
  			args[_key39] = arguments[_key39];
  		}

  		return _ret38 = (_temp38 = (_this40 = possibleConstructorReturn(this, _MaterialComponent39.call.apply(_MaterialComponent39, [this].concat(args))), _this40), _this40.component = 'grid', _temp38), possibleConstructorReturn(_this40, _ret38);
  	}

  	return Grid;
  }(MaterialComponent);

  var Cell = function (_MaterialComponent40) {
  	inherits(Cell, _MaterialComponent40);

  	function Cell() {
  		var _temp39, _this41, _ret39;

  		classCallCheck(this, Cell);

  		for (var _len40 = arguments.length, args = Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
  			args[_key40] = arguments[_key40];
  		}

  		return _ret39 = (_temp39 = (_this41 = possibleConstructorReturn(this, _MaterialComponent40.call.apply(_MaterialComponent40, [this].concat(args))), _this41), _this41.component = 'cell', _temp39), possibleConstructorReturn(_this41, _ret39);
  	}

  	return Cell;
  }(MaterialComponent);

  Grid.Cell = Cell;

  var Progress = function (_MaterialComponent41) {
  	inherits(Progress, _MaterialComponent41);

  	function Progress() {
  		var _temp40, _this42, _ret40;

  		classCallCheck(this, Progress);

  		for (var _len41 = arguments.length, args = Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
  			args[_key41] = arguments[_key41];
  		}

  		return _ret40 = (_temp40 = (_this42 = possibleConstructorReturn(this, _MaterialComponent41.call.apply(_MaterialComponent41, [this].concat(args))), _this42), _this42.component = 'progress', _this42.js = true, _temp40), possibleConstructorReturn(_this42, _ret40);
  	}

  	Progress.prototype.mdlRender = function mdlRender(props) {
  		return preact.h(
  			'div',
  			props,
  			preact.h('div', { 'class': 'progressbar bar bar1' }),
  			preact.h('div', { 'class': 'bufferbar bar bar2' }),
  			preact.h('div', { 'class': 'auxbar bar bar3' })
  		);
  	};

  	Progress.prototype.componentDidUpdate = function componentDidUpdate() {
  		var api = this.base.MaterialProgress,
  		    p = this.props;
  		if (p.progress) api.setProgress(p.progress);
  		if (p.buffer) api.setBuffer(p.buffer);
  	};

  	return Progress;
  }(MaterialComponent);

  var Spinner = function (_MaterialComponent42) {
  	inherits(Spinner, _MaterialComponent42);

  	function Spinner() {
  		var _temp41, _this43, _ret41;

  		classCallCheck(this, Spinner);

  		for (var _len42 = arguments.length, args = Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
  			args[_key42] = arguments[_key42];
  		}

  		return _ret41 = (_temp41 = (_this43 = possibleConstructorReturn(this, _MaterialComponent42.call.apply(_MaterialComponent42, [this].concat(args))), _this43), _this43.component = 'spinner', _this43.js = true, _temp41), possibleConstructorReturn(_this43, _ret41);
  	}

  	return Spinner;
  }(MaterialComponent);

  var Menu = function (_MaterialComponent43) {
  	inherits(Menu, _MaterialComponent43);

  	function Menu() {
  		var _temp42, _this44, _ret42;

  		classCallCheck(this, Menu);

  		for (var _len43 = arguments.length, args = Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
  			args[_key43] = arguments[_key43];
  		}

  		return _ret42 = (_temp42 = (_this44 = possibleConstructorReturn(this, _MaterialComponent43.call.apply(_MaterialComponent43, [this].concat(args))), _this44), _this44.component = 'menu', _this44.nodeName = 'ul', _this44.js = true, _this44.ripple = true, _temp42), possibleConstructorReturn(_this44, _ret42);
  	}

  	return Menu;
  }(MaterialComponent);

  var MenuItem = function (_MaterialComponent44) {
  	inherits(MenuItem, _MaterialComponent44);

  	function MenuItem() {
  		var _temp43, _this45, _ret43;

  		classCallCheck(this, MenuItem);

  		for (var _len44 = arguments.length, args = Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
  			args[_key44] = arguments[_key44];
  		}

  		return _ret43 = (_temp43 = (_this45 = possibleConstructorReturn(this, _MaterialComponent44.call.apply(_MaterialComponent44, [this].concat(args))), _this45), _this45.component = 'menu__item', _this45.nodeName = 'li', _temp43), possibleConstructorReturn(_this45, _ret43);
  	}

  	return MenuItem;
  }(MaterialComponent);

  Menu.Item = MenuItem;

  var Slider = function (_MaterialComponent45) {
  	inherits(Slider, _MaterialComponent45);

  	function Slider() {
  		var _temp44, _this46, _ret44;

  		classCallCheck(this, Slider);

  		for (var _len45 = arguments.length, args = Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
  			args[_key45] = arguments[_key45];
  		}

  		return _ret44 = (_temp44 = (_this46 = possibleConstructorReturn(this, _MaterialComponent45.call.apply(_MaterialComponent45, [this].concat(args))), _this46), _this46.component = 'slider', _this46.js = true, _temp44), possibleConstructorReturn(_this46, _ret44);
  	}

  	Slider.prototype.mdlRender = function mdlRender(props) {
  		return preact.h('input', _extends({ type: 'range', tabindex: '0' }, props));
  	};

  	return Slider;
  }(MaterialComponent);

  var Snackbar = function (_MaterialComponent46) {
  	inherits(Snackbar, _MaterialComponent46);

  	function Snackbar() {
  		var _temp45, _this47, _ret45;

  		classCallCheck(this, Snackbar);

  		for (var _len46 = arguments.length, args = Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
  			args[_key46] = arguments[_key46];
  		}

  		return _ret45 = (_temp45 = (_this47 = possibleConstructorReturn(this, _MaterialComponent46.call.apply(_MaterialComponent46, [this].concat(args))), _this47), _this47.component = 'snackbar', _this47.js = true, _temp45), possibleConstructorReturn(_this47, _ret45);
  	}

  	Snackbar.prototype.mdlRender = function mdlRender(props) {
  		return preact.h(
  			'div',
  			props,
  			preact.h(
  				'div',
  				{ 'class': 'mdl-snackbar__text' },
  				props.children
  			),
  			preact.h('button', { 'class': 'mdl-snackbar__action', type: 'button' })
  		);
  	};

  	return Snackbar;
  }(MaterialComponent);

  var CheckBox = function (_MaterialComponent47) {
  	inherits(CheckBox, _MaterialComponent47);

  	function CheckBox() {
  		var _temp46, _this48, _ret46;

  		classCallCheck(this, CheckBox);

  		for (var _len47 = arguments.length, args = Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
  			args[_key47] = arguments[_key47];
  		}

  		return _ret46 = (_temp46 = (_this48 = possibleConstructorReturn(this, _MaterialComponent47.call.apply(_MaterialComponent47, [this].concat(args))), _this48), _this48.component = 'checkbox', _this48.js = true, _this48.ripple = true, _temp46), possibleConstructorReturn(_this48, _ret46);
  	}

  	CheckBox.prototype.getValue = function getValue() {
  		return this.base.children[0].checked;
  	};

  	CheckBox.prototype.mdlRender = function mdlRender(props) {
  		var evt = {};
  		for (var i in props) {
  			if (i.match(/^on[a-z]+$/gi)) {
  				evt[i] = props[i];
  				delete props[i];
  			}
  		}return preact.h(
  			'label',
  			props,
  			preact.h('input', _extends({ type: 'checkbox', 'class': 'mdl-checkbox__input', checked: props.checked, disabled: props.disabled }, evt)),
  			preact.h(
  				'span',
  				{ 'class': 'mdl-checkbox__label' },
  				props.children
  			),
  			preact.h('span', { 'class': 'mdl-checkbox__focus-helper' }),
  			preact.h(
  				'span',
  				{ 'class': 'mdl-checkbox__box-outline' },
  				preact.h('span', { 'class': 'mdl-checkbox__tick-outline' })
  			)
  		);
  	};

  	return CheckBox;
  }(MaterialComponent);

  var Radio = function (_MaterialComponent48) {
  	inherits(Radio, _MaterialComponent48);

  	function Radio() {
  		var _temp47, _this49, _ret47;

  		classCallCheck(this, Radio);

  		for (var _len48 = arguments.length, args = Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
  			args[_key48] = arguments[_key48];
  		}

  		return _ret47 = (_temp47 = (_this49 = possibleConstructorReturn(this, _MaterialComponent48.call.apply(_MaterialComponent48, [this].concat(args))), _this49), _this49.component = 'radio', _this49.js = true, _this49.ripple = true, _temp47), possibleConstructorReturn(_this49, _ret47);
  	}

  	Radio.prototype.getValue = function getValue() {
  		return this.base.children[0].checked;
  	};

  	Radio.prototype.mdlRender = function mdlRender(props) {
  		return preact.h(
  			'label',
  			props,
  			preact.h('input', { type: 'radio', 'class': 'mdl-radio__button', name: props.name, value: props.value, checked: props.checked, disabled: props.disabled }),
  			preact.h(
  				'span',
  				{ 'class': 'mdl-radio__label' },
  				props.children
  			)
  		);
  	};

  	return Radio;
  }(MaterialComponent);

  var IconToggle = function (_MaterialComponent49) {
  	inherits(IconToggle, _MaterialComponent49);

  	function IconToggle() {
  		var _temp48, _this50, _ret48;

  		classCallCheck(this, IconToggle);

  		for (var _len49 = arguments.length, args = Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
  			args[_key49] = arguments[_key49];
  		}

  		return _ret48 = (_temp48 = (_this50 = possibleConstructorReturn(this, _MaterialComponent49.call.apply(_MaterialComponent49, [this].concat(args))), _this50), _this50.component = 'icon-toggle', _this50.js = true, _this50.ripple = true, _temp48), possibleConstructorReturn(_this50, _ret48);
  	}

  	IconToggle.prototype.getValue = function getValue() {
  		return this.base.children[0].checked;
  	};

  	IconToggle.prototype.mdlRender = function mdlRender(props) {
  		return preact.h(
  			'label',
  			props,
  			preact.h('input', { type: 'checkbox', 'class': 'mdl-icon-toggle__input', checked: props.checked, disabled: props.disabled }),
  			preact.h(
  				'span',
  				{ 'class': 'mdl-icon-toggle__label material-icons' },
  				props.children
  			)
  		);
  	};

  	return IconToggle;
  }(MaterialComponent);

  var Switch = function (_MaterialComponent50) {
  	inherits(Switch, _MaterialComponent50);

  	function Switch() {
  		var _temp49, _this51, _ret49;

  		classCallCheck(this, Switch);

  		for (var _len50 = arguments.length, args = Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
  			args[_key50] = arguments[_key50];
  		}

  		return _ret49 = (_temp49 = (_this51 = possibleConstructorReturn(this, _MaterialComponent50.call.apply(_MaterialComponent50, [this].concat(args))), _this51), _this51.component = 'switch', _this51.nodeName = 'label', _this51.js = true, _this51.ripple = true, _temp49), possibleConstructorReturn(_this51, _ret49);
  	}

  	Switch.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref6) {
  		var checked = _ref6.checked;

  		if (Boolean(checked) === Boolean(this.props.checked)) return false;
  		return true;
  	};

  	Switch.prototype.getValue = function getValue() {
  		return this.base.children[0].checked;
  	};

  	Switch.prototype.mdlRender = function mdlRender(_ref7) {
  		var props = objectWithoutProperties(_ref7, []);

  		var evt = {};
  		for (var i in props) {
  			if (i.match(/^on[a-z]+$/gi)) {
  				evt[i] = props[i];
  				delete props[i];
  			}
  		}return preact.h(
  			'label',
  			props,
  			preact.h('input', _extends({ type: 'checkbox', 'class': 'mdl-switch__input', checked: props.checked, disabled: props.disabled }, evt)),
  			preact.h(
  				'span',
  				{ 'class': 'mdl-switch__label' },
  				props.children
  			),
  			preact.h('div', { 'class': 'mdl-switch__track' }),
  			preact.h(
  				'div',
  				{ 'class': 'mdl-switch__thumb' },
  				preact.h('span', { 'class': 'mdl-switch__focus-helper' })
  			)
  		);
  	};

  	return Switch;
  }(MaterialComponent);

  var Table = function (_MaterialComponent51) {
  	inherits(Table, _MaterialComponent51);

  	function Table() {
  		var _temp50, _this52, _ret50;

  		classCallCheck(this, Table);

  		for (var _len51 = arguments.length, args = Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
  			args[_key51] = arguments[_key51];
  		}

  		return _ret50 = (_temp50 = (_this52 = possibleConstructorReturn(this, _MaterialComponent51.call.apply(_MaterialComponent51, [this].concat(args))), _this52), _this52.component = 'data-table', _this52.nodeName = 'table', _this52.js = true, _temp50), possibleConstructorReturn(_this52, _ret50);
  	}

  	return Table;
  }(MaterialComponent);

  var TableCell = function (_MaterialComponent52) {
  	inherits(TableCell, _MaterialComponent52);

  	function TableCell() {
  		var _temp51, _this53, _ret51;

  		classCallCheck(this, TableCell);

  		for (var _len52 = arguments.length, args = Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
  			args[_key52] = arguments[_key52];
  		}

  		return _ret51 = (_temp51 = (_this53 = possibleConstructorReturn(this, _MaterialComponent52.call.apply(_MaterialComponent52, [this].concat(args))), _this53), _this53.component = 'data-table__cell', _this53.nodeName = 'td', _temp51), possibleConstructorReturn(_this53, _ret51);
  	}

  	return TableCell;
  }(MaterialComponent);

  Table.Cell = TableCell;

  var List = function (_MaterialComponent53) {
  	inherits(List, _MaterialComponent53);

  	function List() {
  		var _temp52, _this54, _ret52;

  		classCallCheck(this, List);

  		for (var _len53 = arguments.length, args = Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
  			args[_key53] = arguments[_key53];
  		}

  		return _ret52 = (_temp52 = (_this54 = possibleConstructorReturn(this, _MaterialComponent53.call.apply(_MaterialComponent53, [this].concat(args))), _this54), _this54.component = 'list', _this54.nodeName = 'ul', _temp52), possibleConstructorReturn(_this54, _ret52);
  	}

  	return List;
  }(MaterialComponent);

  var ListItem = function (_MaterialComponent54) {
  	inherits(ListItem, _MaterialComponent54);

  	function ListItem() {
  		var _temp53, _this55, _ret53;

  		classCallCheck(this, ListItem);

  		for (var _len54 = arguments.length, args = Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
  			args[_key54] = arguments[_key54];
  		}

  		return _ret53 = (_temp53 = (_this55 = possibleConstructorReturn(this, _MaterialComponent54.call.apply(_MaterialComponent54, [this].concat(args))), _this55), _this55.component = 'list__item', _this55.nodeName = 'li', _temp53), possibleConstructorReturn(_this55, _ret53);
  	}

  	return ListItem;
  }(MaterialComponent);

  List.Item = ListItem;

  var TextField = function (_MaterialComponent55) {
  	inherits(TextField, _MaterialComponent55);

  	function TextField() {
  		classCallCheck(this, TextField);

  		for (var _len55 = arguments.length, args = Array(_len55), _key55 = 0; _key55 < _len55; _key55++) {
  			args[_key55] = arguments[_key55];
  		}

  		var _this56 = possibleConstructorReturn(this, _MaterialComponent55.call.apply(_MaterialComponent55, [this].concat(args)));

  		_this56.component = 'textfield';
  		_this56.js = true;

  		_this56.id = uid();
  		return _this56;
  	}

  	TextField.prototype.componentDidUpdate = function componentDidUpdate() {
  		var input = this.base && this.base.querySelector && this.base.querySelector('input,textarea');
  		if (input && input.value && input.value !== this.props.value) {
  			input.value = this.props.value;
  		}
  		if (input && input.setCustomValidity) {
  			input.setCustomValidity(this.props.errorMessage || "");
  		}
  	};

  	TextField.prototype.mdlRender = function mdlRender() {
  		var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  		var id = props.id || this.id,
  		    errorMessage = props.errorMessage,
  		    p = extend({}, props);

  		delete p.class;
  		delete p.errorMessage;

  		var field = preact.h(
  			'div',
  			null,
  			preact.h('input', _extends({ type: 'text', 'class': 'mdl-textfield__input', id: id, value: '' }, p)),
  			preact.h(
  				'label',
  				{ 'class': 'mdl-textfield__label', 'for': id },
  				props.label || props.children
  			),
  			errorMessage ? preact.h(
  				'span',
  				{ 'class': 'mdl-textfield__error' },
  				errorMessage
  			) : null
  		);
  		if (props.multiline) {
  			field.children[0].nodeName = 'textarea';
  		}
  		if (props.expandable === true) {
  			(field.attributes = field.attributes || {}).class = 'mdl-textfield__expandable-holder';
  			field = preact.h(
  				'div',
  				null,
  				preact.h(
  					'label',
  					{ 'class': 'mdl-button mdl-js-button mdl-button--icon', 'for': id },
  					preact.h(
  						'i',
  						{ 'class': 'material-icons' },
  						props.icon
  					)
  				),
  				field
  			);
  		}
  		var cl = getClass(props);
  		if (cl) {
  			(field.attributes = field.attributes || {}).class = cl;
  		}

  		return field;
  	};

  	return TextField;
  }(MaterialComponent);

  var Tooltip = function (_MaterialComponent56) {
  	inherits(Tooltip, _MaterialComponent56);

  	function Tooltip() {
  		var _temp54, _this57, _ret54;

  		classCallCheck(this, Tooltip);

  		for (var _len56 = arguments.length, args = Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
  			args[_key56] = arguments[_key56];
  		}

  		return _ret54 = (_temp54 = (_this57 = possibleConstructorReturn(this, _MaterialComponent56.call.apply(_MaterialComponent56, [this].concat(args))), _this57), _this57.component = 'tooltip', _temp54), possibleConstructorReturn(_this57, _ret54);
  	}

  	return Tooltip;
  }(MaterialComponent);

  var index = {
  	options: options,
  	Icon: Icon,
  	Button: Button,
  	Card: Card,
  	Dialog: Dialog,
  	Layout: Layout,
  	Navigation: Navigation,
  	Tabs: Tabs,
  	MegaFooter: MegaFooter,
  	MiniFooter: MiniFooter,
  	Grid: Grid,
  	Cell: Cell,
  	Progress: Progress,
  	Spinner: Spinner,
  	Menu: Menu,
  	Slider: Slider,
  	Snackbar: Snackbar,
  	CheckBox: CheckBox,
  	Radio: Radio,
  	IconToggle: IconToggle,
  	Switch: Switch,
  	Table: Table,
  	TextField: TextField,
  	Tooltip: Tooltip,
  	List: List,
  	ListItem: ListItem
  };

  exports.options = options;
  exports.MaterialComponent = MaterialComponent;
  exports.Icon = Icon;
  exports.Button = Button;
  exports.Card = Card;
  exports.CardTitle = CardTitle;
  exports.CardTitleText = CardTitleText;
  exports.CardMedia = CardMedia;
  exports.CardText = CardText;
  exports.CardActions = CardActions;
  exports.CardMenu = CardMenu;
  exports.Dialog = Dialog;
  exports.DialogTitle = DialogTitle;
  exports.DialogContent = DialogContent;
  exports.DialogActions = DialogActions;
  exports.Layout = Layout;
  exports.LayoutHeader = LayoutHeader;
  exports.LayoutHeaderRow = LayoutHeaderRow;
  exports.LayoutTitle = LayoutTitle;
  exports.LayoutSpacer = LayoutSpacer;
  exports.LayoutDrawer = LayoutDrawer;
  exports.LayoutContent = LayoutContent;
  exports.LayoutTabBar = LayoutTabBar;
  exports.LayoutTab = LayoutTab;
  exports.LayoutTabPanel = LayoutTabPanel;
  exports.Navigation = Navigation;
  exports.NavigationLink = NavigationLink;
  exports.Tabs = Tabs;
  exports.TabBar = TabBar;
  exports.Tab = Tab;
  exports.TabPanel = TabPanel;
  exports.MegaFooter = MegaFooter;
  exports.MegaFooterMiddleSection = MegaFooterMiddleSection;
  exports.MegaFooterDropDownSection = MegaFooterDropDownSection;
  exports.MegaFooterHeading = MegaFooterHeading;
  exports.MegaFooterLinkList = MegaFooterLinkList;
  exports.MegaFooterBottomSection = MegaFooterBottomSection;
  exports.MiniFooter = MiniFooter;
  exports.MiniFooterLeftSection = MiniFooterLeftSection;
  exports.MiniFooterLinkList = MiniFooterLinkList;
  exports.Grid = Grid;
  exports.Cell = Cell;
  exports.Progress = Progress;
  exports.Spinner = Spinner;
  exports.Menu = Menu;
  exports.MenuItem = MenuItem;
  exports.Slider = Slider;
  exports.Snackbar = Snackbar;
  exports.CheckBox = CheckBox;
  exports.Radio = Radio;
  exports.IconToggle = IconToggle;
  exports.Switch = Switch;
  exports.Table = Table;
  exports.TableCell = TableCell;
  exports.List = List;
  exports.ListItem = ListItem;
  exports.TextField = TextField;
  exports.Tooltip = Tooltip;
  exports['default'] = index;

}));
//# sourceMappingURL=preact-mdl.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.off = exports.on = exports.emit = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _mitt = __webpack_require__(9);

var _mitt2 = _interopRequireDefault(_mitt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*global ga*/

var pubsub = (0, _mitt2.default)();
exports.default = pubsub;
var emit = pubsub.emit,
    on = pubsub.on,
    off = pubsub.off;
exports.emit = emit;
exports.on = on;
exports.off = off;


on('track', function (url) {
	var type = 'pageview';
	if (url && (typeof url === 'undefined' ? 'undefined' : _typeof(url)) === 'object') {
		type = url.type;
		url = url.url;
	}
	if (typeof url !== 'string') return;
	if (url.charAt(0) !== '/') url = '/' + url;
	if (typeof ga === 'function') {
		ga('send', type, url);
	}
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.updateConnections = updateConnections;

var _store = __webpack_require__(11);

var _store2 = _interopRequireDefault(_store);

var _peachClient = __webpack_require__(24);

var _peachClient2 = _interopRequireDefault(_peachClient);

var _praline = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var peach = (0, _peachClient2.default)({
	url: "https://api.nectarine.rocks", // Open-Source proxy, see: https://github.com/developit/nectarine-api-proxy (it's 4 lines of code for extreme clarity)
	imgurKey: "546c25a59c58ad7",
	store: _store2.default,
	init: false
});

window.peach = peach;
exports.default = peach;


var updateConnectionsTimer = void 0;
peach.on("login", function () {
	setTimeout(updateConnections, 1);

	clearInterval(updateConnectionsTimer);
	updateConnectionsTimer = setInterval(updateConnections, 60000);
});

var lastUpdate = void 0;
function updateConnections() {
	var now = Date.now();
	if (lastUpdate && now - lastUpdate < 5000) return;
	lastUpdate = now;

	(0, _praline.parallel)([peach.activity, peach.connections], function (err) {
		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$activityItems = _ref.activityItems,
		    activityItems = _ref$activityItems === undefined ? [] : _ref$activityItems;

		var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
		    connections = _ref2.connections,
		    inboundFriendRequests = _ref2.inboundFriendRequests,
		    outboundFriendRequests = _ref2.outboundFriendRequests;

		_store2.default.setState({
			activityItems: activityItems,
			connections: connections,
			inboundFriendRequests: inboundFriendRequests,
			outboundFriendRequests: outboundFriendRequests
		});
	});
}
peach.updateConnections = updateConnections;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = optimisticHttps;
var HTTPS_DOMAINS = /^http:\/\/(s3\.amazonaws\.com|[^/]+\.imgur\.com|[^/]+\.squarespace\.com)(\/|$)/;

function optimisticHttps(url) {
	if (HTTPS_DOMAINS.test(url)) {
		return url.replace('http://', 'https://');
	}
	return url;
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
		c = url.match(reg),
		matches = {},
		ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i=0; i<p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1=0; i$1<max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0)===':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
				flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
				plus = ~flags.indexOf('+'),
				star = ~flags.indexOf('*'),
				val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?')<0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		}
		else if (route[i$1]!==url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default!==true && ret===false) { return false; }
	return matches;
}

function pathRankSort(a, b) {
	return (
		(a.rank < b.rank) ? 1 :
		(a.rank > b.rank) ? -1 :
		(a.index - b.index)
	);
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0)==':' ? (1 + '*+?'.indexOf(segment.charAt(segment.length-1))) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_!=null || typeof Symbol!=='undefined' && node[Symbol.for('preactattr')]!=null;
}

function setUrl(url, type) {
	if ( type === void 0 ) type='push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	}
	else if (typeof history!=='undefined' && history[type+'State']) {
		history[type+'State'](null, null, url);
	}
}


function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	}
	else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	}
	else {
		url = typeof location!=='undefined' ? location : EMPTY;
	}
	return ("" + (url.pathname || '') + (url.search || ''));
}



function route(url, replace) {
	if ( replace === void 0 ) replace=false;

	if (typeof url!=='string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}


/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i=ROUTERS.length; i--; ) {
		if (ROUTERS[i].canRoute(url)) { return true; }
	}
	return false;
}


/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i=0; i<ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url)===true) {
			didRoute = true;
		}
	}
	for (var i$1=subscribers.length; i$1--; ) {
		subscribers[i$1](url);
	}
	return didRoute;
}


function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) { return; }

	var href = node.getAttribute('href'),
		target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || (target && !target.match(/^_?self$/i))) { return; }

	// attempt to route, if no match simply cede control to browser
	return route(href);
}


function handleLinkClick(e) {
	if (e.button==0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}


function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
		if (e.stopPropagation) { e.stopPropagation(); }
		e.preventDefault();
	}
	return false;
}


function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button!==0) { return; }

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase()==='A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) { return; }
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while ((t=t.parentNode));
}


var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) { return; }

	if (typeof addEventListener==='function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}


var Router = (function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if ( Component$$1 ) Router.__proto__ = Component$$1;
	Router.prototype = Object.create( Component$$1 && Component$$1.prototype );
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate (props) {
		if (props.static!==true) { return true; }
		return props.url!==this.props.url || props.onChange!==this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute (url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo (url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) { return this.canRoute(url); }

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount () {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount () {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo(("" + (location.pathname || '') + (location.search || '')));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount () {
		if (typeof this.unlisten==='function') { this.unlisten(); }
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate () {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate () {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren (children, url, invoke) {
		return children
			.filter(prepareVNodeForRanking)
			.sort(pathRankSort)
			.map( function (vnode) {
				var matches = exec(url, vnode.attributes.path, vnode.attributes);
				if (matches) {
					if (invoke !== false) {
						var newProps = { url: url, matches: matches };
						assign(newProps, matches);
						delete newProps.ref;
						delete newProps.key;
						return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
					}
					return vnode;
				}
			}).filter(Boolean);
	};

	Router.prototype.render = function render (ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url!==previous) {
			this.previousUrl = url;
			if (typeof onChange==='function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]));

var Link = function (props) { return (
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props))
); };

var Route = function (props) { return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props); };

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _neatime = __webpack_require__(33);

var _neatime2 = _interopRequireDefault(_neatime);

var _decko = __webpack_require__(1);

var _pubsub = __webpack_require__(3);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _comment = __webpack_require__(34);

var _comment2 = _interopRequireDefault(_comment);

var _renderers = __webpack_require__(14);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var noBubble = function noBubble(e) {
	if (e) e.stopPropagation();
};

var Post = (_class = function (_Component) {
	_inherits(Post, _Component);

	function Post(props) {
		_classCallCheck(this, Post);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = { newComment: '', comments: [] };
		return _this;
	}

	Post.prototype.goAuthor = function goAuthor(e) {
		var _props = this.props,
		    author = _props.author,
		    body = _props.body,
		    id = author && author.id || body && body.authorStream && body.authorStream.id;

		if (id) {
			(0, _pubsub.emit)('go', { url: '/profile/' + encodeURIComponent(id) });
		}
		noBubble(e);
		return false;
	};

	Post.prototype.isLiked = function isLiked() {
		var _props2 = this.props,
		    id = _props2.id,
		    likedByMe = _props2.likedByMe,
		    _peach$store$getState = _peach2.default.store.getState(),
		    localLikes = _peach$store$getState.localLikes;

		return localLikes && localLikes.hasOwnProperty(id) ? localLikes[id] : likedByMe || false;
	};

	Post.prototype.likeCount = function likeCount() {
		var _props3 = this.props,
		    id = _props3.id,
		    likeCount = _props3.likeCount,
		    likedByMe = _props3.likedByMe,
		    _peach$store$getState2 = _peach2.default.store.getState(),
		    localLikes = _peach$store$getState2.localLikes;

		return (likeCount || 0) + (localLikes && localLikes[id] === true && likedByMe !== true ? 1 : 0);
	};

	Post.prototype.toggleLike = function toggleLike(e) {
		var liked = !this.isLiked(),
		    id = this.props.id,
		    _peach$store$getState3 = _peach2.default.store.getState(),
		    _peach$store$getState4 = _peach$store$getState3.localLikes,
		    localLikes = _peach$store$getState4 === undefined ? {} : _peach$store$getState4;

		localLikes[id] = liked;
		_peach2.default.store.setState({ localLikes: localLikes });
		this.setState({ liked: liked });
		_peach2.default[liked ? 'like' : 'unlike'](id, function (err) {
			if (err) alert('Error: ' + err);
		});
		noBubble(e);
	};

	Post.prototype.clickComment = function clickComment(_ref) {
		var author = _ref.author;

		this.setState({
			newComment: '@' + author.name + ' ' + (this.state.newComment || '')
		});
		setTimeout(this.focusCommentField, 50);
	};

	Post.prototype.focusCommentField = function focusCommentField() {
		this.base.querySelector('.post-new-comment textarea').focus();
	};

	Post.prototype.maybeComment = function maybeComment(e) {
		if (e && e.keyCode && e.keyCode === 13) {
			return this.comment(e);
		}
	};

	Post.prototype.comment = function comment(e) {
		var _this2 = this;

		var id = this.props.id,
		    _state = this.state,
		    newComment = _state.newComment,
		    _state$comments = _state.comments,
		    comments = _state$comments === undefined ? [] : _state$comments,
		    author = _peach2.default.store.getState().profile || {};

		if (newComment) {
			// comments.push({ author, body:newComment });
			// this.setState({ newComment: '', comments });
			_peach2.default.comment({
				postId: id,
				body: newComment
			}, function (err, comment) {
				if (err) return alert('Error: ' + err);
				comment.author = author;
				comments.push(comment);
				_this2.setState({ lastCommentedId: id, newComment: '', comments: comments });
			});
		}
		e.preventDefault();
		return false;
	};

	Post.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
		var id = _ref2.id;
		var _state2 = this.state,
		    lastComentedId = _state2.lastComentedId,
		    comments = _state2.comments;

		if (id !== lastComentedId && comments && comments.length) {
			this.setState({ lastComentedId: null, comments: [] });
		}
	};

	Post.prototype.confirmDelete = function confirmDelete() {
		var _this3 = this;

		setTimeout(function () {
			if (confirm('Permanently delete this post?')) _this3.delete();
		}, 200);
	};

	Post.prototype.delete = function _delete() {
		var _this4 = this;

		var id = this.props.id;

		_peach2.default.deletePost(id, function (err) {
			if (err) return alert('Error: ' + err);
			_this4.setState({ deleted: true });
		});
	};

	Post.prototype.openPostMenu = function openPostMenu(e) {
		var menu = this.base.querySelector('.mdl-menu[for="postmenu-' + this.props.id + '"]');
		if (menu) menu.MaterialMenu.toggle();
		return noBubble(e), false;
	};

	Post.prototype.render = function render(_ref3, _ref4) {
		var _this5 = this;

		var id = _ref3.id,
		    _ref3$comment = _ref3.comment,
		    comment = _ref3$comment === undefined ? true : _ref3$comment,
		    _ref3$minimal = _ref3.minimal,
		    minimal = _ref3$minimal === undefined ? false : _ref3$minimal,
		    type = _ref3.type,
		    body = _ref3.body,
		    message = _ref3.message,
		    _ref3$comments = _ref3.comments,
		    comments = _ref3$comments === undefined ? [] : _ref3$comments,
		    author = _ref3.author,
		    authorId = _ref3.authorId,
		    createdTime = _ref3.createdTime;
		var newComment = _ref4.newComment,
		    stateComments = _ref4.comments,
		    deleted = _ref4.deleted;

		if (deleted === true) return (0, _preact.h)('div', { 'class': 'post post-deleted' });

		author = author || body && body.authorStream;
		var avatar = author && author.avatarSrc,
		    isLiked = this.isLiked(),
		    likeCount = this.likeCount(),
		    isOwn = !author && !authorId || (authorId || author.id) === _peach2.default.store.getState().profile.id;

		if (stateComments) {
			var commentIds = comments.map(function (c) {
				return c.id;
			});
			comments = comments.concat(stateComments.filter(function (c) {
				return commentIds.indexOf(c.id) < 0;
			}));
		}
		if (!message || !message[0]) {
			message = body && body.message || body;
		}
		if (!message) message = [];
		if (!Array.isArray(message)) {
			message = [message];
		}
		for (var i = message.length; i--;) {
			if (typeof message[i] === 'string') {
				message[i] = { type: 'text', text: message[i] };
			}
			if (!message[i].type) {
				message[i].type = type;
			}
		}

		if (minimal) return (0, _preact.h)(
			'div',
			{ 'class': 'post type-' + type, minimal: minimal || null, 'has-avatar': !!author || null, 'is-own': isOwn || null },
			author ? (0, _preact.h)('div', { 'class': 'avatar', onClick: this.goAuthor, style: avatar && 'background-image: url(' + (0, _optimisticHttps2.default)(avatar) + ');' }) : null,
			(0, _preact.h)(
				'div',
				{ 'class': 'post-meta' },
				(0, _preact.h)(
					'span',
					{ 'class': 'post-time' },
					(0, _neatime2.default)(createdTime * 1000)
				)
			),
			(0, _preact.h)(
				'div',
				{ 'class': 'items' },
				message.map(_renderers.renderItem)
			)
		);

		return (0, _preact.h)(
			'div',
			{ 'class': 'post type-' + type, 'has-avatar': !!author || null, 'is-own': isOwn || null },
			(0, _preact.h)('div', { 'class': 'avatar', onClick: this.goAuthor, style: author ? 'background-image: url(' + (0, _optimisticHttps2.default)(avatar) + ');' : null }),
			(0, _preact.h)(
				'div',
				{ 'class': 'post-meta' },
				(0, _preact.h)(
					'span',
					{ 'class': 'post-time' },
					(0, _neatime2.default)(createdTime * 1000)
				),
				isOwn ? (0, _preact.h)(
					'span',
					{ 'class': 'post-menu-wrap' },
					(0, _preact.h)(
						_preactMdl.Button,
						{ id: 'postmenu-' + id, 'class': 'post-menu', onClick: this.openPostMenu, icon: true },
						(0, _preact.h)(_preactMdl.Icon, { icon: 'more vert' })
					),
					(0, _preact.h)(
						_preactMdl.Menu,
						{ 'bottom-right': true, 'for': 'postmenu-' + id },
						(0, _preact.h)(
							_preactMdl.Menu.Item,
							{ onClick: this.confirmDelete },
							'Delete'
						)
					)
				) : null,
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true, 'class': 'like-unlike', 'is-liked': isLiked || null, onClick: this.toggleLike },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'favorite', badge: likeCount || null })
				)
			),
			(0, _preact.h)(
				'div',
				{ 'class': 'items' },
				message.map(_renderers.renderItem)
			),
			comment !== false ? (0, _preact.h)(
				'div',
				{ 'class': 'comments', onClick: noBubble, onTouchStart: noBubble, onMouseDown: noBubble },
				comments && comments.length ? comments.map(function (comment) {
					return (0, _preact.h)(_comment2.default, _extends({
						allowDelete: isOwn,
						onClick: _this5.clickComment
					}, comment));
				}) : null
			) : null,
			comment !== false ? (0, _preact.h)(
				'div',
				{ 'class': 'post-new-comment', onClick: noBubble },
				(0, _preact.h)(_preactMdl.TextField, { multiline: true, placeholder: 'Witty remark', value: newComment || '', onInput: this.linkState('newComment'), onKeyDown: this.maybeComment }),
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true, onClick: this.comment },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'send' })
				)
			) : null
		);
	};

	return Post;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'goAuthor', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'goAuthor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleLike', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'toggleLike'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clickComment', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'clickComment'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'focusCommentField', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'focusCommentField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'maybeComment', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'maybeComment'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'comment', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'comment'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'confirmDelete', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'confirmDelete'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openPostMenu', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'openPostMenu'), _class.prototype)), _class);
exports.default = Post;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingScreen = function (_Component) {
	_inherits(LoadingScreen, _Component);

	function LoadingScreen() {
		_classCallCheck(this, LoadingScreen);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	LoadingScreen.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
		var overlay = _ref.overlay;

		return overlay !== this.overlay;
	};

	LoadingScreen.prototype.render = function render(_ref2) {
		var _ref2$overlay = _ref2.overlay,
		    overlay = _ref2$overlay === undefined ? true : _ref2$overlay;

		this.overlay = overlay;
		return (0, _preact.h)(
			'div',
			{ 'class': 'loading', overlay: overlay || null },
			(0, _preact.h)(_preactMdl.Spinner, { 'is-active': true, 'single-color': true })
		);
	};

	return LoadingScreen;
}(_preact.Component);

exports.default = LoadingScreen;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//      
// An event handler can take an optional event argument
// and should not return a value
                                          
                                                               

// An array of all currently registered event handlers for a type
                                            
                                                            
// A map of event types and their corresponding event handlers.
                        
                                 
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberOf mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).slice().map(function (handler) { handler(evt); });
			(all['*'] || []).slice().map(function (handler) { handler(type, evt); });
		}
	};
}

/* harmony default export */ __webpack_exports__["default"] = (mitt);
//# sourceMappingURL=mitt.es.js.map


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.__esModule = true;exports.parallel = parallel;exports.sequence = sequence;function parallel(funcs,callback){var c=funcs.length;if(!c)return callback(null);var results=[];var done=function done(){if(callback)callback.apply(undefined,arguments);callback = null;};funcs.forEach(function(func,i){var args=[];if(Array.isArray(func)){args = func.slice();func = args.shift();}args.push(function(err,data){if(err)return done(err);results[i] = data;if(! --c)done.apply(undefined,[null].concat(results));});func.apply(undefined,args);});}function sequence(funcs,callback){var i=0;var c=funcs.length;if(!c)return callback(null);var results=[];var next=function next(){var func=funcs[i++];var args=[];if(Array.isArray(func)){args = func.slice();func = args.shift();}args.push(function(err,data){if(err)return callback(err);results[i - 1] = data;if(i < c)next();else callback.apply(undefined,[null].concat(results));});func.apply(undefined,args);};next();}exports["default"] = function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key < _len;_key++) {args[_key] = arguments[_key];}if(args.length === 2)return parallel.apply(undefined,args);sequence.apply(undefined,args.slice(1));};
//# sourceMappingURL=praline.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _decko = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORE_ID = 'peach-client';

var store = (0, _store2.default)();

// populate from localStorage
try {
	store.setState(JSON.parse(localStorage.getItem(STORE_ID)) || {});
} catch (e) {}

// save to localStorage after writes
store.subscribe((0, _decko.debounce)(500, function (data) {
	try {
		localStorage.setItem(STORE_ID, JSON.stringify(data));
	} catch (err) {
		console.error(err);
	}
}));

exports.default = store;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mitt = __webpack_require__(9);

var _mitt2 = _interopRequireDefault(_mitt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	var self = (0, _mitt2.default)();

	self.data = {};

	self.subscribe = function (fn) {
		self.on('change', fn);
	};

	self.unsubscribe = function (fn) {
		self.off('change', fn);
	};

	self.getState = function () {
		return self.data;
	};

	self.setState = function (state) {
		for (var i in state) {
			if (state.hasOwnProperty(i)) {
				self.data[i] = state[i];
			}
		}self.emit('change', self.data);
	};

	return self;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(global,factory){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports,module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if(typeof exports !== 'undefined' && typeof module !== 'undefined'){factory(exports,module);}else {var mod={exports:{}};factory(mod.exports,mod);global.index = mod.exports;}})(this,function(exports,module){'use strict';module.exports = chooseFiles;function chooseFiles(opts,callback){if(typeof opts === 'function'){var _ref=[callback,opts];opts = _ref[0];callback = _ref[1];}var input=document.createElement('input');input.style.cssText = 'position:absolute;left:0;top:-999em;';input.type = 'file';input.multiple = true;if(opts){for(var i in opts) {if(opts.hasOwnProperty(i)){input[i] = opts[i];}}}document.body.appendChild(input);var done=function done(){if(!callback)return;callback([].slice.call(input.files || []));document.body.removeChild(input);callback = input = null;};input.addEventListener('change',done);addEventListener('focus',function(){return setTimeout(done,1000);});input.click();}});
//# sourceMappingURL=index.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.renderer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderItem = renderItem;

var _preact = __webpack_require__(0);

var _decko = __webpack_require__(1);

var _parseMessage = __webpack_require__(15);

var _parseMessage2 = _interopRequireDefault(_parseMessage);

var _imageViewer = __webpack_require__(35);

var _imageViewer2 = _interopRequireDefault(_imageViewer);

var _videoPlayer = __webpack_require__(36);

var _videoPlayer2 = _interopRequireDefault(_videoPlayer);

var _musicPlayer = __webpack_require__(37);

var _musicPlayer2 = _interopRequireDefault(_musicPlayer);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function renderItem(item) {
	var fn = renderer(item.type);
	if (!fn) {
		if (Object.keys(item).length > 0) {
			console.warn('Unknown type: ' + item.type, item);
		}
		return null;
	}
	return (0, _preact.h)(
		'div',
		{ 'class': 'item item-' + item.type },
		fn(item)
	);
}

// get the corresponding render method for a given item type
var renderer = exports.renderer = (0, _decko.memoize)(function (type) {
	return RENDERERS[String(type).toLowerCase()];
});

var EMPTY = {};

var RENDERERS = {
	image: function image(props) {
		return (0, _preact.h)(_imageViewer2.default, props);
	},

	gif: function gif(props) {
		return (0, _preact.h)(_imageViewer2.default, props);
	},

	video: function video(props) {
		return (0, _preact.h)(_videoPlayer2.default, props);
	},

	text: function text(_ref) {
		var _text = _ref.text;
		return (0, _preact.h)(
			'p',
			null,
			(0, _parseMessage2.default)(_text) || ' '
		);
	},

	mention: function mention(props) {
		return RENDERERS.comment(_extends({
			commentBody: (props.author || props.authorStream || EMPTY).displayName + ' mentioned you'
		}, props));
	},

	tag: function tag(props) {
		return RENDERERS.comment(_extends({
			commentBody: (props.author || props.authorStream || EMPTY).displayName + ' tagged you'
		}, props));
	},

	comment: function comment(_ref2) {
		var type = _ref2.type,
		    commentBody = _ref2.commentBody,
		    postMessage = _ref2.postMessage,
		    author = _ref2.author,
		    authorStream = _ref2.authorStream,
		    postID = _ref2.postID;

		author = author || authorStream || EMPTY;
		return (0, _preact.h)(
			'div',
			{ 'class': 'comment-block comment-type-' + type },
			renderItem(postMessage && postMessage[0] || EMPTY),
			(0, _preact.h)(
				'div',
				{ 'class': 'comment' },
				renderer('text')({ text: commentBody }),
				(0, _preact.h)(
					'author',
					{ title: author.name },
					author.displayName || null
				)
			)
		);
	},

	like: function like(_ref3) {
		var postMessage = _ref3.postMessage,
		    authorStream = _ref3.authorStream,
		    postID = _ref3.postID;
		return (0, _preact.h)(
			'div',
			{ 'class': 'like-block' },
			renderItem(postMessage[0]),
			(0, _preact.h)(
				'div',
				{ 'class': 'like' },
				authorStream.displayName,
				' liked this'
			)
		);
	},

	link: function link(_ref4) {
		var title = _ref4.title,
		    description = _ref4.description,
		    url = _ref4.url,
		    imageURL = _ref4.imageURL;
		return (0, _preact.h)(
			'div',
			{ 'class': 'item-link' },
			(0, _preact.h)(
				'a',
				{ href: url, target: '_blank' },
				title
			),
			(0, _preact.h)(
				'p',
				null,
				description
			),
			(0, _preact.h)('img', { src: (0, _optimisticHttps2.default)(imageURL) })
		);
	},

	music: function music(props) {
		return (0, _preact.h)(_musicPlayer2.default, props);
	},

	location: function location(_ref5) {
		var name = _ref5.name,
		    iconSrc = _ref5.iconSrc,
		    lat = _ref5.lat,
		    long = _ref5.long,
		    props = _objectWithoutProperties(_ref5, ['name', 'iconSrc', 'lat', 'long']);

		return (0, _preact.h)(
			'a',
			{ href: 'https://www.google.com/maps/place/' + encodeURIComponent(name) + '/@' + encodeURIComponent(lat) + ',' + encodeURIComponent(long) + ',17z/', target: '_blank', style: 'display:block;' },
			iconSrc ? (0, _preact.h)('img', { src: (0, _optimisticHttps2.default)(iconSrc), width: '26', height: '26', style: 'float:left; background:#CCC; border-radius:50%;' }) : null,
			(0, _preact.h)(
				'div',
				{ style: 'overflow:hidden; padding:5px;' },
				name
			)
		);
	}
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__(0);

var _decko = __webpack_require__(1);

var WEB_LINK = /\b(https?\:\/\/.+|([a-z0-9-]+\.)*([a-z0-9-]{2,})\.[a-z]{2,6}\b)/i;

var WEB_LINK_TAIL = /[.,\)\]!"'\s]+$/i;

var NO_MATCH = [''];

/** Parse a text message into HTML returned as JSX */
exports.default = (0, _decko.memoize)(function (text) {
	var parts = text.split(/\s/),
	    built = [];
	for (var index = 0; index < parts.length; index++) {
		var word = parts[index],
		    out = word,
		    extra = void 0;
		if (word && word.match(WEB_LINK)) {
			extra = (word.match(WEB_LINK_TAIL) || NO_MATCH)[0];
			var link = word = word.substring(0, word.length - extra.length);
			if (!link.match(/^https?\:\/\//)) link = 'http://' + link;
			word = word.replace(/\?.+$/, '…');
			if (word.length > 100) word = word.substring(0, 99) + '…';
			out = (0, _preact.h)(
				'a',
				{ href: link, target: '_blank' },
				word
			);
		}
		if (out) {
			if (built.length) append(built, ' ');
			append(built, out);
			if (extra) append(built, extra);
		}
	}
	return built;
});


function append(arr, item) {
	var i = arr.length - 1;
	if (i > -1 && typeof arr[i] === 'string' && typeof item === 'string') {
		arr[i] += item;
	} else {
		arr.push(item);
	}
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__(0);

__webpack_require__(17);

__webpack_require__(18);

__webpack_require__(19);

__webpack_require__(20).install();

var root = void 0;
function init() {
	var App = __webpack_require__(21).default;
	root = (0, _preact.render)((0, _preact.h)(App, null), document.body, root);
}

init();

if (false) {
	module.hot.accept('./components/app', function () {
		return requestAnimationFrame(init);
	});
} else if (location.protocol === 'http:' && localStorage.tried_ssl !== 'true') {
	localStorage.tried_ssl = 'true';
	location.href = 'https' + location.href.substring(4);
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function dlv(t,e,n,r){for(r=0,e=e.split?e.split("."):e;t&&r<e.length;)t=t[e[r++]];return void 0===t?n:t}function linkState$1(t,e,n){var r=e.split("."),a=t.__lsc||(t.__lsc={});return a[e+n]||(a[e+n]=function(e){for(var a=e&&e.target||this,i={},l=i,o="string"==typeof n?dlv(e,n):a.nodeName?a.type.match(/^che|rad/)?a.checked:a.value:e,c=0;c<r.length-1;c++)l=l[r[c]]||(l[r[c]]=!c&&t.state[r[c]]||{});l[r[c]]=o,t.setState(i)})}var preact=__webpack_require__(0);preact.Component.prototype.linkState=function(t,e){return linkState$1(this,t,e)},module.exports=linkState$1;
//# sourceMappingURL=polyfill.js.map


/***/ }),
/* 18 */
/***/ (function(module, exports) {

;(function() {
"use strict";

/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A component handler interface using the revealing module design pattern.
 * More details on this design pattern here:
 * https://github.com/jasonmayes/mdl-component-design-pattern
 *
 * @author Jason Mayes.
 */
/* exported componentHandler */

// Pre-defining the componentHandler interface, for closure documentation and
// static verification.
var componentHandler = {
  /**
   * Searches existing DOM for elements of our component type and upgrades them
   * if they have not already been upgraded.
   *
   * @param {string=} optJsClass the programatic name of the element class we
   * need to create a new instance of.
   * @param {string=} optCssClass the name of the CSS class elements of this
   * type will have.
   */
  upgradeDom: function(optJsClass, optCssClass) {},
  /**
   * Upgrades a specific element rather than all in the DOM.
   *
   * @param {!Element} element The element we wish to upgrade.
   * @param {string=} optJsClass Optional name of the class we want to upgrade
   * the element to.
   */
  upgradeElement: function(element, optJsClass) {},
  /**
   * Upgrades a specific list of elements rather than all in the DOM.
   *
   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
   * The elements we wish to upgrade.
   */
  upgradeElements: function(elements) {},
  /**
   * Upgrades all registered components found in the current DOM. This is
   * automatically called on window load.
   */
  upgradeAllRegistered: function() {},
  /**
   * Allows user to be alerted to any upgrades that are performed for a given
   * component type
   *
   * @param {string} jsClass The class name of the MDL component we wish
   * to hook into for any upgrades performed.
   * @param {function(!HTMLElement)} callback The function to call upon an
   * upgrade. This function should expect 1 parameter - the HTMLElement which
   * got upgraded.
   */
  registerUpgradedCallback: function(jsClass, callback) {},
  /**
   * Registers a class for future use and attempts to upgrade existing DOM.
   *
   * @param {componentHandler.ComponentConfigPublic} config the registration configuration
   */
  register: function(config) {},
  /**
   * Downgrade either a given node, an array of nodes, or a NodeList.
   *
   * @param {!Node|!Array<!Node>|!NodeList} nodes
   */
  downgradeElements: function(nodes) {}
};

componentHandler = (function() {
  'use strict';

  /** @type {!Array<componentHandler.ComponentConfig>} */
  var registeredComponents_ = [];

  /** @type {!Array<componentHandler.Component>} */
  var createdComponents_ = [];

  var componentConfigProperty_ = 'mdlComponentConfigInternal_';

  /**
   * Searches registered components for a class we are interested in using.
   * Optionally replaces a match with passed object if specified.
   *
   * @param {string} name The name of a class we want to use.
   * @param {componentHandler.ComponentConfig=} optReplace Optional object to replace match with.
   * @return {!Object|boolean}
   * @private
   */
  function findRegisteredClass_(name, optReplace) {
    for (var i = 0; i < registeredComponents_.length; i++) {
      if (registeredComponents_[i].className === name) {
        if (typeof optReplace !== 'undefined') {
          registeredComponents_[i] = optReplace;
        }
        return registeredComponents_[i];
      }
    }
    return false;
  }

  /**
   * Returns an array of the classNames of the upgraded classes on the element.
   *
   * @param {!Element} element The element to fetch data from.
   * @return {!Array<string>}
   * @private
   */
  function getUpgradedListOfElement_(element) {
    var dataUpgraded = element.getAttribute('data-upgraded');
    // Use `['']` as default value to conform the `,name,name...` style.
    return dataUpgraded === null ? [''] : dataUpgraded.split(',');
  }

  /**
   * Returns true if the given element has already been upgraded for the given
   * class.
   *
   * @param {!Element} element The element we want to check.
   * @param {string} jsClass The class to check for.
   * @returns {boolean}
   * @private
   */
  function isElementUpgraded_(element, jsClass) {
    var upgradedList = getUpgradedListOfElement_(element);
    return upgradedList.indexOf(jsClass) !== -1;
  }

  /**
   * Create an event object.
   *
   * @param {string} eventType The type name of the event.
   * @param {boolean} bubbles Whether the event should bubble up the DOM.
   * @param {boolean} cancelable Whether the event can be canceled.
   * @returns {!Event}
   */
  function createEvent_(eventType, bubbles, cancelable) {
    if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {
      return new CustomEvent(eventType, {
        bubbles: bubbles,
        cancelable: cancelable
      });
    } else {
      var ev = document.createEvent('Events');
      ev.initEvent(eventType, bubbles, cancelable);
      return ev;
    }
  }

  /**
   * Searches existing DOM for elements of our component type and upgrades them
   * if they have not already been upgraded.
   *
   * @param {string=} optJsClass the programatic name of the element class we
   * need to create a new instance of.
   * @param {string=} optCssClass the name of the CSS class elements of this
   * type will have.
   */
  function upgradeDomInternal(optJsClass, optCssClass) {
    if (typeof optJsClass === 'undefined' &&
        typeof optCssClass === 'undefined') {
      for (var i = 0; i < registeredComponents_.length; i++) {
        upgradeDomInternal(registeredComponents_[i].className,
            registeredComponents_[i].cssClass);
      }
    } else {
      var jsClass = /** @type {string} */ (optJsClass);
      if (typeof optCssClass === 'undefined') {
        var registeredClass = findRegisteredClass_(jsClass);
        if (registeredClass) {
          optCssClass = registeredClass.cssClass;
        }
      }

      var elements = document.querySelectorAll('.' + optCssClass);
      for (var n = 0; n < elements.length; n++) {
        upgradeElementInternal(elements[n], jsClass);
      }
    }
  }

  /**
   * Upgrades a specific element rather than all in the DOM.
   *
   * @param {!Element} element The element we wish to upgrade.
   * @param {string=} optJsClass Optional name of the class we want to upgrade
   * the element to.
   */
  function upgradeElementInternal(element, optJsClass) {
    // Verify argument type.
    if (!(typeof element === 'object' && element instanceof Element)) {
      throw new Error('Invalid argument provided to upgrade MDL element.');
    }
    // Allow upgrade to be canceled by canceling emitted event.
    var upgradingEv = createEvent_('mdl-componentupgrading', true, true);
    element.dispatchEvent(upgradingEv);
    if (upgradingEv.defaultPrevented) {
      return;
    }

    var upgradedList = getUpgradedListOfElement_(element);
    var classesToUpgrade = [];
    // If jsClass is not provided scan the registered components to find the
    // ones matching the element's CSS classList.
    if (!optJsClass) {
      var classList = element.classList;
      registeredComponents_.forEach(function(component) {
        // Match CSS & Not to be upgraded & Not upgraded.
        if (classList.contains(component.cssClass) &&
            classesToUpgrade.indexOf(component) === -1 &&
            !isElementUpgraded_(element, component.className)) {
          classesToUpgrade.push(component);
        }
      });
    } else if (!isElementUpgraded_(element, optJsClass)) {
      classesToUpgrade.push(findRegisteredClass_(optJsClass));
    }

    // Upgrade the element for each classes.
    for (var i = 0, n = classesToUpgrade.length, registeredClass; i < n; i++) {
      registeredClass = classesToUpgrade[i];
      if (registeredClass) {
        // Mark element as upgraded.
        upgradedList.push(registeredClass.className);
        element.setAttribute('data-upgraded', upgradedList.join(','));
        var instance = new registeredClass.classConstructor(element);
        instance[componentConfigProperty_] = registeredClass;
        createdComponents_.push(instance);
        // Call any callbacks the user has registered with this component type.
        for (var j = 0, m = registeredClass.callbacks.length; j < m; j++) {
          registeredClass.callbacks[j](element);
        }

        if (registeredClass.widget) {
          // Assign per element instance for control over API
          element[registeredClass.className] = instance;
        }
      } else {
        throw new Error(
          'Unable to find a registered component for the given class.');
      }

      var upgradedEv = createEvent_('mdl-componentupgraded', true, false);
      element.dispatchEvent(upgradedEv);
    }
  }

  /**
   * Upgrades a specific list of elements rather than all in the DOM.
   *
   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
   * The elements we wish to upgrade.
   */
  function upgradeElementsInternal(elements) {
    if (!Array.isArray(elements)) {
      if (elements instanceof Element) {
        elements = [elements];
      } else {
        elements = Array.prototype.slice.call(elements);
      }
    }
    for (var i = 0, n = elements.length, element; i < n; i++) {
      element = elements[i];
      if (element instanceof HTMLElement) {
        upgradeElementInternal(element);
        if (element.children.length > 0) {
          upgradeElementsInternal(element.children);
        }
      }
    }
  }

  /**
   * Registers a class for future use and attempts to upgrade existing DOM.
   *
   * @param {componentHandler.ComponentConfigPublic} config
   */
  function registerInternal(config) {
    // In order to support both Closure-compiled and uncompiled code accessing
    // this method, we need to allow for both the dot and array syntax for
    // property access. You'll therefore see the `foo.bar || foo['bar']`
    // pattern repeated across this method.
    var widgetMissing = (typeof config.widget === 'undefined' &&
        typeof config['widget'] === 'undefined');
    var widget = true;

    if (!widgetMissing) {
      widget = config.widget || config['widget'];
    }

    var newConfig = /** @type {componentHandler.ComponentConfig} */ ({
      classConstructor: config.constructor || config['constructor'],
      className: config.classAsString || config['classAsString'],
      cssClass: config.cssClass || config['cssClass'],
      widget: widget,
      callbacks: []
    });

    registeredComponents_.forEach(function(item) {
      if (item.cssClass === newConfig.cssClass) {
        throw new Error('The provided cssClass has already been registered: ' + item.cssClass);
      }
      if (item.className === newConfig.className) {
        throw new Error('The provided className has already been registered');
      }
    });

    if (config.constructor.prototype
        .hasOwnProperty(componentConfigProperty_)) {
      throw new Error(
          'MDL component classes must not have ' + componentConfigProperty_ +
          ' defined as a property.');
    }

    var found = findRegisteredClass_(config.classAsString, newConfig);

    if (!found) {
      registeredComponents_.push(newConfig);
    }
  }

  /**
   * Allows user to be alerted to any upgrades that are performed for a given
   * component type
   *
   * @param {string} jsClass The class name of the MDL component we wish
   * to hook into for any upgrades performed.
   * @param {function(!HTMLElement)} callback The function to call upon an
   * upgrade. This function should expect 1 parameter - the HTMLElement which
   * got upgraded.
   */
  function registerUpgradedCallbackInternal(jsClass, callback) {
    var regClass = findRegisteredClass_(jsClass);
    if (regClass) {
      regClass.callbacks.push(callback);
    }
  }

  /**
   * Upgrades all registered components found in the current DOM. This is
   * automatically called on window load.
   */
  function upgradeAllRegisteredInternal() {
    for (var n = 0; n < registeredComponents_.length; n++) {
      upgradeDomInternal(registeredComponents_[n].className);
    }
  }

  /**
   * Check the component for the downgrade method.
   * Execute if found.
   * Remove component from createdComponents list.
   *
   * @param {?componentHandler.Component} component
   */
  function deconstructComponentInternal(component) {
    if (component) {
      var componentIndex = createdComponents_.indexOf(component);
      createdComponents_.splice(componentIndex, 1);

      var upgrades = component.element_.getAttribute('data-upgraded').split(',');
      var componentPlace = upgrades.indexOf(component[componentConfigProperty_].classAsString);
      upgrades.splice(componentPlace, 1);
      component.element_.setAttribute('data-upgraded', upgrades.join(','));

      var ev = createEvent_('mdl-componentdowngraded', true, false);
      component.element_.dispatchEvent(ev);
    }
  }

  /**
   * Downgrade either a given node, an array of nodes, or a NodeList.
   *
   * @param {!Node|!Array<!Node>|!NodeList} nodes
   */
  function downgradeNodesInternal(nodes) {
    /**
     * Auxiliary function to downgrade a single node.
     * @param  {!Node} node the node to be downgraded
     */
    var downgradeNode = function(node) {
      createdComponents_.filter(function(item) {
        return item.element_ === node;
      }).forEach(deconstructComponentInternal);
    };
    if (nodes instanceof Array || nodes instanceof NodeList) {
      for (var n = 0; n < nodes.length; n++) {
        downgradeNode(nodes[n]);
      }
    } else if (nodes instanceof Node) {
      downgradeNode(nodes);
    } else {
      throw new Error('Invalid argument provided to downgrade MDL nodes.');
    }
  }

  // Now return the functions that should be made public with their publicly
  // facing names...
  return {
    upgradeDom: upgradeDomInternal,
    upgradeElement: upgradeElementInternal,
    upgradeElements: upgradeElementsInternal,
    upgradeAllRegistered: upgradeAllRegisteredInternal,
    registerUpgradedCallback: registerUpgradedCallbackInternal,
    register: registerInternal,
    downgradeElements: downgradeNodesInternal
  };
})();

/**
 * Describes the type of a registered component type managed by
 * componentHandler. Provided for benefit of the Closure compiler.
 *
 * @typedef {{
 *   constructor: Function,
 *   classAsString: string,
 *   cssClass: string,
 *   widget: (string|boolean|undefined)
 * }}
 */
componentHandler.ComponentConfigPublic;  // jshint ignore:line

/**
 * Describes the type of a registered component type managed by
 * componentHandler. Provided for benefit of the Closure compiler.
 *
 * @typedef {{
 *   constructor: !Function,
 *   className: string,
 *   cssClass: string,
 *   widget: (string|boolean),
 *   callbacks: !Array<function(!HTMLElement)>
 * }}
 */
componentHandler.ComponentConfig;  // jshint ignore:line

/**
 * Created component (i.e., upgraded element) type as managed by
 * componentHandler. Provided for benefit of the Closure compiler.
 *
 * @typedef {{
 *   element_: !HTMLElement,
 *   className: string,
 *   classAsString: string,
 *   cssClass: string,
 *   widget: string
 * }}
 */
componentHandler.Component;  // jshint ignore:line

// Export all symbols, for the benefit of Closure compiler.
// No effect on uncompiled code.
componentHandler['upgradeDom'] = componentHandler.upgradeDom;
componentHandler['upgradeElement'] = componentHandler.upgradeElement;
componentHandler['upgradeElements'] = componentHandler.upgradeElements;
componentHandler['upgradeAllRegistered'] =
    componentHandler.upgradeAllRegistered;
componentHandler['registerUpgradedCallback'] =
    componentHandler.registerUpgradedCallback;
componentHandler['register'] = componentHandler.register;
componentHandler['downgradeElements'] = componentHandler.downgradeElements;
window.componentHandler = componentHandler;
window['componentHandler'] = componentHandler;

window.addEventListener('load', function() {
  'use strict';

  /**
   * Performs a "Cutting the mustard" test. If the browser supports the features
   * tested, adds a mdl-js class to the <html> element. It then upgrades all MDL
   * components requiring JavaScript.
   */
  if ('classList' in document.createElement('div') &&
      'querySelector' in document &&
      'addEventListener' in window && Array.prototype.forEach) {
    document.documentElement.classList.add('mdl-js');
    componentHandler.upgradeAllRegistered();
  } else {
    /**
     * Dummy function to avoid JS errors.
     */
    componentHandler.upgradeElement = function() {};
    /**
     * Dummy function to avoid JS errors.
     */
    componentHandler.register = function() {};
  }
});

// Source: https://github.com/darius/requestAnimationFrame/blob/master/requestAnimationFrame.js
// Adapted from https://gist.github.com/paulirish/1579671 which derived from
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller.
// Fixes from Paul Irish, Tino Zijdel, Andrew Mao, Klemen Slavič, Darius Bacon
// MIT license
if (!Date.now) {
    /**
     * Date.now polyfill.
     * @return {number} the current Date
     */
    Date.now = function () {
        return new Date().getTime();
    };
    Date['now'] = Date.now;
}
var vendors = [
    'webkit',
    'moz'
];
for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
    var vp = vendors[i];
    window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
    window['requestAnimationFrame'] = window.requestAnimationFrame;
    window['cancelAnimationFrame'] = window.cancelAnimationFrame;
}
if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
    var lastTime = 0;
    /**
     * requestAnimationFrame polyfill.
     * @param  {!Function} callback the callback function.
     */
    window.requestAnimationFrame = function (callback) {
        var now = Date.now();
        var nextTime = Math.max(lastTime + 16, now);
        return setTimeout(function () {
            callback(lastTime = nextTime);
        }, nextTime - now);
    };
    window.cancelAnimationFrame = clearTimeout;
    window['requestAnimationFrame'] = window.requestAnimationFrame;
    window['cancelAnimationFrame'] = window.cancelAnimationFrame;
}
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Button MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialButton = function MaterialButton(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialButton'] = MaterialButton;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialButton.prototype.Constant_ = {};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialButton.prototype.CssClasses_ = {
    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_CONTAINER: 'mdl-button__ripple-container',
    RIPPLE: 'mdl-ripple'
};
/**
   * Handle blur of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialButton.prototype.blurHandler_ = function (event) {
    if (event) {
        this.element_.blur();
    }
};
// Public methods.
/**
   * Disable button.
   *
   * @public
   */
MaterialButton.prototype.disable = function () {
    this.element_.disabled = true;
};
MaterialButton.prototype['disable'] = MaterialButton.prototype.disable;
/**
   * Enable button.
   *
   * @public
   */
MaterialButton.prototype.enable = function () {
    this.element_.disabled = false;
};
MaterialButton.prototype['enable'] = MaterialButton.prototype.enable;
/**
   * Initialize element.
   */
MaterialButton.prototype.init = function () {
    if (this.element_) {
        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
            var rippleContainer = document.createElement('span');
            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
            this.rippleElement_ = document.createElement('span');
            this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
            rippleContainer.appendChild(this.rippleElement_);
            this.boundRippleBlurHandler = this.blurHandler_.bind(this);
            this.rippleElement_.addEventListener('mouseup', this.boundRippleBlurHandler);
            this.element_.appendChild(rippleContainer);
        }
        this.boundButtonBlurHandler = this.blurHandler_.bind(this);
        this.element_.addEventListener('mouseup', this.boundButtonBlurHandler);
        this.element_.addEventListener('mouseleave', this.boundButtonBlurHandler);
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialButton,
    classAsString: 'MaterialButton',
    cssClass: 'mdl-js-button',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Checkbox MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialCheckbox = function MaterialCheckbox(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialCheckbox'] = MaterialCheckbox;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialCheckbox.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialCheckbox.prototype.CssClasses_ = {
    INPUT: 'mdl-checkbox__input',
    BOX_OUTLINE: 'mdl-checkbox__box-outline',
    FOCUS_HELPER: 'mdl-checkbox__focus-helper',
    TICK_OUTLINE: 'mdl-checkbox__tick-outline',
    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    RIPPLE_CONTAINER: 'mdl-checkbox__ripple-container',
    RIPPLE_CENTER: 'mdl-ripple--center',
    RIPPLE: 'mdl-ripple',
    IS_FOCUSED: 'is-focused',
    IS_DISABLED: 'is-disabled',
    IS_CHECKED: 'is-checked',
    IS_UPGRADED: 'is-upgraded'
};
/**
   * Handle change of state.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialCheckbox.prototype.onChange_ = function (event) {
    this.updateClasses_();
};
/**
   * Handle focus of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialCheckbox.prototype.onFocus_ = function (event) {
    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle lost focus of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialCheckbox.prototype.onBlur_ = function (event) {
    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle mouseup.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialCheckbox.prototype.onMouseUp_ = function (event) {
    this.blur_();
};
/**
   * Handle class updates.
   *
   * @private
   */
MaterialCheckbox.prototype.updateClasses_ = function () {
    this.checkDisabled();
    this.checkToggleState();
};
/**
   * Add blur.
   *
   * @private
   */
MaterialCheckbox.prototype.blur_ = function () {
    // TODO: figure out why there's a focus event being fired after our blur,
    // so that we can avoid this hack.
    window.setTimeout(function () {
        this.inputElement_.blur();
    }.bind(this), this.Constant_.TINY_TIMEOUT);
};
// Public methods.
/**
   * Check the inputs toggle state and update display.
   *
   * @public
   */
MaterialCheckbox.prototype.checkToggleState = function () {
    if (this.inputElement_.checked) {
        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
    }
};
MaterialCheckbox.prototype['checkToggleState'] = MaterialCheckbox.prototype.checkToggleState;
/**
   * Check the inputs disabled state and update display.
   *
   * @public
   */
MaterialCheckbox.prototype.checkDisabled = function () {
    if (this.inputElement_.disabled) {
        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    }
};
MaterialCheckbox.prototype['checkDisabled'] = MaterialCheckbox.prototype.checkDisabled;
/**
   * Disable checkbox.
   *
   * @public
   */
MaterialCheckbox.prototype.disable = function () {
    this.inputElement_.disabled = true;
    this.updateClasses_();
};
MaterialCheckbox.prototype['disable'] = MaterialCheckbox.prototype.disable;
/**
   * Enable checkbox.
   *
   * @public
   */
MaterialCheckbox.prototype.enable = function () {
    this.inputElement_.disabled = false;
    this.updateClasses_();
};
MaterialCheckbox.prototype['enable'] = MaterialCheckbox.prototype.enable;
/**
   * Check checkbox.
   *
   * @public
   */
MaterialCheckbox.prototype.check = function () {
    this.inputElement_.checked = true;
    this.updateClasses_();
};
MaterialCheckbox.prototype['check'] = MaterialCheckbox.prototype.check;
/**
   * Uncheck checkbox.
   *
   * @public
   */
MaterialCheckbox.prototype.uncheck = function () {
    this.inputElement_.checked = false;
    this.updateClasses_();
};
MaterialCheckbox.prototype['uncheck'] = MaterialCheckbox.prototype.uncheck;
/**
   * Initialize element.
   */
MaterialCheckbox.prototype.init = function () {
    if (this.element_) {
        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
        var boxOutline = document.createElement('span');
        boxOutline.classList.add(this.CssClasses_.BOX_OUTLINE);
        var tickContainer = document.createElement('span');
        tickContainer.classList.add(this.CssClasses_.FOCUS_HELPER);
        var tickOutline = document.createElement('span');
        tickOutline.classList.add(this.CssClasses_.TICK_OUTLINE);
        boxOutline.appendChild(tickOutline);
        this.element_.appendChild(tickContainer);
        this.element_.appendChild(boxOutline);
        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
            this.rippleContainerElement_ = document.createElement('span');
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
            this.boundRippleMouseUp = this.onMouseUp_.bind(this);
            this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
            var ripple = document.createElement('span');
            ripple.classList.add(this.CssClasses_.RIPPLE);
            this.rippleContainerElement_.appendChild(ripple);
            this.element_.appendChild(this.rippleContainerElement_);
        }
        this.boundInputOnChange = this.onChange_.bind(this);
        this.boundInputOnFocus = this.onFocus_.bind(this);
        this.boundInputOnBlur = this.onBlur_.bind(this);
        this.boundElementMouseUp = this.onMouseUp_.bind(this);
        this.inputElement_.addEventListener('change', this.boundInputOnChange);
        this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
        this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
        this.element_.addEventListener('mouseup', this.boundElementMouseUp);
        this.updateClasses_();
        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialCheckbox,
    classAsString: 'MaterialCheckbox',
    cssClass: 'mdl-js-checkbox',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for icon toggle MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialIconToggle = function MaterialIconToggle(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialIconToggle'] = MaterialIconToggle;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialIconToggle.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialIconToggle.prototype.CssClasses_ = {
    INPUT: 'mdl-icon-toggle__input',
    JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    RIPPLE_CONTAINER: 'mdl-icon-toggle__ripple-container',
    RIPPLE_CENTER: 'mdl-ripple--center',
    RIPPLE: 'mdl-ripple',
    IS_FOCUSED: 'is-focused',
    IS_DISABLED: 'is-disabled',
    IS_CHECKED: 'is-checked'
};
/**
   * Handle change of state.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialIconToggle.prototype.onChange_ = function (event) {
    this.updateClasses_();
};
/**
   * Handle focus of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialIconToggle.prototype.onFocus_ = function (event) {
    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle lost focus of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialIconToggle.prototype.onBlur_ = function (event) {
    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle mouseup.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialIconToggle.prototype.onMouseUp_ = function (event) {
    this.blur_();
};
/**
   * Handle class updates.
   *
   * @private
   */
MaterialIconToggle.prototype.updateClasses_ = function () {
    this.checkDisabled();
    this.checkToggleState();
};
/**
   * Add blur.
   *
   * @private
   */
MaterialIconToggle.prototype.blur_ = function () {
    // TODO: figure out why there's a focus event being fired after our blur,
    // so that we can avoid this hack.
    window.setTimeout(function () {
        this.inputElement_.blur();
    }.bind(this), this.Constant_.TINY_TIMEOUT);
};
// Public methods.
/**
   * Check the inputs toggle state and update display.
   *
   * @public
   */
MaterialIconToggle.prototype.checkToggleState = function () {
    if (this.inputElement_.checked) {
        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
    }
};
MaterialIconToggle.prototype['checkToggleState'] = MaterialIconToggle.prototype.checkToggleState;
/**
   * Check the inputs disabled state and update display.
   *
   * @public
   */
MaterialIconToggle.prototype.checkDisabled = function () {
    if (this.inputElement_.disabled) {
        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    }
};
MaterialIconToggle.prototype['checkDisabled'] = MaterialIconToggle.prototype.checkDisabled;
/**
   * Disable icon toggle.
   *
   * @public
   */
MaterialIconToggle.prototype.disable = function () {
    this.inputElement_.disabled = true;
    this.updateClasses_();
};
MaterialIconToggle.prototype['disable'] = MaterialIconToggle.prototype.disable;
/**
   * Enable icon toggle.
   *
   * @public
   */
MaterialIconToggle.prototype.enable = function () {
    this.inputElement_.disabled = false;
    this.updateClasses_();
};
MaterialIconToggle.prototype['enable'] = MaterialIconToggle.prototype.enable;
/**
   * Check icon toggle.
   *
   * @public
   */
MaterialIconToggle.prototype.check = function () {
    this.inputElement_.checked = true;
    this.updateClasses_();
};
MaterialIconToggle.prototype['check'] = MaterialIconToggle.prototype.check;
/**
   * Uncheck icon toggle.
   *
   * @public
   */
MaterialIconToggle.prototype.uncheck = function () {
    this.inputElement_.checked = false;
    this.updateClasses_();
};
MaterialIconToggle.prototype['uncheck'] = MaterialIconToggle.prototype.uncheck;
/**
   * Initialize element.
   */
MaterialIconToggle.prototype.init = function () {
    if (this.element_) {
        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
        if (this.element_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
            this.rippleContainerElement_ = document.createElement('span');
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
            this.rippleContainerElement_.classList.add(this.CssClasses_.JS_RIPPLE_EFFECT);
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
            this.boundRippleMouseUp = this.onMouseUp_.bind(this);
            this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
            var ripple = document.createElement('span');
            ripple.classList.add(this.CssClasses_.RIPPLE);
            this.rippleContainerElement_.appendChild(ripple);
            this.element_.appendChild(this.rippleContainerElement_);
        }
        this.boundInputOnChange = this.onChange_.bind(this);
        this.boundInputOnFocus = this.onFocus_.bind(this);
        this.boundInputOnBlur = this.onBlur_.bind(this);
        this.boundElementOnMouseUp = this.onMouseUp_.bind(this);
        this.inputElement_.addEventListener('change', this.boundInputOnChange);
        this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
        this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
        this.element_.addEventListener('mouseup', this.boundElementOnMouseUp);
        this.updateClasses_();
        this.element_.classList.add('is-upgraded');
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialIconToggle,
    classAsString: 'MaterialIconToggle',
    cssClass: 'mdl-js-icon-toggle',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for dropdown MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialMenu = function MaterialMenu(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialMenu'] = MaterialMenu;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialMenu.prototype.Constant_ = {
    // Total duration of the menu animation.
    TRANSITION_DURATION_SECONDS: 0.3,
    // The fraction of the total duration we want to use for menu item animations.
    TRANSITION_DURATION_FRACTION: 0.8,
    // How long the menu stays open after choosing an option (so the user can see
    // the ripple).
    CLOSE_TIMEOUT: 150
};
/**
   * Keycodes, for code readability.
   *
   * @enum {number}
   * @private
   */
MaterialMenu.prototype.Keycodes_ = {
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    UP_ARROW: 38,
    DOWN_ARROW: 40
};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialMenu.prototype.CssClasses_ = {
    CONTAINER: 'mdl-menu__container',
    OUTLINE: 'mdl-menu__outline',
    ITEM: 'mdl-menu__item',
    ITEM_RIPPLE_CONTAINER: 'mdl-menu__item-ripple-container',
    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    RIPPLE: 'mdl-ripple',
    // Statuses
    IS_UPGRADED: 'is-upgraded',
    IS_VISIBLE: 'is-visible',
    IS_ANIMATING: 'is-animating',
    // Alignment options
    BOTTOM_LEFT: 'mdl-menu--bottom-left',
    // This is the default.
    BOTTOM_RIGHT: 'mdl-menu--bottom-right',
    TOP_LEFT: 'mdl-menu--top-left',
    TOP_RIGHT: 'mdl-menu--top-right',
    UNALIGNED: 'mdl-menu--unaligned'
};
/**
   * Initialize element.
   */
MaterialMenu.prototype.init = function () {
    if (this.element_) {
        // Create container for the menu.
        var container = document.createElement('div');
        container.classList.add(this.CssClasses_.CONTAINER);
        this.element_.parentElement.insertBefore(container, this.element_);
        this.element_.parentElement.removeChild(this.element_);
        container.appendChild(this.element_);
        this.container_ = container;
        // Create outline for the menu (shadow and background).
        var outline = document.createElement('div');
        outline.classList.add(this.CssClasses_.OUTLINE);
        this.outline_ = outline;
        container.insertBefore(outline, this.element_);
        // Find the "for" element and bind events to it.
        var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
        var forEl = null;
        if (forElId) {
            forEl = document.getElementById(forElId);
            if (forEl) {
                this.forElement_ = forEl;
                forEl.addEventListener('click', this.handleForClick_.bind(this));
                forEl.addEventListener('keydown', this.handleForKeyboardEvent_.bind(this));
            }
        }
        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
        this.boundItemKeydown_ = this.handleItemKeyboardEvent_.bind(this);
        this.boundItemClick_ = this.handleItemClick_.bind(this);
        for (var i = 0; i < items.length; i++) {
            // Add a listener to each menu item.
            items[i].addEventListener('click', this.boundItemClick_);
            // Add a tab index to each menu item.
            items[i].tabIndex = '-1';
            // Add a keyboard listener to each menu item.
            items[i].addEventListener('keydown', this.boundItemKeydown_);
        }
        // Add ripple classes to each item, if the user has enabled ripples.
        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
            for (i = 0; i < items.length; i++) {
                var item = items[i];
                var rippleContainer = document.createElement('span');
                rippleContainer.classList.add(this.CssClasses_.ITEM_RIPPLE_CONTAINER);
                var ripple = document.createElement('span');
                ripple.classList.add(this.CssClasses_.RIPPLE);
                rippleContainer.appendChild(ripple);
                item.appendChild(rippleContainer);
                item.classList.add(this.CssClasses_.RIPPLE_EFFECT);
            }
        }
        // Copy alignment classes to the container, so the outline can use them.
        if (this.element_.classList.contains(this.CssClasses_.BOTTOM_LEFT)) {
            this.outline_.classList.add(this.CssClasses_.BOTTOM_LEFT);
        }
        if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
            this.outline_.classList.add(this.CssClasses_.BOTTOM_RIGHT);
        }
        if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
            this.outline_.classList.add(this.CssClasses_.TOP_LEFT);
        }
        if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
            this.outline_.classList.add(this.CssClasses_.TOP_RIGHT);
        }
        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
            this.outline_.classList.add(this.CssClasses_.UNALIGNED);
        }
        container.classList.add(this.CssClasses_.IS_UPGRADED);
    }
};
/**
   * Handles a click on the "for" element, by positioning the menu and then
   * toggling it.
   *
   * @param {Event} evt The event that fired.
   * @private
   */
MaterialMenu.prototype.handleForClick_ = function (evt) {
    if (this.element_ && this.forElement_) {
        var rect = this.forElement_.getBoundingClientRect();
        var forRect = this.forElement_.parentElement.getBoundingClientRect();
        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
        } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
            // Position below the "for" element, aligned to its right.
            this.container_.style.right = forRect.right - rect.right + 'px';
            this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
        } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
            // Position above the "for" element, aligned to its left.
            this.container_.style.left = this.forElement_.offsetLeft + 'px';
            this.container_.style.bottom = forRect.bottom - rect.top + 'px';
        } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
            // Position above the "for" element, aligned to its right.
            this.container_.style.right = forRect.right - rect.right + 'px';
            this.container_.style.bottom = forRect.bottom - rect.top + 'px';
        } else {
            // Default: position below the "for" element, aligned to its left.
            this.container_.style.left = this.forElement_.offsetLeft + 'px';
            this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
        }
    }
    this.toggle(evt);
};
/**
   * Handles a keyboard event on the "for" element.
   *
   * @param {Event} evt The event that fired.
   * @private
   */
MaterialMenu.prototype.handleForKeyboardEvent_ = function (evt) {
    if (this.element_ && this.container_ && this.forElement_) {
        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
        if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
            if (evt.keyCode === this.Keycodes_.UP_ARROW) {
                evt.preventDefault();
                items[items.length - 1].focus();
            } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
                evt.preventDefault();
                items[0].focus();
            }
        }
    }
};
/**
   * Handles a keyboard event on an item.
   *
   * @param {Event} evt The event that fired.
   * @private
   */
MaterialMenu.prototype.handleItemKeyboardEvent_ = function (evt) {
    if (this.element_ && this.container_) {
        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
        if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
            var currentIndex = Array.prototype.slice.call(items).indexOf(evt.target);
            if (evt.keyCode === this.Keycodes_.UP_ARROW) {
                evt.preventDefault();
                if (currentIndex > 0) {
                    items[currentIndex - 1].focus();
                } else {
                    items[items.length - 1].focus();
                }
            } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
                evt.preventDefault();
                if (items.length > currentIndex + 1) {
                    items[currentIndex + 1].focus();
                } else {
                    items[0].focus();
                }
            } else if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
                evt.preventDefault();
                // Send mousedown and mouseup to trigger ripple.
                var e = new MouseEvent('mousedown');
                evt.target.dispatchEvent(e);
                e = new MouseEvent('mouseup');
                evt.target.dispatchEvent(e);
                // Send click.
                evt.target.click();
            } else if (evt.keyCode === this.Keycodes_.ESCAPE) {
                evt.preventDefault();
                this.hide();
            }
        }
    }
};
/**
   * Handles a click event on an item.
   *
   * @param {Event} evt The event that fired.
   * @private
   */
MaterialMenu.prototype.handleItemClick_ = function (evt) {
    if (evt.target.hasAttribute('disabled')) {
        evt.stopPropagation();
    } else {
        // Wait some time before closing menu, so the user can see the ripple.
        this.closing_ = true;
        window.setTimeout(function (evt) {
            this.hide();
            this.closing_ = false;
        }.bind(this), this.Constant_.CLOSE_TIMEOUT);
    }
};
/**
   * Calculates the initial clip (for opening the menu) or final clip (for closing
   * it), and applies it. This allows us to animate from or to the correct point,
   * that is, the point it's aligned to in the "for" element.
   *
   * @param {number} height Height of the clip rectangle
   * @param {number} width Width of the clip rectangle
   * @private
   */
MaterialMenu.prototype.applyClip_ = function (height, width) {
    if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
        // Do not clip.
        this.element_.style.clip = '';
    } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
        // Clip to the top right corner of the menu.
        this.element_.style.clip = 'rect(0 ' + width + 'px ' + '0 ' + width + 'px)';
    } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
        // Clip to the bottom left corner of the menu.
        this.element_.style.clip = 'rect(' + height + 'px 0 ' + height + 'px 0)';
    } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
        // Clip to the bottom right corner of the menu.
        this.element_.style.clip = 'rect(' + height + 'px ' + width + 'px ' + height + 'px ' + width + 'px)';
    } else {
        // Default: do not clip (same as clipping to the top left corner).
        this.element_.style.clip = '';
    }
};
/**
   * Cleanup function to remove animation listeners.
   *
   * @param {Event} evt
   * @private
   */
MaterialMenu.prototype.removeAnimationEndListener_ = function (evt) {
    evt.target.classList.remove(MaterialMenu.prototype.CssClasses_.IS_ANIMATING);
};
/**
   * Adds an event listener to clean up after the animation ends.
   *
   * @private
   */
MaterialMenu.prototype.addAnimationEndListener_ = function () {
    this.element_.addEventListener('transitionend', this.removeAnimationEndListener_);
    this.element_.addEventListener('webkitTransitionEnd', this.removeAnimationEndListener_);
};
/**
   * Displays the menu.
   *
   * @public
   */
MaterialMenu.prototype.show = function (evt) {
    if (this.element_ && this.container_ && this.outline_) {
        // Measure the inner element.
        var height = this.element_.getBoundingClientRect().height;
        var width = this.element_.getBoundingClientRect().width;
        // Apply the inner element's size to the container and outline.
        this.container_.style.width = width + 'px';
        this.container_.style.height = height + 'px';
        this.outline_.style.width = width + 'px';
        this.outline_.style.height = height + 'px';
        var transitionDuration = this.Constant_.TRANSITION_DURATION_SECONDS * this.Constant_.TRANSITION_DURATION_FRACTION;
        // Calculate transition delays for individual menu items, so that they fade
        // in one at a time.
        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
        for (var i = 0; i < items.length; i++) {
            var itemDelay = null;
            if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT) || this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
                itemDelay = (height - items[i].offsetTop - items[i].offsetHeight) / height * transitionDuration + 's';
            } else {
                itemDelay = items[i].offsetTop / height * transitionDuration + 's';
            }
            items[i].style.transitionDelay = itemDelay;
        }
        // Apply the initial clip to the text before we start animating.
        this.applyClip_(height, width);
        // Wait for the next frame, turn on animation, and apply the final clip.
        // Also make it visible. This triggers the transitions.
        window.requestAnimationFrame(function () {
            this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
            this.element_.style.clip = 'rect(0 ' + width + 'px ' + height + 'px 0)';
            this.container_.classList.add(this.CssClasses_.IS_VISIBLE);
        }.bind(this));
        // Clean up after the animation is complete.
        this.addAnimationEndListener_();
        // Add a click listener to the document, to close the menu.
        var callback = function (e) {
            // Check to see if the document is processing the same event that
            // displayed the menu in the first place. If so, do nothing.
            // Also check to see if the menu is in the process of closing itself, and
            // do nothing in that case.
            // Also check if the clicked element is a menu item
            // if so, do nothing.
            if (e !== evt && !this.closing_ && e.target.parentNode !== this.element_) {
                document.removeEventListener('click', callback);
                this.hide();
            }
        }.bind(this);
        document.addEventListener('click', callback);
    }
};
MaterialMenu.prototype['show'] = MaterialMenu.prototype.show;
/**
   * Hides the menu.
   *
   * @public
   */
MaterialMenu.prototype.hide = function () {
    if (this.element_ && this.container_ && this.outline_) {
        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
        // Remove all transition delays; menu items fade out concurrently.
        for (var i = 0; i < items.length; i++) {
            items[i].style.removeProperty('transition-delay');
        }
        // Measure the inner element.
        var rect = this.element_.getBoundingClientRect();
        var height = rect.height;
        var width = rect.width;
        // Turn on animation, and apply the final clip. Also make invisible.
        // This triggers the transitions.
        this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
        this.applyClip_(height, width);
        this.container_.classList.remove(this.CssClasses_.IS_VISIBLE);
        // Clean up after the animation is complete.
        this.addAnimationEndListener_();
    }
};
MaterialMenu.prototype['hide'] = MaterialMenu.prototype.hide;
/**
   * Displays or hides the menu, depending on current state.
   *
   * @public
   */
MaterialMenu.prototype.toggle = function (evt) {
    if (this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
        this.hide();
    } else {
        this.show(evt);
    }
};
MaterialMenu.prototype['toggle'] = MaterialMenu.prototype.toggle;
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialMenu,
    classAsString: 'MaterialMenu',
    cssClass: 'mdl-js-menu',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Progress MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialProgress = function MaterialProgress(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialProgress'] = MaterialProgress;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialProgress.prototype.Constant_ = {};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialProgress.prototype.CssClasses_ = { INDETERMINATE_CLASS: 'mdl-progress__indeterminate' };
/**
   * Set the current progress of the progressbar.
   *
   * @param {number} p Percentage of the progress (0-100)
   * @public
   */
MaterialProgress.prototype.setProgress = function (p) {
    if (this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)) {
        return;
    }
    this.progressbar_.style.width = p + '%';
};
MaterialProgress.prototype['setProgress'] = MaterialProgress.prototype.setProgress;
/**
   * Set the current progress of the buffer.
   *
   * @param {number} p Percentage of the buffer (0-100)
   * @public
   */
MaterialProgress.prototype.setBuffer = function (p) {
    this.bufferbar_.style.width = p + '%';
    this.auxbar_.style.width = 100 - p + '%';
};
MaterialProgress.prototype['setBuffer'] = MaterialProgress.prototype.setBuffer;
/**
   * Initialize element.
   */
MaterialProgress.prototype.init = function () {
    if (this.element_) {
        var el = document.createElement('div');
        el.className = 'progressbar bar bar1';
        this.element_.appendChild(el);
        this.progressbar_ = el;
        el = document.createElement('div');
        el.className = 'bufferbar bar bar2';
        this.element_.appendChild(el);
        this.bufferbar_ = el;
        el = document.createElement('div');
        el.className = 'auxbar bar bar3';
        this.element_.appendChild(el);
        this.auxbar_ = el;
        this.progressbar_.style.width = '0%';
        this.bufferbar_.style.width = '100%';
        this.auxbar_.style.width = '0%';
        this.element_.classList.add('is-upgraded');
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialProgress,
    classAsString: 'MaterialProgress',
    cssClass: 'mdl-js-progress',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Radio MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialRadio = function MaterialRadio(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialRadio'] = MaterialRadio;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialRadio.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialRadio.prototype.CssClasses_ = {
    IS_FOCUSED: 'is-focused',
    IS_DISABLED: 'is-disabled',
    IS_CHECKED: 'is-checked',
    IS_UPGRADED: 'is-upgraded',
    JS_RADIO: 'mdl-js-radio',
    RADIO_BTN: 'mdl-radio__button',
    RADIO_OUTER_CIRCLE: 'mdl-radio__outer-circle',
    RADIO_INNER_CIRCLE: 'mdl-radio__inner-circle',
    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    RIPPLE_CONTAINER: 'mdl-radio__ripple-container',
    RIPPLE_CENTER: 'mdl-ripple--center',
    RIPPLE: 'mdl-ripple'
};
/**
   * Handle change of state.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialRadio.prototype.onChange_ = function (event) {
    // Since other radio buttons don't get change events, we need to look for
    // them to update their classes.
    var radios = document.getElementsByClassName(this.CssClasses_.JS_RADIO);
    for (var i = 0; i < radios.length; i++) {
        var button = radios[i].querySelector('.' + this.CssClasses_.RADIO_BTN);
        // Different name == different group, so no point updating those.
        if (button.getAttribute('name') === this.btnElement_.getAttribute('name')) {
            if (typeof radios[i]['MaterialRadio'] !== 'undefined') {
                radios[i]['MaterialRadio'].updateClasses_();
            }
        }
    }
};
/**
   * Handle focus.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialRadio.prototype.onFocus_ = function (event) {
    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle lost focus.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialRadio.prototype.onBlur_ = function (event) {
    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle mouseup.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialRadio.prototype.onMouseup_ = function (event) {
    this.blur_();
};
/**
   * Update classes.
   *
   * @private
   */
MaterialRadio.prototype.updateClasses_ = function () {
    this.checkDisabled();
    this.checkToggleState();
};
/**
   * Add blur.
   *
   * @private
   */
MaterialRadio.prototype.blur_ = function () {
    // TODO: figure out why there's a focus event being fired after our blur,
    // so that we can avoid this hack.
    window.setTimeout(function () {
        this.btnElement_.blur();
    }.bind(this), this.Constant_.TINY_TIMEOUT);
};
// Public methods.
/**
   * Check the components disabled state.
   *
   * @public
   */
MaterialRadio.prototype.checkDisabled = function () {
    if (this.btnElement_.disabled) {
        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    }
};
MaterialRadio.prototype['checkDisabled'] = MaterialRadio.prototype.checkDisabled;
/**
   * Check the components toggled state.
   *
   * @public
   */
MaterialRadio.prototype.checkToggleState = function () {
    if (this.btnElement_.checked) {
        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
    }
};
MaterialRadio.prototype['checkToggleState'] = MaterialRadio.prototype.checkToggleState;
/**
   * Disable radio.
   *
   * @public
   */
MaterialRadio.prototype.disable = function () {
    this.btnElement_.disabled = true;
    this.updateClasses_();
};
MaterialRadio.prototype['disable'] = MaterialRadio.prototype.disable;
/**
   * Enable radio.
   *
   * @public
   */
MaterialRadio.prototype.enable = function () {
    this.btnElement_.disabled = false;
    this.updateClasses_();
};
MaterialRadio.prototype['enable'] = MaterialRadio.prototype.enable;
/**
   * Check radio.
   *
   * @public
   */
MaterialRadio.prototype.check = function () {
    this.btnElement_.checked = true;
    this.onChange_(null);
};
MaterialRadio.prototype['check'] = MaterialRadio.prototype.check;
/**
   * Uncheck radio.
   *
   * @public
   */
MaterialRadio.prototype.uncheck = function () {
    this.btnElement_.checked = false;
    this.onChange_(null);
};
MaterialRadio.prototype['uncheck'] = MaterialRadio.prototype.uncheck;
/**
   * Initialize element.
   */
MaterialRadio.prototype.init = function () {
    if (this.element_) {
        this.btnElement_ = this.element_.querySelector('.' + this.CssClasses_.RADIO_BTN);
        this.boundChangeHandler_ = this.onChange_.bind(this);
        this.boundFocusHandler_ = this.onChange_.bind(this);
        this.boundBlurHandler_ = this.onBlur_.bind(this);
        this.boundMouseUpHandler_ = this.onMouseup_.bind(this);
        var outerCircle = document.createElement('span');
        outerCircle.classList.add(this.CssClasses_.RADIO_OUTER_CIRCLE);
        var innerCircle = document.createElement('span');
        innerCircle.classList.add(this.CssClasses_.RADIO_INNER_CIRCLE);
        this.element_.appendChild(outerCircle);
        this.element_.appendChild(innerCircle);
        var rippleContainer;
        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
            rippleContainer = document.createElement('span');
            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
            rippleContainer.classList.add(this.CssClasses_.RIPPLE_EFFECT);
            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CENTER);
            rippleContainer.addEventListener('mouseup', this.boundMouseUpHandler_);
            var ripple = document.createElement('span');
            ripple.classList.add(this.CssClasses_.RIPPLE);
            rippleContainer.appendChild(ripple);
            this.element_.appendChild(rippleContainer);
        }
        this.btnElement_.addEventListener('change', this.boundChangeHandler_);
        this.btnElement_.addEventListener('focus', this.boundFocusHandler_);
        this.btnElement_.addEventListener('blur', this.boundBlurHandler_);
        this.element_.addEventListener('mouseup', this.boundMouseUpHandler_);
        this.updateClasses_();
        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialRadio,
    classAsString: 'MaterialRadio',
    cssClass: 'mdl-js-radio',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Slider MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialSlider = function MaterialSlider(element) {
    this.element_ = element;
    // Browser feature detection.
    this.isIE_ = window.navigator.msPointerEnabled;
    // Initialize instance.
    this.init();
};
window['MaterialSlider'] = MaterialSlider;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialSlider.prototype.Constant_ = {};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialSlider.prototype.CssClasses_ = {
    IE_CONTAINER: 'mdl-slider__ie-container',
    SLIDER_CONTAINER: 'mdl-slider__container',
    BACKGROUND_FLEX: 'mdl-slider__background-flex',
    BACKGROUND_LOWER: 'mdl-slider__background-lower',
    BACKGROUND_UPPER: 'mdl-slider__background-upper',
    IS_LOWEST_VALUE: 'is-lowest-value',
    IS_UPGRADED: 'is-upgraded'
};
/**
   * Handle input on element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSlider.prototype.onInput_ = function (event) {
    this.updateValueStyles_();
};
/**
   * Handle change on element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSlider.prototype.onChange_ = function (event) {
    this.updateValueStyles_();
};
/**
   * Handle mouseup on element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSlider.prototype.onMouseUp_ = function (event) {
    event.target.blur();
};
/**
   * Handle mousedown on container element.
   * This handler is purpose is to not require the use to click
   * exactly on the 2px slider element, as FireFox seems to be very
   * strict about this.
   *
   * @param {Event} event The event that fired.
   * @private
   * @suppress {missingProperties}
   */
MaterialSlider.prototype.onContainerMouseDown_ = function (event) {
    // If this click is not on the parent element (but rather some child)
    // ignore. It may still bubble up.
    if (event.target !== this.element_.parentElement) {
        return;
    }
    // Discard the original event and create a new event that
    // is on the slider element.
    event.preventDefault();
    var newEvent = new MouseEvent('mousedown', {
        target: event.target,
        buttons: event.buttons,
        clientX: event.clientX,
        clientY: this.element_.getBoundingClientRect().y
    });
    this.element_.dispatchEvent(newEvent);
};
/**
   * Handle updating of values.
   *
   * @private
   */
MaterialSlider.prototype.updateValueStyles_ = function () {
    // Calculate and apply percentages to div structure behind slider.
    var fraction = (this.element_.value - this.element_.min) / (this.element_.max - this.element_.min);
    if (fraction === 0) {
        this.element_.classList.add(this.CssClasses_.IS_LOWEST_VALUE);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_LOWEST_VALUE);
    }
    if (!this.isIE_) {
        this.backgroundLower_.style.flex = fraction;
        this.backgroundLower_.style.webkitFlex = fraction;
        this.backgroundUpper_.style.flex = 1 - fraction;
        this.backgroundUpper_.style.webkitFlex = 1 - fraction;
    }
};
// Public methods.
/**
   * Disable slider.
   *
   * @public
   */
MaterialSlider.prototype.disable = function () {
    this.element_.disabled = true;
};
MaterialSlider.prototype['disable'] = MaterialSlider.prototype.disable;
/**
   * Enable slider.
   *
   * @public
   */
MaterialSlider.prototype.enable = function () {
    this.element_.disabled = false;
};
MaterialSlider.prototype['enable'] = MaterialSlider.prototype.enable;
/**
   * Update slider value.
   *
   * @param {number} value The value to which to set the control (optional).
   * @public
   */
MaterialSlider.prototype.change = function (value) {
    if (typeof value !== 'undefined') {
        this.element_.value = value;
    }
    this.updateValueStyles_();
};
MaterialSlider.prototype['change'] = MaterialSlider.prototype.change;
/**
   * Initialize element.
   */
MaterialSlider.prototype.init = function () {
    if (this.element_) {
        if (this.isIE_) {
            // Since we need to specify a very large height in IE due to
            // implementation limitations, we add a parent here that trims it down to
            // a reasonable size.
            var containerIE = document.createElement('div');
            containerIE.classList.add(this.CssClasses_.IE_CONTAINER);
            this.element_.parentElement.insertBefore(containerIE, this.element_);
            this.element_.parentElement.removeChild(this.element_);
            containerIE.appendChild(this.element_);
        } else {
            // For non-IE browsers, we need a div structure that sits behind the
            // slider and allows us to style the left and right sides of it with
            // different colors.
            var container = document.createElement('div');
            container.classList.add(this.CssClasses_.SLIDER_CONTAINER);
            this.element_.parentElement.insertBefore(container, this.element_);
            this.element_.parentElement.removeChild(this.element_);
            container.appendChild(this.element_);
            var backgroundFlex = document.createElement('div');
            backgroundFlex.classList.add(this.CssClasses_.BACKGROUND_FLEX);
            container.appendChild(backgroundFlex);
            this.backgroundLower_ = document.createElement('div');
            this.backgroundLower_.classList.add(this.CssClasses_.BACKGROUND_LOWER);
            backgroundFlex.appendChild(this.backgroundLower_);
            this.backgroundUpper_ = document.createElement('div');
            this.backgroundUpper_.classList.add(this.CssClasses_.BACKGROUND_UPPER);
            backgroundFlex.appendChild(this.backgroundUpper_);
        }
        this.boundInputHandler = this.onInput_.bind(this);
        this.boundChangeHandler = this.onChange_.bind(this);
        this.boundMouseUpHandler = this.onMouseUp_.bind(this);
        this.boundContainerMouseDownHandler = this.onContainerMouseDown_.bind(this);
        this.element_.addEventListener('input', this.boundInputHandler);
        this.element_.addEventListener('change', this.boundChangeHandler);
        this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
        this.element_.parentElement.addEventListener('mousedown', this.boundContainerMouseDownHandler);
        this.updateValueStyles_();
        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialSlider,
    classAsString: 'MaterialSlider',
    cssClass: 'mdl-js-slider',
    widget: true
});
/**
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Snackbar MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialSnackbar = function MaterialSnackbar(element) {
    this.element_ = element;
    this.textElement_ = this.element_.querySelector('.' + this.cssClasses_.MESSAGE);
    this.actionElement_ = this.element_.querySelector('.' + this.cssClasses_.ACTION);
    if (!this.textElement_) {
        throw new Error('There must be a message element for a snackbar.');
    }
    if (!this.actionElement_) {
        throw new Error('There must be an action element for a snackbar.');
    }
    this.active = false;
    this.actionHandler_ = undefined;
    this.message_ = undefined;
    this.actionText_ = undefined;
    this.queuedNotifications_ = [];
    this.setActionHidden_(true);
};
window['MaterialSnackbar'] = MaterialSnackbar;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialSnackbar.prototype.Constant_ = {
    // The duration of the snackbar show/hide animation, in ms.
    ANIMATION_LENGTH: 250
};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialSnackbar.prototype.cssClasses_ = {
    SNACKBAR: 'mdl-snackbar',
    MESSAGE: 'mdl-snackbar__text',
    ACTION: 'mdl-snackbar__action',
    ACTIVE: 'mdl-snackbar--active'
};
/**
   * Display the snackbar.
   *
   * @private
   */
MaterialSnackbar.prototype.displaySnackbar_ = function () {
    this.element_.setAttribute('aria-hidden', 'true');
    if (this.actionHandler_) {
        this.actionElement_.textContent = this.actionText_;
        this.actionElement_.addEventListener('click', this.actionHandler_);
        this.setActionHidden_(false);
    }
    this.textElement_.textContent = this.message_;
    this.element_.classList.add(this.cssClasses_.ACTIVE);
    this.element_.setAttribute('aria-hidden', 'false');
    setTimeout(this.cleanup_.bind(this), this.timeout_);
};
/**
   * Show the snackbar.
   *
   * @param {Object} data The data for the notification.
   * @public
   */
MaterialSnackbar.prototype.showSnackbar = function (data) {
    if (data === undefined) {
        throw new Error('Please provide a data object with at least a message to display.');
    }
    if (data['message'] === undefined) {
        throw new Error('Please provide a message to be displayed.');
    }
    if (data['actionHandler'] && !data['actionText']) {
        throw new Error('Please provide action text with the handler.');
    }
    if (this.active) {
        this.queuedNotifications_.push(data);
    } else {
        this.active = true;
        this.message_ = data['message'];
        if (data['timeout']) {
            this.timeout_ = data['timeout'];
        } else {
            this.timeout_ = 2750;
        }
        if (data['actionHandler']) {
            this.actionHandler_ = data['actionHandler'];
        }
        if (data['actionText']) {
            this.actionText_ = data['actionText'];
        }
        this.displaySnackbar_();
    }
};
MaterialSnackbar.prototype['showSnackbar'] = MaterialSnackbar.prototype.showSnackbar;
/**
   * Check if the queue has items within it.
   * If it does, display the next entry.
   *
   * @private
   */
MaterialSnackbar.prototype.checkQueue_ = function () {
    if (this.queuedNotifications_.length > 0) {
        this.showSnackbar(this.queuedNotifications_.shift());
    }
};
/**
   * Cleanup the snackbar event listeners and accessiblity attributes.
   *
   * @private
   */
MaterialSnackbar.prototype.cleanup_ = function () {
    this.element_.classList.remove(this.cssClasses_.ACTIVE);
    setTimeout(function () {
        this.element_.setAttribute('aria-hidden', 'true');
        this.textElement_.textContent = '';
        if (!Boolean(this.actionElement_.getAttribute('aria-hidden'))) {
            this.setActionHidden_(true);
            this.actionElement_.textContent = '';
            this.actionElement_.removeEventListener('click', this.actionHandler_);
        }
        this.actionHandler_ = undefined;
        this.message_ = undefined;
        this.actionText_ = undefined;
        this.active = false;
        this.checkQueue_();
    }.bind(this), this.Constant_.ANIMATION_LENGTH);
};
/**
   * Set the action handler hidden state.
   *
   * @param {boolean} value
   * @private
   */
MaterialSnackbar.prototype.setActionHidden_ = function (value) {
    if (value) {
        this.actionElement_.setAttribute('aria-hidden', 'true');
    } else {
        this.actionElement_.removeAttribute('aria-hidden');
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialSnackbar,
    classAsString: 'MaterialSnackbar',
    cssClass: 'mdl-js-snackbar',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Spinner MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @param {HTMLElement} element The element that will be upgraded.
   * @constructor
   */
var MaterialSpinner = function MaterialSpinner(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialSpinner'] = MaterialSpinner;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialSpinner.prototype.Constant_ = { MDL_SPINNER_LAYER_COUNT: 4 };
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialSpinner.prototype.CssClasses_ = {
    MDL_SPINNER_LAYER: 'mdl-spinner__layer',
    MDL_SPINNER_CIRCLE_CLIPPER: 'mdl-spinner__circle-clipper',
    MDL_SPINNER_CIRCLE: 'mdl-spinner__circle',
    MDL_SPINNER_GAP_PATCH: 'mdl-spinner__gap-patch',
    MDL_SPINNER_LEFT: 'mdl-spinner__left',
    MDL_SPINNER_RIGHT: 'mdl-spinner__right'
};
/**
   * Auxiliary method to create a spinner layer.
   *
   * @param {number} index Index of the layer to be created.
   * @public
   */
MaterialSpinner.prototype.createLayer = function (index) {
    var layer = document.createElement('div');
    layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);
    layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER + '-' + index);
    var leftClipper = document.createElement('div');
    leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
    leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);
    var gapPatch = document.createElement('div');
    gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);
    var rightClipper = document.createElement('div');
    rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
    rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);
    var circleOwners = [
        leftClipper,
        gapPatch,
        rightClipper
    ];
    for (var i = 0; i < circleOwners.length; i++) {
        var circle = document.createElement('div');
        circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);
        circleOwners[i].appendChild(circle);
    }
    layer.appendChild(leftClipper);
    layer.appendChild(gapPatch);
    layer.appendChild(rightClipper);
    this.element_.appendChild(layer);
};
MaterialSpinner.prototype['createLayer'] = MaterialSpinner.prototype.createLayer;
/**
   * Stops the spinner animation.
   * Public method for users who need to stop the spinner for any reason.
   *
   * @public
   */
MaterialSpinner.prototype.stop = function () {
    this.element_.classList.remove('is-active');
};
MaterialSpinner.prototype['stop'] = MaterialSpinner.prototype.stop;
/**
   * Starts the spinner animation.
   * Public method for users who need to manually start the spinner for any reason
   * (instead of just adding the 'is-active' class to their markup).
   *
   * @public
   */
MaterialSpinner.prototype.start = function () {
    this.element_.classList.add('is-active');
};
MaterialSpinner.prototype['start'] = MaterialSpinner.prototype.start;
/**
   * Initialize element.
   */
MaterialSpinner.prototype.init = function () {
    if (this.element_) {
        for (var i = 1; i <= this.Constant_.MDL_SPINNER_LAYER_COUNT; i++) {
            this.createLayer(i);
        }
        this.element_.classList.add('is-upgraded');
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialSpinner,
    classAsString: 'MaterialSpinner',
    cssClass: 'mdl-js-spinner',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Checkbox MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialSwitch = function MaterialSwitch(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialSwitch'] = MaterialSwitch;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialSwitch.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialSwitch.prototype.CssClasses_ = {
    INPUT: 'mdl-switch__input',
    TRACK: 'mdl-switch__track',
    THUMB: 'mdl-switch__thumb',
    FOCUS_HELPER: 'mdl-switch__focus-helper',
    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    RIPPLE_CONTAINER: 'mdl-switch__ripple-container',
    RIPPLE_CENTER: 'mdl-ripple--center',
    RIPPLE: 'mdl-ripple',
    IS_FOCUSED: 'is-focused',
    IS_DISABLED: 'is-disabled',
    IS_CHECKED: 'is-checked'
};
/**
   * Handle change of state.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSwitch.prototype.onChange_ = function (event) {
    this.updateClasses_();
};
/**
   * Handle focus of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSwitch.prototype.onFocus_ = function (event) {
    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle lost focus of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSwitch.prototype.onBlur_ = function (event) {
    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle mouseup.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialSwitch.prototype.onMouseUp_ = function (event) {
    this.blur_();
};
/**
   * Handle class updates.
   *
   * @private
   */
MaterialSwitch.prototype.updateClasses_ = function () {
    this.checkDisabled();
    this.checkToggleState();
};
/**
   * Add blur.
   *
   * @private
   */
MaterialSwitch.prototype.blur_ = function () {
    // TODO: figure out why there's a focus event being fired after our blur,
    // so that we can avoid this hack.
    window.setTimeout(function () {
        this.inputElement_.blur();
    }.bind(this), this.Constant_.TINY_TIMEOUT);
};
// Public methods.
/**
   * Check the components disabled state.
   *
   * @public
   */
MaterialSwitch.prototype.checkDisabled = function () {
    if (this.inputElement_.disabled) {
        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    }
};
MaterialSwitch.prototype['checkDisabled'] = MaterialSwitch.prototype.checkDisabled;
/**
   * Check the components toggled state.
   *
   * @public
   */
MaterialSwitch.prototype.checkToggleState = function () {
    if (this.inputElement_.checked) {
        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
    }
};
MaterialSwitch.prototype['checkToggleState'] = MaterialSwitch.prototype.checkToggleState;
/**
   * Disable switch.
   *
   * @public
   */
MaterialSwitch.prototype.disable = function () {
    this.inputElement_.disabled = true;
    this.updateClasses_();
};
MaterialSwitch.prototype['disable'] = MaterialSwitch.prototype.disable;
/**
   * Enable switch.
   *
   * @public
   */
MaterialSwitch.prototype.enable = function () {
    this.inputElement_.disabled = false;
    this.updateClasses_();
};
MaterialSwitch.prototype['enable'] = MaterialSwitch.prototype.enable;
/**
   * Activate switch.
   *
   * @public
   */
MaterialSwitch.prototype.on = function () {
    this.inputElement_.checked = true;
    this.updateClasses_();
};
MaterialSwitch.prototype['on'] = MaterialSwitch.prototype.on;
/**
   * Deactivate switch.
   *
   * @public
   */
MaterialSwitch.prototype.off = function () {
    this.inputElement_.checked = false;
    this.updateClasses_();
};
MaterialSwitch.prototype['off'] = MaterialSwitch.prototype.off;
/**
   * Initialize element.
   */
MaterialSwitch.prototype.init = function () {
    if (this.element_) {
        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
        var track = document.createElement('div');
        track.classList.add(this.CssClasses_.TRACK);
        var thumb = document.createElement('div');
        thumb.classList.add(this.CssClasses_.THUMB);
        var focusHelper = document.createElement('span');
        focusHelper.classList.add(this.CssClasses_.FOCUS_HELPER);
        thumb.appendChild(focusHelper);
        this.element_.appendChild(track);
        this.element_.appendChild(thumb);
        this.boundMouseUpHandler = this.onMouseUp_.bind(this);
        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
            this.rippleContainerElement_ = document.createElement('span');
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
            this.rippleContainerElement_.addEventListener('mouseup', this.boundMouseUpHandler);
            var ripple = document.createElement('span');
            ripple.classList.add(this.CssClasses_.RIPPLE);
            this.rippleContainerElement_.appendChild(ripple);
            this.element_.appendChild(this.rippleContainerElement_);
        }
        this.boundChangeHandler = this.onChange_.bind(this);
        this.boundFocusHandler = this.onFocus_.bind(this);
        this.boundBlurHandler = this.onBlur_.bind(this);
        this.inputElement_.addEventListener('change', this.boundChangeHandler);
        this.inputElement_.addEventListener('focus', this.boundFocusHandler);
        this.inputElement_.addEventListener('blur', this.boundBlurHandler);
        this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
        this.updateClasses_();
        this.element_.classList.add('is-upgraded');
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialSwitch,
    classAsString: 'MaterialSwitch',
    cssClass: 'mdl-js-switch',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Tabs MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {Element} element The element that will be upgraded.
   */
var MaterialTabs = function MaterialTabs(element) {
    // Stores the HTML element.
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialTabs'] = MaterialTabs;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string}
   * @private
   */
MaterialTabs.prototype.Constant_ = {};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialTabs.prototype.CssClasses_ = {
    TAB_CLASS: 'mdl-tabs__tab',
    PANEL_CLASS: 'mdl-tabs__panel',
    ACTIVE_CLASS: 'is-active',
    UPGRADED_CLASS: 'is-upgraded',
    MDL_JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    MDL_RIPPLE_CONTAINER: 'mdl-tabs__ripple-container',
    MDL_RIPPLE: 'mdl-ripple',
    MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events'
};
/**
   * Handle clicks to a tabs component
   *
   * @private
   */
MaterialTabs.prototype.initTabs_ = function () {
    if (this.element_.classList.contains(this.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
        this.element_.classList.add(this.CssClasses_.MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS);
    }
    // Select element tabs, document panels
    this.tabs_ = this.element_.querySelectorAll('.' + this.CssClasses_.TAB_CLASS);
    this.panels_ = this.element_.querySelectorAll('.' + this.CssClasses_.PANEL_CLASS);
    // Create new tabs for each tab element
    for (var i = 0; i < this.tabs_.length; i++) {
        new MaterialTab(this.tabs_[i], this);
    }
    this.element_.classList.add(this.CssClasses_.UPGRADED_CLASS);
};
/**
   * Reset tab state, dropping active classes
   *
   * @private
   */
MaterialTabs.prototype.resetTabState_ = function () {
    for (var k = 0; k < this.tabs_.length; k++) {
        this.tabs_[k].classList.remove(this.CssClasses_.ACTIVE_CLASS);
    }
};
/**
   * Reset panel state, droping active classes
   *
   * @private
   */
MaterialTabs.prototype.resetPanelState_ = function () {
    for (var j = 0; j < this.panels_.length; j++) {
        this.panels_[j].classList.remove(this.CssClasses_.ACTIVE_CLASS);
    }
};
/**
   * Initialize element.
   */
MaterialTabs.prototype.init = function () {
    if (this.element_) {
        this.initTabs_();
    }
};
/**
   * Constructor for an individual tab.
   *
   * @constructor
   * @param {Element} tab The HTML element for the tab.
   * @param {MaterialTabs} ctx The MaterialTabs object that owns the tab.
   */
function MaterialTab(tab, ctx) {
    if (tab) {
        if (ctx.element_.classList.contains(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
            var rippleContainer = document.createElement('span');
            rippleContainer.classList.add(ctx.CssClasses_.MDL_RIPPLE_CONTAINER);
            rippleContainer.classList.add(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT);
            var ripple = document.createElement('span');
            ripple.classList.add(ctx.CssClasses_.MDL_RIPPLE);
            rippleContainer.appendChild(ripple);
            tab.appendChild(rippleContainer);
        }
        tab.addEventListener('click', function (e) {
            if (tab.getAttribute('href').charAt(0) === '#') {
                e.preventDefault();
                var href = tab.href.split('#')[1];
                var panel = ctx.element_.querySelector('#' + href);
                ctx.resetTabState_();
                ctx.resetPanelState_();
                tab.classList.add(ctx.CssClasses_.ACTIVE_CLASS);
                panel.classList.add(ctx.CssClasses_.ACTIVE_CLASS);
            }
        });
    }
}
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialTabs,
    classAsString: 'MaterialTabs',
    cssClass: 'mdl-js-tabs'
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Textfield MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialTextfield = function MaterialTextfield(element) {
    this.element_ = element;
    this.maxRows = this.Constant_.NO_MAX_ROWS;
    // Initialize instance.
    this.init();
};
window['MaterialTextfield'] = MaterialTextfield;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialTextfield.prototype.Constant_ = {
    NO_MAX_ROWS: -1,
    MAX_ROWS_ATTRIBUTE: 'maxrows'
};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialTextfield.prototype.CssClasses_ = {
    LABEL: 'mdl-textfield__label',
    INPUT: 'mdl-textfield__input',
    IS_DIRTY: 'is-dirty',
    IS_FOCUSED: 'is-focused',
    IS_DISABLED: 'is-disabled',
    IS_INVALID: 'is-invalid',
    IS_UPGRADED: 'is-upgraded',
    HAS_PLACEHOLDER: 'has-placeholder'
};
/**
   * Handle input being entered.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialTextfield.prototype.onKeyDown_ = function (event) {
    var currentRowCount = event.target.value.split('\n').length;
    if (event.keyCode === 13) {
        if (currentRowCount >= this.maxRows) {
            event.preventDefault();
        }
    }
};
/**
   * Handle focus.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialTextfield.prototype.onFocus_ = function (event) {
    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle lost focus.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialTextfield.prototype.onBlur_ = function (event) {
    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
};
/**
   * Handle reset event from out side.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialTextfield.prototype.onReset_ = function (event) {
    this.updateClasses_();
};
/**
   * Handle class updates.
   *
   * @private
   */
MaterialTextfield.prototype.updateClasses_ = function () {
    this.checkDisabled();
    this.checkValidity();
    this.checkDirty();
    this.checkFocus();
};
// Public methods.
/**
   * Check the disabled state and update field accordingly.
   *
   * @public
   */
MaterialTextfield.prototype.checkDisabled = function () {
    if (this.input_.disabled) {
        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    }
};
MaterialTextfield.prototype['checkDisabled'] = MaterialTextfield.prototype.checkDisabled;
/**
  * Check the focus state and update field accordingly.
  *
  * @public
  */
MaterialTextfield.prototype.checkFocus = function () {
    if (Boolean(this.element_.querySelector(':focus'))) {
        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
    }
};
MaterialTextfield.prototype['checkFocus'] = MaterialTextfield.prototype.checkFocus;
/**
   * Check the validity state and update field accordingly.
   *
   * @public
   */
MaterialTextfield.prototype.checkValidity = function () {
    if (this.input_.validity) {
        if (this.input_.validity.valid) {
            this.element_.classList.remove(this.CssClasses_.IS_INVALID);
        } else {
            this.element_.classList.add(this.CssClasses_.IS_INVALID);
        }
    }
};
MaterialTextfield.prototype['checkValidity'] = MaterialTextfield.prototype.checkValidity;
/**
   * Check the dirty state and update field accordingly.
   *
   * @public
   */
MaterialTextfield.prototype.checkDirty = function () {
    if (this.input_.value && this.input_.value.length > 0) {
        this.element_.classList.add(this.CssClasses_.IS_DIRTY);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_DIRTY);
    }
};
MaterialTextfield.prototype['checkDirty'] = MaterialTextfield.prototype.checkDirty;
/**
   * Disable text field.
   *
   * @public
   */
MaterialTextfield.prototype.disable = function () {
    this.input_.disabled = true;
    this.updateClasses_();
};
MaterialTextfield.prototype['disable'] = MaterialTextfield.prototype.disable;
/**
   * Enable text field.
   *
   * @public
   */
MaterialTextfield.prototype.enable = function () {
    this.input_.disabled = false;
    this.updateClasses_();
};
MaterialTextfield.prototype['enable'] = MaterialTextfield.prototype.enable;
/**
   * Update text field value.
   *
   * @param {string} value The value to which to set the control (optional).
   * @public
   */
MaterialTextfield.prototype.change = function (value) {
    this.input_.value = value || '';
    this.updateClasses_();
};
MaterialTextfield.prototype['change'] = MaterialTextfield.prototype.change;
/**
   * Initialize element.
   */
MaterialTextfield.prototype.init = function () {
    if (this.element_) {
        this.label_ = this.element_.querySelector('.' + this.CssClasses_.LABEL);
        this.input_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
        if (this.input_) {
            if (this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)) {
                this.maxRows = parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE), 10);
                if (isNaN(this.maxRows)) {
                    this.maxRows = this.Constant_.NO_MAX_ROWS;
                }
            }
            if (this.input_.hasAttribute('placeholder')) {
                this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);
            }
            this.boundUpdateClassesHandler = this.updateClasses_.bind(this);
            this.boundFocusHandler = this.onFocus_.bind(this);
            this.boundBlurHandler = this.onBlur_.bind(this);
            this.boundResetHandler = this.onReset_.bind(this);
            this.input_.addEventListener('input', this.boundUpdateClassesHandler);
            this.input_.addEventListener('focus', this.boundFocusHandler);
            this.input_.addEventListener('blur', this.boundBlurHandler);
            this.input_.addEventListener('reset', this.boundResetHandler);
            if (this.maxRows !== this.Constant_.NO_MAX_ROWS) {
                // TODO: This should handle pasting multi line text.
                // Currently doesn't.
                this.boundKeyDownHandler = this.onKeyDown_.bind(this);
                this.input_.addEventListener('keydown', this.boundKeyDownHandler);
            }
            var invalid = this.element_.classList.contains(this.CssClasses_.IS_INVALID);
            this.updateClasses_();
            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
            if (invalid) {
                this.element_.classList.add(this.CssClasses_.IS_INVALID);
            }
            if (this.input_.hasAttribute('autofocus')) {
                this.element_.focus();
                this.checkFocus();
            }
        }
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialTextfield,
    classAsString: 'MaterialTextfield',
    cssClass: 'mdl-js-textfield',
    widget: true
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Tooltip MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialTooltip = function MaterialTooltip(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialTooltip'] = MaterialTooltip;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialTooltip.prototype.Constant_ = {};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialTooltip.prototype.CssClasses_ = {
    IS_ACTIVE: 'is-active',
    BOTTOM: 'mdl-tooltip--bottom',
    LEFT: 'mdl-tooltip--left',
    RIGHT: 'mdl-tooltip--right',
    TOP: 'mdl-tooltip--top'
};
/**
   * Handle mouseenter for tooltip.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialTooltip.prototype.handleMouseEnter_ = function (event) {
    var props = event.target.getBoundingClientRect();
    var left = props.left + props.width / 2;
    var top = props.top + props.height / 2;
    var marginLeft = -1 * (this.element_.offsetWidth / 2);
    var marginTop = -1 * (this.element_.offsetHeight / 2);
    if (this.element_.classList.contains(this.CssClasses_.LEFT) || this.element_.classList.contains(this.CssClasses_.RIGHT)) {
        left = props.width / 2;
        if (top + marginTop < 0) {
            this.element_.style.top = '0';
            this.element_.style.marginTop = '0';
        } else {
            this.element_.style.top = top + 'px';
            this.element_.style.marginTop = marginTop + 'px';
        }
    } else {
        if (left + marginLeft < 0) {
            this.element_.style.left = '0';
            this.element_.style.marginLeft = '0';
        } else {
            this.element_.style.left = left + 'px';
            this.element_.style.marginLeft = marginLeft + 'px';
        }
    }
    if (this.element_.classList.contains(this.CssClasses_.TOP)) {
        this.element_.style.top = props.top - this.element_.offsetHeight - 10 + 'px';
    } else if (this.element_.classList.contains(this.CssClasses_.RIGHT)) {
        this.element_.style.left = props.left + props.width + 10 + 'px';
    } else if (this.element_.classList.contains(this.CssClasses_.LEFT)) {
        this.element_.style.left = props.left - this.element_.offsetWidth - 10 + 'px';
    } else {
        this.element_.style.top = props.top + props.height + 10 + 'px';
    }
    this.element_.classList.add(this.CssClasses_.IS_ACTIVE);
};
/**
   * Hide tooltip on mouseleave or scroll
   *
   * @private
   */
MaterialTooltip.prototype.hideTooltip_ = function () {
    this.element_.classList.remove(this.CssClasses_.IS_ACTIVE);
};
/**
   * Initialize element.
   */
MaterialTooltip.prototype.init = function () {
    if (this.element_) {
        var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
        if (forElId) {
            this.forElement_ = document.getElementById(forElId);
        }
        if (this.forElement_) {
            // It's left here because it prevents accidental text selection on Android
            if (!this.forElement_.hasAttribute('tabindex')) {
                this.forElement_.setAttribute('tabindex', '0');
            }
            this.boundMouseEnterHandler = this.handleMouseEnter_.bind(this);
            this.boundMouseLeaveAndScrollHandler = this.hideTooltip_.bind(this);
            this.forElement_.addEventListener('mouseenter', this.boundMouseEnterHandler, false);
            this.forElement_.addEventListener('touchend', this.boundMouseEnterHandler, false);
            this.forElement_.addEventListener('mouseleave', this.boundMouseLeaveAndScrollHandler, false);
            window.addEventListener('scroll', this.boundMouseLeaveAndScrollHandler, true);
            window.addEventListener('touchstart', this.boundMouseLeaveAndScrollHandler);
        }
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialTooltip,
    classAsString: 'MaterialTooltip',
    cssClass: 'mdl-tooltip'
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Layout MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialLayout = function MaterialLayout(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialLayout'] = MaterialLayout;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialLayout.prototype.Constant_ = {
    MAX_WIDTH: '(max-width: 1024px)',
    TAB_SCROLL_PIXELS: 100,
    RESIZE_TIMEOUT: 100,
    MENU_ICON: '&#xE5D2;',
    CHEVRON_LEFT: 'chevron_left',
    CHEVRON_RIGHT: 'chevron_right'
};
/**
   * Keycodes, for code readability.
   *
   * @enum {number}
   * @private
   */
MaterialLayout.prototype.Keycodes_ = {
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32
};
/**
   * Modes.
   *
   * @enum {number}
   * @private
   */
MaterialLayout.prototype.Mode_ = {
    STANDARD: 0,
    SEAMED: 1,
    WATERFALL: 2,
    SCROLL: 3
};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialLayout.prototype.CssClasses_ = {
    CONTAINER: 'mdl-layout__container',
    HEADER: 'mdl-layout__header',
    DRAWER: 'mdl-layout__drawer',
    CONTENT: 'mdl-layout__content',
    DRAWER_BTN: 'mdl-layout__drawer-button',
    ICON: 'material-icons',
    JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
    RIPPLE_CONTAINER: 'mdl-layout__tab-ripple-container',
    RIPPLE: 'mdl-ripple',
    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    HEADER_SEAMED: 'mdl-layout__header--seamed',
    HEADER_WATERFALL: 'mdl-layout__header--waterfall',
    HEADER_SCROLL: 'mdl-layout__header--scroll',
    FIXED_HEADER: 'mdl-layout--fixed-header',
    OBFUSCATOR: 'mdl-layout__obfuscator',
    TAB_BAR: 'mdl-layout__tab-bar',
    TAB_CONTAINER: 'mdl-layout__tab-bar-container',
    TAB: 'mdl-layout__tab',
    TAB_BAR_BUTTON: 'mdl-layout__tab-bar-button',
    TAB_BAR_LEFT_BUTTON: 'mdl-layout__tab-bar-left-button',
    TAB_BAR_RIGHT_BUTTON: 'mdl-layout__tab-bar-right-button',
    TAB_MANUAL_SWITCH: 'mdl-layout__tab-manual-switch',
    PANEL: 'mdl-layout__tab-panel',
    HAS_DRAWER: 'has-drawer',
    HAS_TABS: 'has-tabs',
    HAS_SCROLLING_HEADER: 'has-scrolling-header',
    CASTING_SHADOW: 'is-casting-shadow',
    IS_COMPACT: 'is-compact',
    IS_SMALL_SCREEN: 'is-small-screen',
    IS_DRAWER_OPEN: 'is-visible',
    IS_ACTIVE: 'is-active',
    IS_UPGRADED: 'is-upgraded',
    IS_ANIMATING: 'is-animating',
    ON_LARGE_SCREEN: 'mdl-layout--large-screen-only',
    ON_SMALL_SCREEN: 'mdl-layout--small-screen-only'
};
/**
   * Handles scrolling on the content.
   *
   * @private
   */
MaterialLayout.prototype.contentScrollHandler_ = function () {
    if (this.header_.classList.contains(this.CssClasses_.IS_ANIMATING)) {
        return;
    }
    var headerVisible = !this.element_.classList.contains(this.CssClasses_.IS_SMALL_SCREEN) || this.element_.classList.contains(this.CssClasses_.FIXED_HEADER);
    if (this.content_.scrollTop > 0 && !this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
        this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
        this.header_.classList.add(this.CssClasses_.IS_COMPACT);
        if (headerVisible) {
            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
        }
    } else if (this.content_.scrollTop <= 0 && this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
        this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
        this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
        if (headerVisible) {
            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
        }
    }
};
/**
   * Handles a keyboard event on the drawer.
   *
   * @param {Event} evt The event that fired.
   * @private
   */
MaterialLayout.prototype.keyboardEventHandler_ = function (evt) {
    // Only react when the drawer is open.
    if (evt.keyCode === this.Keycodes_.ESCAPE && this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
        this.toggleDrawer();
    }
};
/**
   * Handles changes in screen size.
   *
   * @private
   */
MaterialLayout.prototype.screenSizeHandler_ = function () {
    if (this.screenSizeMediaQuery_.matches) {
        this.element_.classList.add(this.CssClasses_.IS_SMALL_SCREEN);
    } else {
        this.element_.classList.remove(this.CssClasses_.IS_SMALL_SCREEN);
        // Collapse drawer (if any) when moving to a large screen size.
        if (this.drawer_) {
            this.drawer_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
            this.obfuscator_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
        }
    }
};
/**
   * Handles events of drawer button.
   *
   * @param {Event} evt The event that fired.
   * @private
   */
MaterialLayout.prototype.drawerToggleHandler_ = function (evt) {
    if (evt && evt.type === 'keydown') {
        if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
            // prevent scrolling in drawer nav
            evt.preventDefault();
        } else {
            // prevent other keys
            return;
        }
    }
    this.toggleDrawer();
};
/**
   * Handles (un)setting the `is-animating` class
   *
   * @private
   */
MaterialLayout.prototype.headerTransitionEndHandler_ = function () {
    this.header_.classList.remove(this.CssClasses_.IS_ANIMATING);
};
/**
   * Handles expanding the header on click
   *
   * @private
   */
MaterialLayout.prototype.headerClickHandler_ = function () {
    if (this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
        this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
        this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
    }
};
/**
   * Reset tab state, dropping active classes
   *
   * @private
   */
MaterialLayout.prototype.resetTabState_ = function (tabBar) {
    for (var k = 0; k < tabBar.length; k++) {
        tabBar[k].classList.remove(this.CssClasses_.IS_ACTIVE);
    }
};
/**
   * Reset panel state, droping active classes
   *
   * @private
   */
MaterialLayout.prototype.resetPanelState_ = function (panels) {
    for (var j = 0; j < panels.length; j++) {
        panels[j].classList.remove(this.CssClasses_.IS_ACTIVE);
    }
};
/**
  * Toggle drawer state
  *
  * @public
  */
MaterialLayout.prototype.toggleDrawer = function () {
    var drawerButton = this.element_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
    this.drawer_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
    this.obfuscator_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
    // Set accessibility properties.
    if (this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
        this.drawer_.setAttribute('aria-hidden', 'false');
        drawerButton.setAttribute('aria-expanded', 'true');
    } else {
        this.drawer_.setAttribute('aria-hidden', 'true');
        drawerButton.setAttribute('aria-expanded', 'false');
    }
};
MaterialLayout.prototype['toggleDrawer'] = MaterialLayout.prototype.toggleDrawer;
/**
   * Initialize element.
   */
MaterialLayout.prototype.init = function () {
    if (this.element_) {
        var container = document.createElement('div');
        container.classList.add(this.CssClasses_.CONTAINER);
        var focusedElement = this.element_.querySelector(':focus');
        this.element_.parentElement.insertBefore(container, this.element_);
        this.element_.parentElement.removeChild(this.element_);
        container.appendChild(this.element_);
        if (focusedElement) {
            focusedElement.focus();
        }
        var directChildren = this.element_.childNodes;
        var numChildren = directChildren.length;
        for (var c = 0; c < numChildren; c++) {
            var child = directChildren[c];
            if (child.classList && child.classList.contains(this.CssClasses_.HEADER)) {
                this.header_ = child;
            }
            if (child.classList && child.classList.contains(this.CssClasses_.DRAWER)) {
                this.drawer_ = child;
            }
            if (child.classList && child.classList.contains(this.CssClasses_.CONTENT)) {
                this.content_ = child;
            }
        }
        window.addEventListener('pageshow', function (e) {
            if (e.persisted) {
                // when page is loaded from back/forward cache
                // trigger repaint to let layout scroll in safari
                this.element_.style.overflowY = 'hidden';
                requestAnimationFrame(function () {
                    this.element_.style.overflowY = '';
                }.bind(this));
            }
        }.bind(this), false);
        if (this.header_) {
            this.tabBar_ = this.header_.querySelector('.' + this.CssClasses_.TAB_BAR);
        }
        var mode = this.Mode_.STANDARD;
        if (this.header_) {
            if (this.header_.classList.contains(this.CssClasses_.HEADER_SEAMED)) {
                mode = this.Mode_.SEAMED;
            } else if (this.header_.classList.contains(this.CssClasses_.HEADER_WATERFALL)) {
                mode = this.Mode_.WATERFALL;
                this.header_.addEventListener('transitionend', this.headerTransitionEndHandler_.bind(this));
                this.header_.addEventListener('click', this.headerClickHandler_.bind(this));
            } else if (this.header_.classList.contains(this.CssClasses_.HEADER_SCROLL)) {
                mode = this.Mode_.SCROLL;
                container.classList.add(this.CssClasses_.HAS_SCROLLING_HEADER);
            }
            if (mode === this.Mode_.STANDARD) {
                this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
                if (this.tabBar_) {
                    this.tabBar_.classList.add(this.CssClasses_.CASTING_SHADOW);
                }
            } else if (mode === this.Mode_.SEAMED || mode === this.Mode_.SCROLL) {
                this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
                if (this.tabBar_) {
                    this.tabBar_.classList.remove(this.CssClasses_.CASTING_SHADOW);
                }
            } else if (mode === this.Mode_.WATERFALL) {
                // Add and remove shadows depending on scroll position.
                // Also add/remove auxiliary class for styling of the compact version of
                // the header.
                this.content_.addEventListener('scroll', this.contentScrollHandler_.bind(this));
                this.contentScrollHandler_();
            }
        }
        // Add drawer toggling button to our layout, if we have an openable drawer.
        if (this.drawer_) {
            var drawerButton = this.element_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
            if (!drawerButton) {
                drawerButton = document.createElement('div');
                drawerButton.setAttribute('aria-expanded', 'false');
                drawerButton.setAttribute('role', 'button');
                drawerButton.setAttribute('tabindex', '0');
                drawerButton.classList.add(this.CssClasses_.DRAWER_BTN);
                var drawerButtonIcon = document.createElement('i');
                drawerButtonIcon.classList.add(this.CssClasses_.ICON);
                drawerButtonIcon.innerHTML = this.Constant_.MENU_ICON;
                drawerButton.appendChild(drawerButtonIcon);
            }
            if (this.drawer_.classList.contains(this.CssClasses_.ON_LARGE_SCREEN)) {
                //If drawer has ON_LARGE_SCREEN class then add it to the drawer toggle button as well.
                drawerButton.classList.add(this.CssClasses_.ON_LARGE_SCREEN);
            } else if (this.drawer_.classList.contains(this.CssClasses_.ON_SMALL_SCREEN)) {
                //If drawer has ON_SMALL_SCREEN class then add it to the drawer toggle button as well.
                drawerButton.classList.add(this.CssClasses_.ON_SMALL_SCREEN);
            }
            drawerButton.addEventListener('click', this.drawerToggleHandler_.bind(this));
            drawerButton.addEventListener('keydown', this.drawerToggleHandler_.bind(this));
            // Add a class if the layout has a drawer, for altering the left padding.
            // Adds the HAS_DRAWER to the elements since this.header_ may or may
            // not be present.
            this.element_.classList.add(this.CssClasses_.HAS_DRAWER);
            // If we have a fixed header, add the button to the header rather than
            // the layout.
            if (this.element_.classList.contains(this.CssClasses_.FIXED_HEADER)) {
                this.header_.insertBefore(drawerButton, this.header_.firstChild);
            } else {
                this.element_.insertBefore(drawerButton, this.content_);
            }
            var obfuscator = document.createElement('div');
            obfuscator.classList.add(this.CssClasses_.OBFUSCATOR);
            this.element_.appendChild(obfuscator);
            obfuscator.addEventListener('click', this.drawerToggleHandler_.bind(this));
            this.obfuscator_ = obfuscator;
            this.drawer_.addEventListener('keydown', this.keyboardEventHandler_.bind(this));
            this.drawer_.setAttribute('aria-hidden', 'true');
        }
        // Keep an eye on screen size, and add/remove auxiliary class for styling
        // of small screens.
        this.screenSizeMediaQuery_ = window.matchMedia(this.Constant_.MAX_WIDTH);
        this.screenSizeMediaQuery_.addListener(this.screenSizeHandler_.bind(this));
        this.screenSizeHandler_();
        // Initialize tabs, if any.
        if (this.header_ && this.tabBar_) {
            this.element_.classList.add(this.CssClasses_.HAS_TABS);
            var tabContainer = document.createElement('div');
            tabContainer.classList.add(this.CssClasses_.TAB_CONTAINER);
            this.header_.insertBefore(tabContainer, this.tabBar_);
            this.header_.removeChild(this.tabBar_);
            var leftButton = document.createElement('div');
            leftButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
            leftButton.classList.add(this.CssClasses_.TAB_BAR_LEFT_BUTTON);
            var leftButtonIcon = document.createElement('i');
            leftButtonIcon.classList.add(this.CssClasses_.ICON);
            leftButtonIcon.textContent = this.Constant_.CHEVRON_LEFT;
            leftButton.appendChild(leftButtonIcon);
            leftButton.addEventListener('click', function () {
                this.tabBar_.scrollLeft -= this.Constant_.TAB_SCROLL_PIXELS;
            }.bind(this));
            var rightButton = document.createElement('div');
            rightButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
            rightButton.classList.add(this.CssClasses_.TAB_BAR_RIGHT_BUTTON);
            var rightButtonIcon = document.createElement('i');
            rightButtonIcon.classList.add(this.CssClasses_.ICON);
            rightButtonIcon.textContent = this.Constant_.CHEVRON_RIGHT;
            rightButton.appendChild(rightButtonIcon);
            rightButton.addEventListener('click', function () {
                this.tabBar_.scrollLeft += this.Constant_.TAB_SCROLL_PIXELS;
            }.bind(this));
            tabContainer.appendChild(leftButton);
            tabContainer.appendChild(this.tabBar_);
            tabContainer.appendChild(rightButton);
            // Add and remove tab buttons depending on scroll position and total
            // window size.
            var tabUpdateHandler = function () {
                if (this.tabBar_.scrollLeft > 0) {
                    leftButton.classList.add(this.CssClasses_.IS_ACTIVE);
                } else {
                    leftButton.classList.remove(this.CssClasses_.IS_ACTIVE);
                }
                if (this.tabBar_.scrollLeft < this.tabBar_.scrollWidth - this.tabBar_.offsetWidth) {
                    rightButton.classList.add(this.CssClasses_.IS_ACTIVE);
                } else {
                    rightButton.classList.remove(this.CssClasses_.IS_ACTIVE);
                }
            }.bind(this);
            this.tabBar_.addEventListener('scroll', tabUpdateHandler);
            tabUpdateHandler();
            // Update tabs when the window resizes.
            var windowResizeHandler = function () {
                // Use timeouts to make sure it doesn't happen too often.
                if (this.resizeTimeoutId_) {
                    clearTimeout(this.resizeTimeoutId_);
                }
                this.resizeTimeoutId_ = setTimeout(function () {
                    tabUpdateHandler();
                    this.resizeTimeoutId_ = null;
                }.bind(this), this.Constant_.RESIZE_TIMEOUT);
            }.bind(this);
            window.addEventListener('resize', windowResizeHandler);
            if (this.tabBar_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
                this.tabBar_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
            }
            // Select element tabs, document panels
            var tabs = this.tabBar_.querySelectorAll('.' + this.CssClasses_.TAB);
            var panels = this.content_.querySelectorAll('.' + this.CssClasses_.PANEL);
            // Create new tabs for each tab element
            for (var i = 0; i < tabs.length; i++) {
                new MaterialLayoutTab(tabs[i], tabs, panels, this);
            }
        }
        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
    }
};
/**
   * Constructor for an individual tab.
   *
   * @constructor
   * @param {HTMLElement} tab The HTML element for the tab.
   * @param {!Array<HTMLElement>} tabs Array with HTML elements for all tabs.
   * @param {!Array<HTMLElement>} panels Array with HTML elements for all panels.
   * @param {MaterialLayout} layout The MaterialLayout object that owns the tab.
   */
function MaterialLayoutTab(tab, tabs, panels, layout) {
    /**
     * Auxiliary method to programmatically select a tab in the UI.
     */
    function selectTab() {
        var href = tab.href.split('#')[1];
        var panel = layout.content_.querySelector('#' + href);
        layout.resetTabState_(tabs);
        layout.resetPanelState_(panels);
        tab.classList.add(layout.CssClasses_.IS_ACTIVE);
        panel.classList.add(layout.CssClasses_.IS_ACTIVE);
    }
    if (layout.tabBar_.classList.contains(layout.CssClasses_.JS_RIPPLE_EFFECT)) {
        var rippleContainer = document.createElement('span');
        rippleContainer.classList.add(layout.CssClasses_.RIPPLE_CONTAINER);
        rippleContainer.classList.add(layout.CssClasses_.JS_RIPPLE_EFFECT);
        var ripple = document.createElement('span');
        ripple.classList.add(layout.CssClasses_.RIPPLE);
        rippleContainer.appendChild(ripple);
        tab.appendChild(rippleContainer);
    }
    if (!layout.tabBar_.classList.contains(layout.CssClasses_.TAB_MANUAL_SWITCH)) {
        tab.addEventListener('click', function (e) {
            if (tab.getAttribute('href').charAt(0) === '#') {
                e.preventDefault();
                selectTab();
            }
        });
    }
    tab.show = selectTab;
}
window['MaterialLayoutTab'] = MaterialLayoutTab;
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialLayout,
    classAsString: 'MaterialLayout',
    cssClass: 'mdl-js-layout'
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Data Table Card MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {Element} element The element that will be upgraded.
   */
var MaterialDataTable = function MaterialDataTable(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialDataTable'] = MaterialDataTable;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialDataTable.prototype.Constant_ = {};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialDataTable.prototype.CssClasses_ = {
    DATA_TABLE: 'mdl-data-table',
    SELECTABLE: 'mdl-data-table--selectable',
    SELECT_ELEMENT: 'mdl-data-table__select',
    IS_SELECTED: 'is-selected',
    IS_UPGRADED: 'is-upgraded'
};
/**
   * Generates and returns a function that toggles the selection state of a
   * single row (or multiple rows).
   *
   * @param {Element} checkbox Checkbox that toggles the selection state.
   * @param {Element} row Row to toggle when checkbox changes.
   * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
   * @private
   */
MaterialDataTable.prototype.selectRow_ = function (checkbox, row, opt_rows) {
    if (row) {
        return function () {
            if (checkbox.checked) {
                row.classList.add(this.CssClasses_.IS_SELECTED);
            } else {
                row.classList.remove(this.CssClasses_.IS_SELECTED);
            }
        }.bind(this);
    }
    if (opt_rows) {
        return function () {
            var i;
            var el;
            if (checkbox.checked) {
                for (i = 0; i < opt_rows.length; i++) {
                    el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
                    el['MaterialCheckbox'].check();
                    opt_rows[i].classList.add(this.CssClasses_.IS_SELECTED);
                }
            } else {
                for (i = 0; i < opt_rows.length; i++) {
                    el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
                    el['MaterialCheckbox'].uncheck();
                    opt_rows[i].classList.remove(this.CssClasses_.IS_SELECTED);
                }
            }
        }.bind(this);
    }
};
/**
   * Creates a checkbox for a single or or multiple rows and hooks up the
   * event handling.
   *
   * @param {Element} row Row to toggle when checkbox changes.
   * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
   * @private
   */
MaterialDataTable.prototype.createCheckbox_ = function (row, opt_rows) {
    var label = document.createElement('label');
    var labelClasses = [
        'mdl-checkbox',
        'mdl-js-checkbox',
        'mdl-js-ripple-effect',
        this.CssClasses_.SELECT_ELEMENT
    ];
    label.className = labelClasses.join(' ');
    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.classList.add('mdl-checkbox__input');
    if (row) {
        checkbox.checked = row.classList.contains(this.CssClasses_.IS_SELECTED);
        checkbox.addEventListener('change', this.selectRow_(checkbox, row));
    } else if (opt_rows) {
        checkbox.addEventListener('change', this.selectRow_(checkbox, null, opt_rows));
    }
    label.appendChild(checkbox);
    componentHandler.upgradeElement(label, 'MaterialCheckbox');
    return label;
};
/**
   * Initialize element.
   */
MaterialDataTable.prototype.init = function () {
    if (this.element_) {
        var firstHeader = this.element_.querySelector('th');
        var bodyRows = Array.prototype.slice.call(this.element_.querySelectorAll('tbody tr'));
        var footRows = Array.prototype.slice.call(this.element_.querySelectorAll('tfoot tr'));
        var rows = bodyRows.concat(footRows);
        if (this.element_.classList.contains(this.CssClasses_.SELECTABLE)) {
            var th = document.createElement('th');
            var headerCheckbox = this.createCheckbox_(null, rows);
            th.appendChild(headerCheckbox);
            firstHeader.parentElement.insertBefore(th, firstHeader);
            for (var i = 0; i < rows.length; i++) {
                var firstCell = rows[i].querySelector('td');
                if (firstCell) {
                    var td = document.createElement('td');
                    if (rows[i].parentNode.nodeName.toUpperCase() === 'TBODY') {
                        var rowCheckbox = this.createCheckbox_(rows[i]);
                        td.appendChild(rowCheckbox);
                    }
                    rows[i].insertBefore(td, firstCell);
                }
            }
            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
        }
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialDataTable,
    classAsString: 'MaterialDataTable',
    cssClass: 'mdl-js-data-table'
});
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
   * Class constructor for Ripple MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */
var MaterialRipple = function MaterialRipple(element) {
    this.element_ = element;
    // Initialize instance.
    this.init();
};
window['MaterialRipple'] = MaterialRipple;
/**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */
MaterialRipple.prototype.Constant_ = {
    INITIAL_SCALE: 'scale(0.0001, 0.0001)',
    INITIAL_SIZE: '1px',
    INITIAL_OPACITY: '0.4',
    FINAL_OPACITY: '0',
    FINAL_SCALE: ''
};
/**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */
MaterialRipple.prototype.CssClasses_ = {
    RIPPLE_CENTER: 'mdl-ripple--center',
    RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
    RIPPLE: 'mdl-ripple',
    IS_ANIMATING: 'is-animating',
    IS_VISIBLE: 'is-visible'
};
/**
   * Handle mouse / finger down on element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialRipple.prototype.downHandler_ = function (event) {
    if (!this.rippleElement_.style.width && !this.rippleElement_.style.height) {
        var rect = this.element_.getBoundingClientRect();
        this.boundHeight = rect.height;
        this.boundWidth = rect.width;
        this.rippleSize_ = Math.sqrt(rect.width * rect.width + rect.height * rect.height) * 2 + 2;
        this.rippleElement_.style.width = this.rippleSize_ + 'px';
        this.rippleElement_.style.height = this.rippleSize_ + 'px';
    }
    this.rippleElement_.classList.add(this.CssClasses_.IS_VISIBLE);
    if (event.type === 'mousedown' && this.ignoringMouseDown_) {
        this.ignoringMouseDown_ = false;
    } else {
        if (event.type === 'touchstart') {
            this.ignoringMouseDown_ = true;
        }
        var frameCount = this.getFrameCount();
        if (frameCount > 0) {
            return;
        }
        this.setFrameCount(1);
        var bound = event.currentTarget.getBoundingClientRect();
        var x;
        var y;
        // Check if we are handling a keyboard click.
        if (event.clientX === 0 && event.clientY === 0) {
            x = Math.round(bound.width / 2);
            y = Math.round(bound.height / 2);
        } else {
            var clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
            var clientY = event.clientY !== undefined ? event.clientY : event.touches[0].clientY;
            x = Math.round(clientX - bound.left);
            y = Math.round(clientY - bound.top);
        }
        this.setRippleXY(x, y);
        this.setRippleStyles(true);
        window.requestAnimationFrame(this.animFrameHandler.bind(this));
    }
};
/**
   * Handle mouse / finger up on element.
   *
   * @param {Event} event The event that fired.
   * @private
   */
MaterialRipple.prototype.upHandler_ = function (event) {
    // Don't fire for the artificial "mouseup" generated by a double-click.
    if (event && event.detail !== 2) {
        // Allow a repaint to occur before removing this class, so the animation
        // shows for tap events, which seem to trigger a mouseup too soon after
        // mousedown.
        window.setTimeout(function () {
            this.rippleElement_.classList.remove(this.CssClasses_.IS_VISIBLE);
        }.bind(this), 0);
    }
};
/**
   * Initialize element.
   */
MaterialRipple.prototype.init = function () {
    if (this.element_) {
        var recentering = this.element_.classList.contains(this.CssClasses_.RIPPLE_CENTER);
        if (!this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT_IGNORE_EVENTS)) {
            this.rippleElement_ = this.element_.querySelector('.' + this.CssClasses_.RIPPLE);
            this.frameCount_ = 0;
            this.rippleSize_ = 0;
            this.x_ = 0;
            this.y_ = 0;
            // Touch start produces a compat mouse down event, which would cause a
            // second ripples. To avoid that, we use this property to ignore the first
            // mouse down after a touch start.
            this.ignoringMouseDown_ = false;
            this.boundDownHandler = this.downHandler_.bind(this);
            this.element_.addEventListener('mousedown', this.boundDownHandler);
            this.element_.addEventListener('touchstart', this.boundDownHandler);
            this.boundUpHandler = this.upHandler_.bind(this);
            this.element_.addEventListener('mouseup', this.boundUpHandler);
            this.element_.addEventListener('mouseleave', this.boundUpHandler);
            this.element_.addEventListener('touchend', this.boundUpHandler);
            this.element_.addEventListener('blur', this.boundUpHandler);
            /**
         * Getter for frameCount_.
         * @return {number} the frame count.
         */
            this.getFrameCount = function () {
                return this.frameCount_;
            };
            /**
         * Setter for frameCount_.
         * @param {number} fC the frame count.
         */
            this.setFrameCount = function (fC) {
                this.frameCount_ = fC;
            };
            /**
         * Getter for rippleElement_.
         * @return {Element} the ripple element.
         */
            this.getRippleElement = function () {
                return this.rippleElement_;
            };
            /**
         * Sets the ripple X and Y coordinates.
         * @param  {number} newX the new X coordinate
         * @param  {number} newY the new Y coordinate
         */
            this.setRippleXY = function (newX, newY) {
                this.x_ = newX;
                this.y_ = newY;
            };
            /**
         * Sets the ripple styles.
         * @param  {boolean} start whether or not this is the start frame.
         */
            this.setRippleStyles = function (start) {
                if (this.rippleElement_ !== null) {
                    var transformString;
                    var scale;
                    var size;
                    var offset = 'translate(' + this.x_ + 'px, ' + this.y_ + 'px)';
                    if (start) {
                        scale = this.Constant_.INITIAL_SCALE;
                        size = this.Constant_.INITIAL_SIZE;
                    } else {
                        scale = this.Constant_.FINAL_SCALE;
                        size = this.rippleSize_ + 'px';
                        if (recentering) {
                            offset = 'translate(' + this.boundWidth / 2 + 'px, ' + this.boundHeight / 2 + 'px)';
                        }
                    }
                    transformString = 'translate(-50%, -50%) ' + offset + scale;
                    this.rippleElement_.style.webkitTransform = transformString;
                    this.rippleElement_.style.msTransform = transformString;
                    this.rippleElement_.style.transform = transformString;
                    if (start) {
                        this.rippleElement_.classList.remove(this.CssClasses_.IS_ANIMATING);
                    } else {
                        this.rippleElement_.classList.add(this.CssClasses_.IS_ANIMATING);
                    }
                }
            };
            /**
         * Handles an animation frame.
         */
            this.animFrameHandler = function () {
                if (this.frameCount_-- > 0) {
                    window.requestAnimationFrame(this.animFrameHandler.bind(this));
                } else {
                    this.setRippleStyles(false);
                }
            };
        }
    }
};
// The component registers itself. It can assume componentHandler is available
// in the global scope.
componentHandler.register({
    constructor: MaterialRipple,
    classAsString: 'MaterialRipple',
    cssClass: 'mdl-js-ripple-effect',
    widget: false
});
}());


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var appCacheIframe;

function hasSW() {
  return 'serviceWorker' in navigator &&
    // This is how I block Chrome 40 and detect Chrome 41, because first has
    // bugs with history.pustState and/or hashchange
    (window.fetch || 'imageRendering' in document.documentElement.style) &&
    (window.location.protocol === 'https:' || window.location.hostname === 'localhost')
}

function install(options) {
  options || (options = {});

  
    if (hasSW()) {
      var registration = navigator.serviceWorker
        .register(
          "/sw.js"
          
        );

      
        var handleUpdating = function(registration) {
          var sw = registration.installing || registration.waiting;
          var ignoreInstalling;
          var ignoreWaiting;

          // No SW or already handled
          if (!sw || sw.onstatechange) return;

          var stateChangeHandler;

          // Already has SW
          if (registration.active) {
            onUpdateStateChange();
            stateChangeHandler = onUpdateStateChange;
          } else {
            onInstallStateChange();
            stateChangeHandler = onInstallStateChange;
          }

          ignoreInstalling = true;
          if (registration.waiting) {
            ignoreWaiting = true;
          }

          sw.onstatechange = stateChangeHandler;

          function onUpdateStateChange() {
            switch (sw.state) {
              case 'redundant': {
                sendEvent('onUpdateFailed');
                sw.onstatechange = null;
              } break;

              case 'installing': {
                if (!ignoreInstalling) {
                  sendEvent('onUpdating');
                }
              } break;

              case 'installed': {
                if (!ignoreWaiting) {
                  sendEvent('onUpdateReady');
                }
              } break;

              case 'activated': {
                sendEvent('onUpdated');
                sw.onstatechange = null;
              } break;
            }
          }

          function onInstallStateChange() {
            switch (sw.state) {
              case 'redundant': {
                // Failed to install, ignore
                sw.onstatechange = null;
              } break;

              case 'installing': {
                // Installing, ignore
              } break;

              case 'installed': {
                // Installed, wait activation
              } break;

              case 'activated': {
                sendEvent('onInstalled');
                sw.onstatechange = null;
              } break;
            }
          }
        };

        var sendEvent = function(event) {
          if (typeof options[event] === 'function') {
            options[event]({
              source: 'ServiceWorker'
            });
          }
        };

        registration.then(function(reg) {
          // WTF no reg?
          if (!reg) return;

          // Installed but Shift-Reloaded (page is not controller by SW),
          // update might be ready at this point (more than one tab opened).
          // Anyway, if page is hard-reloaded, then it probably already have latest version
          // but it's not controlled by SW yet. Applying update will claim this page
          // to be controlled by SW. Maybe set flag to not reload it?
          // if (!navigator.serviceWorker.controller) return;

          handleUpdating(reg);
          reg.onupdatefound = function() {
            handleUpdating(reg);
          };
        }).catch(function(err) {
          sendEvent('onError');
          return Promise.reject(err);
        });
      

      return;
    }
  

  
    if (window.applicationCache) {
      var directory = "/appcache/";
      var name = "manifest";

      var doLoad = function() {
        var page = directory + name + '.html';
        var iframe = document.createElement('iframe');

        

        iframe.src = page;
        iframe.style.display = 'none';

        appCacheIframe = iframe;
        document.body.appendChild(iframe);
      };

      if (document.readyState === 'complete') {
        setTimeout(doLoad);
      } else {
        window.addEventListener('load', doLoad);
      }

      return;
    }
  
}

function applyUpdate(callback, errback) {
  
    if (hasSW()) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (!registration || !registration.waiting) {
          errback && errback();
          return;
        }

        registration.waiting.postMessage({
          action: 'skipWaiting'
        });

        callback && callback();
      });

      return;
    }
  

  
}

exports.install = install;
exports.applyUpdate = applyUpdate;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _dec, _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _optimizedVisibility = __webpack_require__(22);

var _loadingScreen = __webpack_require__(8);

var _loadingScreen2 = _interopRequireDefault(_loadingScreen);

var _header = __webpack_require__(23);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(27);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

var _wave = __webpack_require__(30);

var _wave2 = _interopRequireDefault(_wave);

var _main = __webpack_require__(31);

var _main2 = _interopRequireDefault(_main);

var _login = __webpack_require__(47);

var _login2 = _interopRequireDefault(_login);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _notify = __webpack_require__(48);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoggedIn = function (_Component) {
	_inherits(LoggedIn, _Component);

	function LoggedIn() {
		_classCallCheck(this, LoggedIn);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	LoggedIn.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	LoggedIn.prototype.componentDidMount = function componentDidMount() {
		(0, _notify.init)();
	};

	LoggedIn.prototype.render = function render() {
		return (0, _preact.h)(
			_preactMdl.Layout,
			{ 'fixed-header': true, js: false },
			(0, _preact.h)(_create2.default, null),
			(0, _preact.h)(_wave2.default, null),
			(0, _preact.h)(_sidebar2.default, null),
			(0, _preact.h)(_header2.default, null),
			(0, _preact.h)(_main2.default, null)
		);
	};

	return LoggedIn;
}(_preact.Component);

var App = (_dec = (0, _decko.debounce)(500), (_class = function (_Component2) {
	_inherits(App, _Component2);

	function App() {
		var _temp, _this2, _ret;

		_classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
			pending: true,
			loggedin: false
		}, _temp), _possibleConstructorReturn(_this2, _ret);
	}

	App.prototype.componentDidMount = function componentDidMount() {
		var _this3 = this;

		_peach2.default.init(function () {
			return _this3.setState({ pending: false });
		});
		_peach2.default.on('login', function () {
			return _this3.setState({ loggedin: true });
		});
		_peach2.default.on('logout', function () {
			return _this3.setState({ loggedin: false });
		});

		(0, _pubsub.on)('update-visibility', this.updateVisibility);

		this.bodyAttr('loaded', true);
		_peach2.default.store.subscribe(this.updateBackground);
		this.updateBackground(_peach2.default.store.getState());
	};

	App.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('update-visibility', this.updateVisibility);
		_peach2.default.store.unsubscribe(this.updateBackground);
	};

	App.prototype.updateVisibility = function updateVisibility() {
		(0, _optimizedVisibility.updateAllVisibility)();
	};

	App.prototype.updateBackground = function updateBackground(_ref) {
		var prefs = _ref.prefs;

		var wb = prefs && prefs.plainBackground || false;
		if (wb !== this.plainBackground) {
			this.plainBackground = wb;
			this.bodyAttr('plain-background', wb);
		}
	};

	App.prototype.bodyAttr = function bodyAttr(key, value) {
		try {
			if (value === false) document.body.removeAttribute(key);else document.body.setAttribute(key, value);
		} catch (err) {}
	};

	App.prototype.render = function render(_ref2, _ref3) {
		var pending = _ref3.pending,
		    loggedin = _ref3.loggedin;

		_objectDestructuringEmpty(_ref2);

		return (0, _preact.h)(
			'div',
			{ id: 'app' },
			pending ? (0, _preact.h)(_loadingScreen2.default, null) : loggedin ? (0, _preact.h)(LoggedIn, null) : (0, _preact.h)(_login2.default, null)
		);
	};

	return App;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'updateVisibility', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'updateVisibility'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateBackground', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'updateBackground'), _class.prototype)), _class));
exports.default = App;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.updateAllVisibility = updateAllVisibility;

//setInterval(update, 5000);

var updateTimer = setTimeout(updateAllVisibility, 100);
var elements = void 0;
var lastUpdated = void 0;
var cache = {};

function updateAllVisibility() {
	clearTimeout(updateTimer);

	var now = Date.now();
	if (!lastUpdated || now - lastUpdated > 1000) {
		lastUpdated = now;
		elements = document.querySelectorAll('[optimized-visibility]');
	}

	cache.wh = window.innerHeight;
	cache.ww = window.innerWidth;

	for (var i = elements.length; i--;) {
		updateVisibility(elements[i]);
	}

	// console.log( [].filter.call(elements, p => p._visible).length + ' of '+elements.length);
	updateTimer = setTimeout(updateAllVisibility, 1500);
}

function updateVisibility(el) {
	var visible = inViewport(el),
	    wasVisible = el.hasAttribute('visible'); // && el.hasAttribute('visible');
	if (visible !== wasVisible) {
		if (visible) el.setAttribute('visible', true);else el.removeAttribute('visible');
		//el._visible = visible;
		//el.style.visibility = visible ? '' : 'hidden';
		//if (el.hasAttribute('more-optimized')) {
		//	if (visible) el.setAttribute('visible', true);
		//	else el.removeAttribute('visible');
		//}
	}
}

function inViewport(el) {
	var _el$getBoundingClient = el.getBoundingClientRect(),
	    top = _el$getBoundingClient.top,
	    left = _el$getBoundingClient.left,
	    right = _el$getBoundingClient.right,
	    bottom = _el$getBoundingClient.bottom,
	    width = _el$getBoundingClient.width,
	    height = _el$getBoundingClient.height;

	return top >= -height && left >= -width && bottom <= cache.wh + height && right <= cache.ww + width;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _preactRouter = __webpack_require__(6);

var _decko = __webpack_require__(1);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var REDUCE = function REDUCE(_ref) {
	var connections = _ref.connections,
	    inboundFriendRequests = _ref.inboundFriendRequests,
	    outboundFriendRequests = _ref.outboundFriendRequests;
	return { connections: connections, inboundFriendRequests: inboundFriendRequests, outboundFriendRequests: outboundFriendRequests };
};

var Header = (_class = function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		_classCallCheck(this, Header);

		var _this = _possibleConstructorReturn(this, _Component.call(this));

		_peach2.default.store.subscribe(function (state) {
			return _this.setState(REDUCE(state));
		});

		_this.state.loading = _peach2.default.isLoading();

		_peach2.default.on('loadstart', function () {
			return _this.setState({ loading: true });
		});
		_peach2.default.on('loadend', function () {
			return _this.setState({ loading: false });
		});
		return _this;
	}

	Header.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref2, _ref3) {
		var inboundFriendRequests = _ref3.inboundFriendRequests,
		    loading = _ref3.loading;

		_objectDestructuringEmpty(_ref2);

		return inboundFriendRequests !== this.inboundFriendRequests || loading !== this.loading;
	};

	Header.prototype.linkTo = function linkTo(url) {
		return function () {
			return (0, _preactRouter.route)(url);
		};
	};

	Header.prototype.toggleMenu = function toggleMenu() {
		//peach.store.setState({ menu:true });
		(0, _pubsub.emit)('menu');
	};

	Header.prototype.addFriend = function addFriend() {
		var name = prompt('Friend\'s name:');
		if (!name) return;
		_peach2.default.addFriend(name, function (err) {
			if (err) alert('Error: ' + err);else alert('Friend request sent');
		});
	};

	Header.prototype.refresh = function refresh() {
		(0, _pubsub.emit)('refresh');
	};

	Header.prototype.render = function render(_ref4, _ref5) {
		var _ref5$loading = _ref5.loading,
		    loading = _ref5$loading === undefined ? false : _ref5$loading,
		    _ref5$inboundFriendRe = _ref5.inboundFriendRequests,
		    inboundFriendRequests = _ref5$inboundFriendRe === undefined ? [] : _ref5$inboundFriendRe;

		_objectDestructuringEmpty(_ref4);

		this.inboundFriendRequests = inboundFriendRequests;
		this.loading = loading;

		return (0, _preact.h)(
			_preactMdl.Layout.Header,
			{ manual: true },
			(0, _preact.h)(
				_preactMdl.Layout.HeaderRow,
				null,
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true, onClick: this.toggleMenu },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'menu' })
				),
				(0, _preact.h)(
					_preactMdl.Layout.Title,
					null,
					(0, _preact.h)(
						'span',
						{ style: 'cursor:pointer;', onClick: this.linkTo('/') },
						'Nectarine'
					)
				),
				(0, _preact.h)(_preactMdl.Layout.Spacer, null),
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true, onClick: this.refresh },
					(0, _preact.h)(
						'span',
						{ 'class': 'logo', loading: loading || null },
						'\uD83C\uDF51'
					)
				),
				(0, _preact.h)(_preactMdl.Layout.Spacer, null),
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true, onClick: this.addFriend },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'person add' })
				),
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true, style: 'overflow:visible', onClick: this.linkTo('/notifications') },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'notifications', badge: inboundFriendRequests.length || null })
				)
			)
		);
	};

	return Header;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'linkTo', [_decko.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'linkTo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleMenu', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'toggleMenu'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addFriend', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'addFriend'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'refresh', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'refresh'), _class.prototype)), _class);
exports.default = Header;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mitt = __webpack_require__(9);

var _mitt2 = _interopRequireDefault(_mitt);

var _jan = __webpack_require__(25);

var _jan2 = _interopRequireDefault(_jan);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _opaqueFetch = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enc = encodeURIComponent;

var EMPTY_FUNC = function EMPTY_FUNC() {};

var URL = "/api"; // 'https://v1.peachapi.com'

var CACHE_LIFETIME = 60 * 1000;

exports.default = function () {
	var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    _ref$url = _ref.url,
	    url = _ref$url === undefined ? URL : _ref$url,
	    store = _ref.store,
	    imgurKey = _ref.imgurKey,
	    _ref$init = _ref.init,
	    init = _ref$init === undefined ? true : _ref$init;

	var api = _jan2.default.ns(url),
	    peach = (0, _mitt2.default)();

	if (!store) store = (0, _store2.default)("peach-client");
	// if (!store.getState().streamCache) {
	// 	store.setState({ streamCache:{} });
	// }

	peach.rawRequest = _jan2.default;
	peach.api = api;
	peach.url = url;
	peach.store = store;
	peach.streamCache = {};
	peach._openRequests = 0;

	peach.init = function (callback) {
		if (typeof callback !== "function") callback = EMPTY_FUNC;
		var state = store.getState(),
		    email = state.email,
		    password = state.password;

		if (email && password) {
			peach.login({ email: email, password: password }, function (err) {
				if (err) {
					// console.log('stored credentials failed: '+err);
					store.setState({ token: null });
					peach.emit("logout", {});
					callback("Invalid credentials", false);
				} else {
					//peach.emit('login', state);
					callback(null, true);
				}
			});
		} else {
			callback(null, false);
		}
	};

	peach.isLoggedIn = function () {
		return !!store.getState().token;
	};

	peach.isLoading = function () {
		return peach._openRequests > 0;
	};

	api.on("req", function (_ref2) {
		var xhr = _ref2.xhr,
		    req = _ref2.req;

		if (!peach._openRequests++) peach.emit("loadstart");

		var h = req.headers || (req.headers = {}),
		    _store$getState = store.getState(),
		    id = _store$getState.id,
		    token = _store$getState.token,
		    streams = _store$getState.streams;


		if (token && !h.Authorization) {
			h.Authorization = "Bearer " + token;
		}

		h.Accept = "application/json";
		if (req.body && typeof req.body !== "string") {
			h["Content-Type"] = "application/json";
			req.originalBody = req.body;
			req.body = JSON.stringify(req.body);
		}
	});

	api.on("res", function (_ref3) {
		var res = _ref3.res,
		    req = _ref3.req;
		var data = res.data;


		if (! --peach._openRequests) peach.emit("loadend");

		if (res.status === 401) {
			res.error = "Unauthorized";
			return;
		}

		if (data) {
			var error = data.error || data.success === 0 && "Unspecified error";
			if (error) {
				res.error = error.Message || error.message || error;

				// overwrite incorrect http status codes
				if (res.status === 200) {
					res.status = error.Code || error.code || 520;
				}
			}

			if (data.data) res.data = data = data.data;

			// parse out successful auth repsonses
			var streams = data.streams,
			    rootStream = streams && streams[0] || {},
			    id = rootStream.id || data.id,
			    token = rootStream.token || data.token,
			    state = store.getState();
			if (streams) {
				store.setState({ streams: streams });
			}
			if (token && token !== state.token) {
				peach.emit("login", store.getState());
				var credentials = req.originalBody,
				    root = { id: data.id, token: data.token }; // no clue what this is for yet
				store.setState(_extends({ id: id, token: token }, credentials));

				// since we just logged in, fetch the user's profile:
				peach.user.me(EMPTY_FUNC, false);
			}
		}
	});

	// strip res from callback
	var cb = function cb(callback) {
		return function (err, res, data) {
			callback(err, data);
			callback = null;
		};
	};

	// create a post method
	var method = function method(_method, url) {
		return function () {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			var callback = args.pop(),
			    body = args.pop();
			api({ method: _method, url: url, body: body }, cb(callback));
		};
	};

	/** { email, password } */
	peach.login = method("post", "/login");

	/** { name, email, password } */
	peach.register = method("post", "/register");

	peach.isEmailRegistered = method("post", "/precheck/create/user");

	peach.connections = method("get", "/connections");
	peach.connections.explore = method("get", "/connections/explore");

	peach.activity = method("get", "/activity");
	peach.activity.isUnread = method("get", "/activity/isUnread");

	/** Mark a stream as read. */
	peach.markAsRead = function (id) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_FUNC;

		updateCachedConnection("id", id, {
			unreadPostCount: 0,
			lastRead: Date.now() / 1000 | 0
		});
		api.put("/stream/id/" + enc(id) + "/read", cb(callback));
	};

	function updateCachedConnection(by, value, update) {
		var _peach$store$getState = peach.store.getState(),
		    connections = _peach$store$getState.connections;

		if (connections) {
			for (var i = connections.length; i--;) {
				if (connections[i][by] === value) {
					if (update === false) {
						connections.splice(i, 1);
					} else {
						for (var p in update) {
							if (update.hasOwnProperty(p)) {
								connections[i][p] = update[p];
							}
						}
					}
					peach.store.setState({ connections: connections });
					return true;
				}
			}
		}
		return false;
	}

	// peach.stream.id = (id, cb) => peach.user.stream(id, cb);

	peach.user = {};

	/** Fetch the stream for a given user (by id) */
	peach.user.stream = function (id) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_FUNC;
		var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		if (id && (typeof id === "undefined" ? "undefined" : _typeof(id)) === "object") {
			opts = id;
			id = id.id;
		}
		if (id === "me") id = store.getState().id;
		var cached = peach.streamCache[id];
		if (!opts.optimistic && cached && peach.streamCache.hasOwnProperty(id)) {
			if (cached && cached._fetched && Date.now() - cached._fetched < CACHE_LIFETIME) {
				return callback(null, cached);
			}
		}
		api.get("/stream/id/" + id, function (err, res, data) {
			if (data && data.error) {
				err = data.error.Message || "Unknown error";
				data = null;
			}
			if (!err && data) {
				// data._fetched = Date.now();
				peach.cacheStream(data);
			}
			if (err && cached && opts.fallback !== false) {
				err = null;
				data = cached;
			}
			callback(err, data);
		});
	};

	peach.user.me = function () {
		var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_FUNC;
		var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		var _store$getState2 = store.getState(),
		    id = _store$getState2.id,
		    profile = _store$getState2.profile;

		if (profile && cache !== false) return callback(null, profile);
		peach.user.stream(id, function (err, profile) {
			if (profile) store.setState({ profile: profile });
			callback(err, profile);
		});
	};

	var hasComments = function hasComments(stream) {
		return stream && stream.posts && stream.posts.filter(function (p) {
			return p.hasOwnProperty("comments");
		}).length > 0;
	};

	peach.cacheStream = function (stream) {
		var cached = peach.streamCache[stream.id];
		if (hasComments(cached) && !hasComments(stream)) {
			//console.warn(`ignoring cache update for ${stream.id}, no comments`);
			return;
		}
		if (!stream._fetched) stream._fetched = Date.now();
		peach.streamCache[stream.id] = stream;
	};

	/** Publish a text post */
	peach.post = function (post, callback) {
		if (typeof post === "string") post = { text: post, type: "text" };
		api.post({ url: "/post", body: { message: [].concat(post) } }, cb(callback));
	};

	/** Delete a post. */
	peach.deletePost = function (id, callback) {
		return api.delete("/post/" + enc(id), cb(callback));
	};

	/** Send a wave of some type to the given profile ID.
  *	Available `type` values:
  *	- `wave`
  *	- `ring`
  *	- `hundred` (100'd)
  *	- `cake`
  *	- `boop`
  *	- `quarantine`
  *	- `kiss`
  *	- `hiss`
  *	@param {String} targetStreamId	The ID of the stream to send the wave to
  *	@param {String} type			A valid wave type
  *	@param {Function} [callback]
  */
	peach.wave = function (targetStreamId, type, callback) {
		api.post({ url: "/activity/wave", body: { targetStreamId: targetStreamId, type: type } }, cb(callback));
	};

	/** Like a post */
	peach.like = function (postId, callback) {
		return api.post({ url: "/like", body: { postId: postId } }, cb(callback));
	};

	/** Un-like a post */
	peach.unlike = function (postId, callback) {
		return api.delete("/like/postID/" + postId, cb(callback));
	};

	/** Add a comment to a post.
  *	@param {Object} comment
  *	@param {String} comment.postId	ID of the post to comment on
  *	@param {String} body			The comment message text
  */
	peach.comment = method("post", "/comment");

	/** Delete a comment, either your own or off of a post of yours.
  *	@param {string} id		The comment ID
  */
	peach.deleteComment = function (id, callback) {
		return api.delete("/comment/" + enc(id), cb(callback));
	};

	/** Set your stream visibility */
	peach.setVisibility = method("post", "/stream/visibility");

	/** Get your stream visibility */
	peach.getVisibility = method("get", "/stream/visibility");

	/** Set your @username. Pass {name:"foo"} */
	peach.setName = method("put", "/stream/name");

	/** Set your bio. Pass {bio:"foo"} */
	peach.setBio = method("put", "/stream/bio");

	/** Set your display name. Pass {displayName:"foo"} */
	peach.setDisplayName = method("put", "/stream/displayName");

	/** Set your avatar URL. Pass {avatarSrc:"https://..."} */
	//peach.setAvatar = method('put', '/stream/avatarSrc');
	peach.setAvatar = function (avatarSrc) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_FUNC;

		api.put({ url: "/stream/avatarSrc", body: { avatarSrc: avatarSrc } }, function (err, res) {
			var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

			callback(err, err ? null : _extends({ avatarSrc: avatarSrc }, data));
		});
	};

	peach.uploadAvatar = function (image) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_FUNC;

		peach.uploadImage(image, function (err, _ref4) {
			var url = _ref4.url;

			if (err) return callback(err);
			peach.setAvatar(url, callback);
		});
	};

	peach.uploadImage = function (image) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_FUNC;

		var body = new FormData();
		body.append("type", "file");
		body.append("image", image);
		(0, _opaqueFetch.opaqueFetch)("https://api.imgur.com/3/image", {
			method: "POST",
			headers: { Authorization: "Client-ID " + imgurKey },
			body: body
		}).then(function (r) {
			if (!r.ok) return callback("Error uploading image: " + r.statusText);
			r.json().then(function (data) {
				data = data && data.data || data;
				if (data.link || data.id) {
					var _url = data.link || "https://i.imgur.com/" + data.id + ".png";
					if (typeof _url === "string") {
						_url = _url.replace(/^http:\/\//g, "https://");
					}
					callback(null, _extends({ url: _url }, data));
				} else {
					callback("Error uploading image: " + data.error);
				}
			});
		});
	};

	// peach.setName = (name, callback) => api.post({ url:'/stream/name', body:{ name } }, cb(callback));
	// peach.setDisplayName = (displayName, callback) => api.post({ url:`/stream/id/${store.getState().id}/displayName`, body:{ displayName } }, cb(callback));

	/** Issue a friend request */
	peach.addFriend = function (username, callback) {
		return api.post("/stream/n/" + enc(username) + "/connection", cb(callback));
	};

	/** Cancel a friend request */
	peach.removeFriend = function (id, callback) {
		updateCachedConnection("id", id, false);
		var cached = peach.streamCache[id];
		if (cached) cached.youFollow = false;
		api.delete("/stream/id/" + enc(id) + "/connection", cb(callback));
	};

	/** Issue a friend request */
	peach.acceptFriendRequest = function (id, callback) {
		return api.post("/friend-request/" + enc(id) + "/accept", cb(callback));
	};

	/** Deny a friend request */
	peach.denyFriendRequest = function (id, callback) {
		return api.delete("/friend-request/" + enc(id), cb(callback));
	};

	if (init) setTimeout(peach.init, 1);
	return peach;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/** Jan is a simple library for making HTTP requests.
 *
 * Jan makes it easy to issue network calls without dealing with awkward legacy API signatures.
 *
 * If called as a function, `jan()` is an alias of {@link module:jan.request `jan.request()`}
 * @module jan
 *
 * @example
 *	<caption>Basic Usage</caption>
 *	// grab the library:
 *	require(['jan'], function(jan) {
 *
 *		// Log requests before they go out:
 *		jan.on('req', function(e) {
 *			console.log('Request: ', e.req);
 *		});
 *
 *		// Log responses when they come in:
 *		jan.on('res', function(e) {
 *			console.log('Response: ', e.res);
 *		});
 *
 *		// Make a basic GET request:
 *		jan('/api/todos', function(err, res, body) {
 *			if (err) throw err;
 *			var names = data.map(function(todo){ return todo.name; });
 *			alert('ToDos: ' + names.join(', '));
 *		});
 *	});
 */
(function(root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module==='object' && module.exports) {
		module.exports = factory();
	}
	else {
		root.jan = factory();
	}
}(this, function() {
	var events = { req:[], res:[] },
		methods = 'GET POST PUT DELETE HEAD OPTIONS'.split(' '),
		hop = {}.hasOwnProperty;

	/** Issue an HTTP request.
	 * @memberOf module:jan
	 * @name request
	 * @function
	 * @param {Object|String} options			Options for the request, or a `String` `"url"` to which a GET request should be issued.
	 * @param {String} [opt.method=GET]		HTTP method
	 * @param {String} [opt.url=/]				The URL to request
	 * @param {String|FormData|Blob|ArrayBufferView} [opt.body=none]		Request body, for HTTP methods that allow it. Supported types: [XMLHttpRequest#send](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#send())
	 * @param {Object} [opt.headers={ }]		A map of request headers
	 * @param {String} [opt.user=none]			Authentication username, if basic auth is to be used
	 * @param {String} [opt.pass=none]			Authentication password for basic auth
	 * @param {Function} callback				A function to call when the request has completed (error or success). Gets passed `(err, httpResponse, responseBody)`.
	 *
	 * @example
	 *	<caption>"Kitchen Sync"</caption>
	 *	jan({
	 *		method : 'PUT',
	 *		url : 'http://foo.com/bar.json',
	 *		headers : {
	 *			'Content-Type' : 'application/json'
	 *		},
	 *		user : 'bob',
	 *		pass : 'firebird',
	 *		body : JSON.stringify({ key : 'value' })
	 *	}, function(err, res, body) {
	 *		if (err) throw err;
	 *		console.log(res.status===204, body);
	 *	});
	 */
	function jan(opt, callback, a) {
		if (a) {
			opt = extend(callback || {}, { url:opt });
			callback = a;
		}
		opt = typeof opt==='string' ? {url:opt} : opt || {};
		if (opt.baseUrl) {
			// TODO: proper support for URL concatenation
			opt.url = opt.baseUrl + opt.url;
		}
		opt.headers = opt.headers || {};
		var xhr = new XMLHttpRequest(),
			e = { xhr:xhr, req:opt };
		emit('req', e);
		(xhr = e.xhr).open(opt.method || 'GET', opt.url || '/', true, opt.user, opt.pass);
		for (var name in opt.headers) if (hop.call(opt.headers, name)) xhr.setRequestHeader(name, opt.headers[name]);
		xhr.onreadystatechange = function() {
			if (xhr.readyState!==4) return;
			var res = {
					status : xhr.status,
					error : !xhr.status ? 'Connection Error' : xhr.status>399 ? xhr.statusText : null,
					headers : {},
					body : xhr.responseText,
					xml : xhr.responseXML,
					xhr : xhr
				},
				hreg = /^\s*([a-z0-9_-]+)\s*\:\s*(.*?)\s*$/gim,
				h = xhr.getAllResponseHeaders(),
				m;
			try{ res.json = JSON.parse(res.body); }catch(o){}
			res.data = res.json || res.xml || res.body;
			while (m=hreg.exec(h)) res.headers[m[1].toLowerCase()] = m[2];
			e.res = res;
			emit('res', e);
			(callback || opt.callback).call(e, res.error, res, res.data);
		};
		xhr.send(opt.body);
	}


	/**Get a namespaced copy of {@link module:jan jan} where all methods are relative to a base URL.
	 * @function
	 * @name module:jan.ns
	 * @param {String} baseUrl		A URL to which all namespaced methods should be relative
	 * @returns A `baseUrl`-namespaced jan interface
	 * @example
	 *	// Create a namespaced API client:
	 *	var api = jan.ns('https://example.com/api');
	 *
	 *	// GET /api/images:
	 *	api.get('/images', function(err, res, images) {
	 *		console.log(images);
	 *	});
	 *
	 *	// Log response headers for any requests to the base URL:
	 *	api.on('res', function(e) {
	 *		console.log( e.res.headers );
	 *	});
	 */
	jan.ns = function(uri) {
		var opt = { baseUrl:uri },
			ns = mapVerbs(alias(opt), opt);
		ns.on = function(type, handler, a) {
			jan.on(type, uri + (handler.sub ? handler : ''), a || handler);
			return ns;
		};
		return ns;
	};


	/**Register a handler function to be called in response to a given type of event.
	 *
	 * Valid event types are: `req` and `res`, fired on request and response respectively.
	 * @function
	 * @name module:jan.on
	 * @example
	 *	jan.on('res', function(e) {
	 *		// e.req
	 *		// e.res
	 *		// e.xhr
	 *	});
	 * @param {String} type					An event type to observe
	 * @param {String|RegExp} [urlFilter]	A String prefix or RegExp to filter against each event's request url
	 * @param {Function} handler			Handler function, gets passed an Event object
	 */
	jan.on = function(type, handler, a) {
		events[type].push(a ? function(e) {
			if (handler.exec ? e.req.url.match(handler) : e.req.url.indexOf(handler)===0) {
				a.call(this, e);
			}
		} : handler);
		return jan;
	};


	/**Alias of {@link module:jan.request request()} that presupplies the option `method:'GET'`
	 * @name module:jan.get
	 * @function
	 *
	 * @example
	 *	<caption>Get popular YouTube videos</caption>
	 *	var url = 'http://gdata.youtube.com/feeds/api/standardfeeds/most_popular?v=2&alt=json';
	 *	jan.get(url, function(err, data) {
	 *		if (err) throw err;
	 *		// display video links:
	 *		document.body.innerHTML = data.feed.entry.map(function(vid) {
	 *			return vid.title.$t.anchor(vid.content.src);	// String#neverforget
	 *		}).join('<br>');
	 *	});
	 */

	/**Alias of {@link module:jan.request request()} that presupplies the option `method:'POST'`
	 * @name module:jan.post
	 * @function
	 *
	 * @example
	 *	<caption>Submit a contact form</caption>
	 *	jan.post({
	 *		url : 'http://example.com/contact-form.php',
	 *		headers : {
	 *			'Content-Type' : 'application/x-www-form-encoded'
	 *		},
	 *		body : new FormData(document.querySelector('form'))
	 *	}, function(err, data) {
	 *		if (err) throw err;
	 *		alert('Submitted: ' + data.message);
	 *	});
	 */

	/** Alias of {@link module:jan.request request()} that presupplies the option `method:'PUT'`
	 * @name module:jan.put
	 * @function
	 *
	 * @example
	 *	<caption>Update a REST resource</caption>
	 *	jan.put({
	 *		url : 'http://foo.com/bar.json',
	 *		headers : { 'Content-Type':'application/json' },
	 *		body : '{"key":"val"}'
	 *	}, function(err, data) {
	 *		if (err) throw err;
	 *		console.log(data);
	 *	});
	 */

	/**	Alias of {@link module:jan.request request()} that presupplies the option `method:'HEAD'`
	 *	@name module:jan.head
	 *	@function
	 *
	 * @example
	 *	<caption>Get headers</caption>
	 *	jan.head('/massive.json', function(err, data, res) {
	 *		if (err) throw err;
	 *		console.log(res.headers);
	 *	});
	 */

	/**	Alias of {@link module:jan.request request()} that presupplies the option `method:'OPTIONS'`
	 *	@name module:jan.options
	 *	@function
	 *
	 * @example
	 *	<caption>Get WADL XML</caption>
	 *	jan.options('/api/v1', function(err, data, res) {
	 *		if (err) throw err;
	 *		console.log(res.headers, res.body);
	 *	});
	 */

	/**	Alias of {@link module:jan.request request()} that presupplies the option `method:'DELETE'`
	 *	@name module:jan.del
	 *	@function
	 *
	 * @example
	 *	<caption>Delete a REST resource</caption>
	 *	jan.del({
	 *		url : '/api/items/1a2b3c'
	 *	}, function(err, data) {
	 *		if (err) throw err;
	 *		alert('Deleted');
	 *	});
	 */

	/**	Alias of {@link module:jan.del del()}.
	 *  This alias is provided for completeness, but [should not be used](http://mothereff.in/js-properties#delete) because [it throws in ES3](http://mathiasbynens.be/notes/javascript-properties).
	 *	@name module:jan.delete
	 *	@function
	 *	@deprecated Don't call <code>delete()</code> if you need to support ES3. <code>jan['delete']()</code> is okay.
	 */

	mapVerbs(jan);


	function emit(type, args) {
		args = Array.prototype.slice.call(arguments, 1);
		for (var e=events[type], i=e.length; i--; ) e[i].apply(jan, args);
	}


	function alias(overrides) {
		return function(opt, callback) {
			return jan(extend({}, typeof opt==='string' ? {url:opt} : opt, overrides), callback);
		};
	}


	function mapVerbs(onto, opts) {
		for (var i=methods.length; i--; ) {
			onto[methods[i].toLowerCase()] = alias(extend({}, opts || {}, {
				method : methods[i]
			}));
		}
		onto.del = onto['delete'];
		return onto;
	}


	function extend(base, obj) {
		for (var i=1, p, o; i<arguments.length; i++) {
			o = arguments[i];
			for (p in o) if (hop.call(o, p)) base[p] = o[p];
		}
		return base;
	}


	return (jan.jan = jan.request = jan);
}));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.opaqueFetch = opaqueFetch;
function opaqueFetch(url, opts) {
	return new Promise(function (resolve) {
		var w = new Worker("data:text/javascript," + encodeURIComponent("onmessage=" + function (e) {
			fetch(e.data.url, e.data).then(function (r) {
				r.arrayBuffer().then(function (body) {
					postMessage({
						status: r.status,
						headers: Object.fromEntries(r.headers.entries()),
						body: body
					});
				});
			});
		}));
		w.onmessage = function (e) {
			w.terminate();
			resolve(new Response(e.data.body, e.data));
		};
		var r = new Request(url, opts);
		r.arrayBuffer().then(function (body) {
			w.postMessage({
				url: r.url,
				method: r.method,
				headers: Object.fromEntries(r.headers.entries()),
				body: body
			});
		});
	});
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactRouter = __webpack_require__(6);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Sidebar = (_class = function (_Component) {
	_inherits(Sidebar, _Component);

	function Sidebar() {
		var _temp, _this, _ret;

		_classCallCheck(this, Sidebar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { displayName: '' }, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Sidebar.prototype.componentDidMount = function componentDidMount() {
		(0, _pubsub.on)('menu', this.open);
		(0, _pubsub.on)('route', this.close);
		_peach2.default.store.subscribe(this.fromState);
		this.fromState(_peach2.default.store.getState());
	};

	Sidebar.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('menu', this.open);
		(0, _pubsub.off)('route', this.close);
		_peach2.default.store.unsubscribe(this.fromState);
	};

	Sidebar.prototype.fromState = function fromState() {
		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    _ref$profile = _ref.profile;

		_ref$profile = _ref$profile === undefined ? {} : _ref$profile;
		var displayName = _ref$profile.displayName;

		if (displayName !== this.state.displayName) {
			this.setState({ displayName: displayName });
		}
	};

	Sidebar.prototype.go = function go(e) {
		(0, _preactRouter.route)(e);
		this.close();
	};

	Sidebar.prototype.close = function close() {
		this.base.classList.remove('is-visible');
		this.visible = false;
	};

	Sidebar.prototype.open = function open() {
		this.base.classList.add('is-visible');
		this.visible = true;
	};

	Sidebar.prototype.me = function me() {
		var _this2 = this;

		_peach2.default.addFriend('developit', function () {
			return _this2.go('/profile/77a03b2c4fa9460ea42ff4000558c18a');
		});
		return false;
	};

	Sidebar.prototype.render = function render(_ref2, _ref3) {
		var displayName = _ref3.displayName;

		_objectDestructuringEmpty(_ref2);

		var Link = _preactMdl.Navigation.Link;

		return (0, _preact.h)(
			_preactMdl.Layout.Drawer,
			{ js: false, 'class': this.visible ? 'is-visible' : null },
			(0, _preact.h)(
				_preactMdl.Button,
				{ 'class': 'menu', icon: true, onClick: this.close },
				(0, _preact.h)(_preactMdl.Icon, { icon: 'menu' })
			),
			(0, _preact.h)(
				_preactMdl.Layout.Title,
				null,
				(0, _preact.h)(
					Link,
					{ href: '/profile', route: this.go },
					displayName || ' '
				)
			),
			(0, _preact.h)(
				_preactMdl.Navigation,
				null,
				(0, _preact.h)(
					Link,
					{ href: '/', route: this.go },
					'Home'
				),
				(0, _preact.h)(
					Link,
					{ href: '/friends', route: this.go },
					'Friends List'
				),
				(0, _preact.h)(
					Link,
					{ href: '/explore', route: this.go },
					'Explore ',
					(0, _preact.h)(
						'em',
						null,
						'Friends of Friends'
					)
				),
				(0, _preact.h)(
					Link,
					{ href: '/profile', route: this.go },
					'My Profile'
				),
				(0, _preact.h)(
					Link,
					{ href: '/stream', route: this.go },
					'Stream'
				),
				(0, _preact.h)(
					Link,
					{ href: '/settings', route: this.go },
					'Settings'
				),
				(0, _preact.h)('div', { style: 'border-top:1px solid #DDD; margin:5px 0; height:0; padding:0; font-size:0;' }),
				(0, _preact.h)(
					Link,
					{ onClick: this.me },
					'App by Jason \uD83D\uDE80'
				)
			)
		);
	};

	return Sidebar;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'fromState', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'fromState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'go', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'go'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'close', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'close'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'open', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'open'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'me', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'me'), _class.prototype)), _class);
exports.default = Sidebar;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _praline = __webpack_require__(10);

var _chooseFiles = __webpack_require__(13);

var _chooseFiles2 = _interopRequireDefault(_chooseFiles);

var _canvasToBlob = __webpack_require__(29);

var _canvasToBlob2 = _interopRequireDefault(_canvasToBlob);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var MAX_IMAGE_SIZE = 1000;

var CLEAN = {
	type: "text",
	text: "",
	gifs: null,
	images: null,
	error: null,
	loading: false
};

var Create = (_dec = (0, _decko.debounce)(500), (_class = function (_Component) {
	_inherits(Create, _Component);

	function Create() {
		var _temp, _this, _ret;

		_classCallCheck(this, Create);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _extends({ open: false }, CLEAN), _temp), _possibleConstructorReturn(_this, _ret);
	}

	Create.prototype.componentDidMount = function componentDidMount() {
		(0, _pubsub.on)("create", this.open);
	};

	Create.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)("create", this.open);
	};

	Create.prototype.open = function open() {
		var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		(0, _pubsub.emit)("track", "create");
		this.setState(_extends({ open: true }, CLEAN, props));
	};

	Create.prototype.close = function close() {
		this.setState({ open: false });
	};

	Create.prototype.submit = function submit() {
		var _this2 = this;

		var _state = this.state,
		    text = _state.text,
		    type = _state.type,
		    gifs = _state.gifs,
		    images = _state.images,
		    uploading = _state.uploading,
		    loading = _state.loading,
		    selectedMagic = _state.selectedMagic;

		if (loading || uploading) return alert("Still uploading...");
		if (!text && type === "text") return this.setState({ error: "Enter a message" });

		var post = [];

		text = text.replace(/^gif\s+(".*?"|[^\s]+)\s*/i, "");
		if (text) {
			post.push({ text: text, type: type });
		}

		if (gifs && (selectedMagic || selectedMagic === 0)) {
			var img = gifs[selectedMagic].images.downsized;

			post.push({
				type: "gif",
				src: img.url,
				width: img.width,
				height: img.height
			});
		}

		if (images && images.length) {
			post.push.apply(post, images.map(function (img) {
				return {
					type: img.url.match(/\.gif$/i) ? "gif" : "image",
					src: img.url,
					width: img.width,
					height: img.height
				};
			}));
		}

		//console.log(post);

		if (!post.length) return;

		this.setState({ loading: true });
		_peach2.default.post(post, function (error, result) {
			_this2.setState({ loading: false });
			if (error) return _this2.setState({ error: error });
			_this2.close();
			(0, _pubsub.emit)("did-post");
		});
	};

	Create.prototype.componentDidUpdate = function componentDidUpdate(_ref, _ref2) {
		var _ref2$text = _ref2.text,
		    text = _ref2$text === undefined ? "" : _ref2$text;

		_objectDestructuringEmpty(_ref);

		var p = text.match(/^gif\s+(".*?"|[^\s]+)/i);
		this.magicGif(p && p[1]);
	};

	Create.prototype.magicGif = function magicGif(terms) {
		var _this3 = this;

		if (terms === this.gifTerms) return;
		this.gifTerms = terms;
		// console.log(terms);
		if (!terms) return this.setState({ selectedMagic: null, gifs: null });
		fetch("https://api.giphy.com/v1/gifs/search?q=" + encodeURIComponent(terms) + "&api_key=dc6zaTOxFJmzC").then(function (r) {
			return r.json();
		}).then(function (_ref3) {
			var _ref3$data = _ref3.data,
			    data = _ref3$data === undefined ? [] : _ref3$data;

			_this3.setState({
				selectedMagic: null,
				gifs: data
			});
		});
	};

	Create.prototype.selectMagic = function selectMagic(e) {
		var index = e.target.getAttribute("data-magic");
		this.setState({ selectedMagic: index });
	};

	Create.prototype.addImages = function addImages() {
		var _this4 = this;

		(0, _chooseFiles2.default)(function (files) {
			if (!files || !files[0]) return;
			_this4.setState({ uploading: true });

			(0, _praline.parallel)(files.map(function (img) {
				return [_this4.uploadImage, img];
			}), function (error) {
				for (var _len2 = arguments.length, images = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
					images[_key2 - 1] = arguments[_key2];
				}

				if (!images.length) images = null;
				_this4.setState({ uploading: false, error: error, images: images });
			});
		});
	};

	Create.prototype.uploadImage = function uploadImage(img, callback) {
		var image = new Image(),
		    url = URL.createObjectURL(img);
		setTimeout(function () {
			return URL.revokeObjectURL(url);
		}, 1000);
		image.src = url;
		image.onload = function () {
			var width = image.width,
			    height = image.height;

			if (width > MAX_IMAGE_SIZE || height > MAX_IMAGE_SIZE) {
				var scale = MAX_IMAGE_SIZE / Math.max(width, height),
				    canvas = document.createElement("canvas");
				canvas.width = width * scale;
				canvas.height = height * scale;
				var ctx = canvas.getContext("2d");
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
				(0, _canvasToBlob2.default)(canvas, function (blob) {
					return _peach2.default.uploadImage(blob, callback);
				}, "image/jpeg", 0.9);
			} else {
				_peach2.default.uploadImage(img, callback);
			}
		};
		image.onerror = function () {
			return callback("Not a valid image");
		};
	};

	Create.prototype.render = function render(_ref4, _ref5) {
		var _this5 = this;

		var open = _ref5.open,
		    _ref5$text = _ref5.text,
		    text = _ref5$text === undefined ? "" : _ref5$text,
		    error = _ref5.error,
		    uploading = _ref5.uploading,
		    loading = _ref5.loading,
		    images = _ref5.images,
		    gifs = _ref5.gifs,
		    selectedMagic = _ref5.selectedMagic;

		_objectDestructuringEmpty(_ref4);

		return (0, _preact.h)(
			"div",
			{ "class": "create modal", showing: open || null },
			(0, _preact.h)(
				_preactMdl.Layout.Header,
				{ manual: true },
				(0, _preact.h)(
					_preactMdl.Layout.HeaderRow,
					null,
					(0, _preact.h)(
						_preactMdl.Button,
						{ icon: true, onClick: this.close },
						(0, _preact.h)(_preactMdl.Icon, { icon: "close" })
					),
					(0, _preact.h)(
						_preactMdl.Layout.Title,
						null,
						"New Post"
					),
					(0, _preact.h)(_preactMdl.Layout.Spacer, null),
					(0, _preact.h)(
						_preactMdl.Button,
						{ icon: true, onClick: this.addImages },
						uploading ? (0, _preact.h)(_preactMdl.Spinner, { active: true }) : (0, _preact.h)(_preactMdl.Icon, { icon: "add a photo" })
					),
					(0, _preact.h)(_preactMdl.Layout.Spacer, null),
					(0, _preact.h)(
						_preactMdl.Button,
						{ icon: true, onClick: this.submit },
						loading ? (0, _preact.h)(_preactMdl.Spinner, { active: true }) : (0, _preact.h)(_preactMdl.Icon, { icon: "send" })
					)
				)
			),
			(0, _preact.h)(
				"div",
				{ "class": "content has-header", magic: !!gifs || null },
				(0, _preact.h)(
					"div",
					{ "class": "inner" },
					(0, _preact.h)(_preactMdl.TextField, {
						"class": "text",
						multiline: true,
						placeholder: "Enter a message.",
						value: text,
						onInput: this.linkState("text")
					}),
					(0, _preact.h)(
						"div",
						{ "class": "magic", show: gifs && gifs.length || null },
						(0, _preact.h)(
							"div",
							{ "class": "inner" },
							gifs ? gifs.map(function (p, i) {
								return (0, _preact.h)("img", {
									"data-magic": i,
									selected: selectedMagic == i || null,
									onClick: _this5.selectMagic,
									src: p.images.downsized.url
								});
							}) : null
						)
					),
					(0, _preact.h)(
						"div",
						{ "class": "images", show: images && images.length || null },
						(0, _preact.h)(
							"div",
							{ "class": "inner" },
							images ? images.map(function (img) {
								return (0, _preact.h)("img", { src: img.url });
							}) : null
						)
					)
				),
				error ? (0, _preact.h)(
					"div",
					{ "class": { error: 1, showing: error } },
					error
				) : null
			)
		);
	};

	return Create;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, "open", [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "magicGif", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "magicGif"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectMagic", [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, "selectMagic"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addImages", [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, "addImages"), _class.prototype)), _class));
exports.default = Create;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (canvas, callback) {
	var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'image/png';
	var quality = arguments[3];

	if (typeof canvas.toBlob === 'function') {
		return canvas.toBlob(callback, type, quality);
	}

	var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
	    len = binStr.length,
	    arr = new Uint8Array(len);
	for (var i = len; i--;) {
		arr[i] = binStr.charCodeAt(i);
	}callback(new Blob([arr], { type: type }));
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var TYPES = [['wave', '👋 Wave'], ['cake', '🍰 Cake'], ['hundred', '💯 100'], ['boop', '👉👃 Boop'], ['quarantine', '😷 Quarantine'], ['kiss', '😘 Blow a kiss'], ['ring', '💍 Put a ring on'], ['hiss', '😾 Hiss']];

var Wave = (_class = function (_Component) {
	_inherits(Wave, _Component);

	function Wave() {
		var _temp, _this, _ret;

		_classCallCheck(this, Wave);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { open: false }, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Wave.prototype.componentDidMount = function componentDidMount() {
		(0, _pubsub.on)('wave', this.open);
	};

	Wave.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('wave', this.open);
	};

	Wave.prototype.open = function open(_ref) {
		var to = _ref.to;

		(0, _pubsub.emit)('track', 'wave');
		if (!to) return console.warn('cant wave to nobody');
		this.setState({ open: true, to: to });
	};

	Wave.prototype.close = function close() {
		this.setState({ open: false, to: null });
	};

	Wave.prototype.send = function send(_ref2) {
		var type = _ref2.type;
		var to = this.state.to;

		setTimeout(this.close, 50);
		_peach2.default.wave(to, type, function (error) {
			if (error) alert('Error: ' + error);
		});
	};

	Wave.prototype.sendType = function sendType(type) {
		var _this2 = this;

		return function () {
			return _this2.send({ type: type });
		};
	};

	Wave.prototype.render = function render(_ref3, _ref4) {
		var _this3 = this;

		var open = _ref4.open;

		_objectDestructuringEmpty(_ref3);

		return (0, _preact.h)(
			'div',
			{ 'class': 'wave modal', showing: open || null },
			(0, _preact.h)(
				'div',
				{ 'class': 'content has-footer' },
				(0, _preact.h)(
					'div',
					{ 'class': 'inner' },
					(0, _preact.h)(
						'div',
						{ 'class': 'scroll-list' },
						TYPES.map(function (_ref5) {
							var type = _ref5[0],
							    text = _ref5[1];
							return (0, _preact.h)(
								'div',
								{ 'class': 'scroll-list-item', onClick: _this3.sendType(type) },
								text
							);
						})
					)
				)
			),
			(0, _preact.h)(
				'div',
				{ 'class': 'footer' },
				(0, _preact.h)(
					_preactMdl.Button,
					{ onClick: this.close },
					'Cancel'
				)
			)
		);
	};

	return Wave;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'open', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'open'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'close', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'close'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'send', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'send'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sendType', [_decko.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'sendType'), _class.prototype)), _class);
exports.default = Wave;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _preactRouter = __webpack_require__(6);

var _preactRouter2 = _interopRequireDefault(_preactRouter);

var _decko = __webpack_require__(1);

var _stream = __webpack_require__(32);

var _stream2 = _interopRequireDefault(_stream);

var _connections = __webpack_require__(38);

var _friends = __webpack_require__(40);

var _friends2 = _interopRequireDefault(_friends);

var _profile = __webpack_require__(42);

var _profile2 = _interopRequireDefault(_profile);

var _notifications = __webpack_require__(43);

var _notifications2 = _interopRequireDefault(_notifications);

var _settings = __webpack_require__(45);

var _settings2 = _interopRequireDefault(_settings);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var App = (_class = function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, App);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	App.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	App.prototype.componentWillMount = function componentWillMount() {
		(0, _pubsub.on)('go', this.go);
	};

	App.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('go', this.go);
	};

	App.prototype.go = function go(e) {
		(0, _preactRouter.route)(e.url || e);
	};

	App.prototype.onRoute = function onRoute(_ref) {
		var url = _ref.url;

		(0, _pubsub.emit)('route', { url: url });
		(0, _pubsub.emit)('track', url);
	};

	App.prototype.create = function create() {
		(0, _pubsub.emit)('create');
	};

	App.prototype.handleScroll = function handleScroll() {
		(0, _pubsub.emit)('update-visibility');
	};

	App.prototype.render = function render() {
		return (0, _preact.h)(
			_preactMdl.Layout.Content,
			{ id: 'content', onScroll: this.handleScroll },
			(0, _preact.h)(
				_preactRouter2.default,
				{ onChange: this.onRoute.bind(this) },
				(0, _preact.h)(_connections.Connections, { path: '/' }),
				(0, _preact.h)(_friends2.default, { path: '/friends' }),
				(0, _preact.h)(_connections.ExploreConnections, { path: '/explore' }),
				(0, _preact.h)(_stream2.default, { path: '/stream' }),
				(0, _preact.h)(_profile2.default, { path: '/profile', id: 'me' }),
				(0, _preact.h)(_profile2.default, { path: '/profile/:id' }),
				(0, _preact.h)(_notifications2.default, { path: '/notifications' }),
				(0, _preact.h)(_settings2.default, { path: '/settings' })
			),
			(0, _preact.h)(
				_preactMdl.Button,
				{ fab: true, colored: true, 'class': 'floating-action-button', onclick: this.create },
				(0, _preact.h)(
					_preactMdl.Icon,
					null,
					'create'
				)
			)
		);
	};

	return App;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'go', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'go'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleScroll', [_decko.debounce], Object.getOwnPropertyDescriptor(_class.prototype, 'handleScroll'), _class.prototype)), _class);
exports.default = App;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _post = __webpack_require__(7);

var _post2 = _interopRequireDefault(_post);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var toId = function toId(_ref) {
	var id = _ref.id,
	    createdTime = _ref.createdTime,
	    body = _ref.body;
	return id || body.postID + '-' + createdTime;
};

var Stream = (_class = function (_Component) {
	_inherits(Stream, _Component);

	function Stream() {
		_classCallCheck(this, Stream);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Stream.prototype.componentDidMount = function componentDidMount() {
		_peach2.default.store.subscribe(this.handleUpdate);
		this.handleUpdate(_peach2.default.store.getState());
		this.update();
		(0, _pubsub.on)('refresh', this.update);
	};

	Stream.prototype.componentWillUnmount = function componentWillUnmount() {
		_peach2.default.store.unsubscribe(this.handleUpdate);
		(0, _pubsub.off)('refresh', this.update);
	};

	Stream.prototype.handleUpdate = function handleUpdate(_ref2) {
		var activityItems = _ref2.activityItems;

		if (activityItems && activityItems !== this.state.activityItems) {
			var ids = activityItems.map(toId).join(',');
			if (ids !== this.state.ids) {
				this.setState({ ids: ids, activityItems: activityItems });
			}
		}
	};

	Stream.prototype.update = function update() {
		(0, _peach.updateConnections)();
	};

	Stream.prototype.handleScroll = function handleScroll() {
		(0, _pubsub.emit)('update-visibility');
	};

	Stream.prototype.componentDidUpdate = function componentDidUpdate() {
		(0, _pubsub.emit)('update-visibility');
	};

	Stream.prototype.render = function render(_ref3, _ref4) {
		var error = _ref4.error,
		    activityItems = _ref4.activityItems;

		_objectDestructuringEmpty(_ref3);

		return (0, _preact.h)(
			'div',
			{ 'class': 'stream view view-scroll', onScroll: this.handleScroll },
			(0, _preact.h)(
				'div',
				{ 'class': 'posts' },
				(0, _preact.h)(
					'div',
					{ 'class': 'posts-inner' },
					(activityItems || []).map(function (m) {
						return (0, _preact.h)(_post2.default, _extends({ minimal: true }, m));
					})
				)
			)
		);
	};

	return Stream;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleUpdate', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'handleUpdate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleScroll', [_decko.debounce], Object.getOwnPropertyDescriptor(_class.prototype, 'handleScroll'), _class.prototype)), _class);
exports.default = Stream;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

/** Returns a simple relative time string
 *  @example
 *      neatime(new Date()-1e4) == 'Just now'     // within the last minute
 *      neatime(Date.now()-1e6) == '16m'          // within the last hour
 *      neatime(Date.now()-1e7) == '2h'           // within the last hour
 *      neatime('Dec 31, 2014') == '4d'           // within the last 7 days
 *      neatime('Dec 25, 2014') == 'Dec 25'       // over 7 days ago gives a simple date
 *      neatime('July 4, 2014') == 'Jul 4, 2014'  // over half a year ago adds the year
 */
function neatime(text) {
	var now = new Date(),
		date = new Date(text),
		diff = (now.getTime() - date.getTime()) / 1000;
	if (diff <= 60) {
		text = 'Just now';
	}
	else if ( (diff /= 60) < 60 ) {
		text = (diff|0) + 'm';
	}
	else if ( (diff /= 60) < 24 ) {
		text = (diff|0) + 'h';
	}
	else if ( (diff /= 24) < 7 ) {
		text = (diff|0) + 'd';
	}
	else {
		text = String(date).split(' ')[1] + ' ' + date.getDate();
		if (diff>182 && now.getYear()!==date.getYear()) {
			text += ', ' + date.getFullYear();
		}
	}
	return text;
}
neatime.neatime = neatime;

module.exports = neatime;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _renderers = __webpack_require__(14);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Comment = (_class = function (_Component) {
	_inherits(Comment, _Component);

	function Comment(props) {
		_classCallCheck(this, Comment);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = { deleted: false };
		return _this;
	}

	Comment.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref, _ref2) {
		var id = _ref.id;
		var deleted = _ref2.deleted;

		return id !== this.props.id || deleted !== this.deleted;
	};

	Comment.prototype.handleClick = function handleClick(e) {
		var t = e.target;
		do {
			if (String(t.nodeName).toUpperCase() === 'A' || String(t.className).match(/\bmdl-menu\b/)) return;
		} while (t = t.parentNode);
		this.props.onClick(this.props);
		return e.stopPropagation(), false;
	};

	Comment.prototype.goAuthor = function goAuthor(e) {
		var author = this.props.author;

		if (author && author.id) {
			_peach2.default.cacheStream(author);
			(0, _pubsub.emit)('go', { url: '/profile/' + encodeURIComponent(author.id) });
		}
		if (e) e.stopPropagation(), e.preventDefault();
		return false;
	};

	Comment.prototype.openMenu = function openMenu(e) {
		var menu = this.base.querySelector('.mdl-menu');
		if (menu) menu.MaterialMenu.toggle();
		if (e) e.stopPropagation(), e.preventDefault();
		return false;
	};

	Comment.prototype.confirmDelete = function confirmDelete() {
		var _this2 = this;

		setTimeout(function () {
			if (confirm('Permanently delete this comment?')) _this2.delete();
		}, 200);
	};

	Comment.prototype.delete = function _delete() {
		var _this3 = this;

		_peach2.default.deleteComment(this.props.id, function (err) {
			if (err) return alert('Error: ' + err);
			_this3.setState({ deleted: true });
		});
	};

	Comment.prototype.renderMenu = function renderMenu() {
		var id = this.props.id;

		return (0, _preact.h)(
			'span',
			{ 'class': 'comment-menu-wrap' },
			(0, _preact.h)(
				_preactMdl.Button,
				{ id: 'commentmenu-' + id, 'class': 'comment-menu', onClick: this.openMenu, icon: true },
				(0, _preact.h)(_preactMdl.Icon, { icon: 'more vert' })
			),
			(0, _preact.h)(
				_preactMdl.Menu,
				{ 'bottom-right': true, 'for': 'commentmenu-' + id },
				(0, _preact.h)(
					_preactMdl.Menu.Item,
					{ onClick: this.confirmDelete },
					'Delete'
				)
			)
		);
	};

	Comment.prototype.render = function render(_ref3, _ref4) {
		var id = _ref3.id,
		    author = _ref3.author,
		    body = _ref3.body,
		    allowDelete = _ref3.allowDelete;
		var deleted = _ref4.deleted;

		this.deleted = deleted;

		if (deleted === true) return (0, _preact.h)(
			'div',
			{ 'class': 'comment comment-deleted' },
			(0, _preact.h)(
				'p',
				null,
				'Deleted'
			)
		);

		var mine = false,
		    me = _peach2.default.store.getState().profile;
		if (author && me && author.id === me.id) {
			mine = allowDelete = true;
		}

		var avatar = author.avatarSrc;
		return (0, _preact.h)(
			'div',
			{ 'class': 'comment', onClick: this.handleClick },
			allowDelete ? this.renderMenu() : (0, _preact.h)('span', { 'class': 'comment-menu-wrap' }),
			(0, _preact.h)('div', { 'class': 'avatar', onClick: this.goAuthor, style: avatar ? 'background-image: url(' + (0, _optimisticHttps2.default)(avatar) + ');' : null }),
			(0, _renderers.renderer)('text')({ text: body }),
			(0, _preact.h)(
				'author',
				{ title: author.name },
				author.displayName
			)
		);
	};

	return Comment;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleClick', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'handleClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goAuthor', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'goAuthor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openMenu', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'openMenu'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'confirmDelete', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'confirmDelete'), _class.prototype)), _class);
exports.default = Comment;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__(0);

var _decko = __webpack_require__(1);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// const IMG = [];
//
// setInterval(() => IMG.forEach(updateVisibility), 1000);
//
// function updateVisibility(img) {
// 	let visible = inViewport(img),
// 		wasVisible = img._visible || false;
// 	if (visible!==wasVisible) {
// 		img._visible = visible;
// 		if (visible) {
// 			img.setAttribute('visible', true);
// 		}
// 		else {
// 			img.removeAttribute('visible');
// 		}
// 	}
// }
//
// function inViewport(el) {
// 	let { top, left, right, bottom, width, height } = el.getBoundingClientRect();
// 	return top>=-height && left>=-width && bottom<=window.innerHeight+height && right<=window.innerWidth+width;
// }

var ImageViewer = function (_Component) {
	_inherits(ImageViewer, _Component);

	function ImageViewer() {
		_classCallCheck(this, ImageViewer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ImageViewer.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
		var src = _ref.src;

		return src !== this.props.src;
	};

	// componentDidMount() {
	// 	let i = IMG.indexOf(this.base);
	// 	if (i===-1) IMG.push(this.base);
	// }
	//
	// componentWillUnmount() {
	// 	let i = IMG.indexOf(this.base);
	// 	if (i!==-1) IMG.splice(i, 1);
	// }
	//
	// componentDidUpdate() {
	// 	if (this.base) updateVisibility(this.base);
	// }

	// @bind
	// toggle(e) {
	// 	this.setState({ full: !this.state.full });
	// 	if (e) return e.preventDefault(), e.stopPropagation(), false;
	// }

	ImageViewer.prototype.render = function render(_ref2, _ref3) {
		var src = _ref2.src;
		var full = _ref3.full;

		src = (0, _optimisticHttps2.default)(src);
		return (0, _preact.h)('img', { src: src, style: {
				display: 'block',
				maxWidth: full ? 'auto' : '',
				margin: 'auto'
			}, 'optimized-visibility': true, onClick: this.toggle });
	};

	return ImageViewer;
}(_preact.Component);

exports.default = ImageViewer;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var VideoPlayer = (_class = function (_Component) {
	_inherits(VideoPlayer, _Component);

	function VideoPlayer() {
		_classCallCheck(this, VideoPlayer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	VideoPlayer.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref, _ref2) {
		var src = _ref.src,
		    posterSrc = _ref.posterSrc;
		var play = _ref2.play;
		var props = this.props;

		return src !== props.src || posterSrc !== props.posterSrc || play !== this.play;
	};

	VideoPlayer.prototype.play = function play(e) {
		var _this2 = this;

		this.setState({ play: true });
		setTimeout(function () {
			return _this2.base.querySelector('video').play();
		}, 50);
		if (e) e.stopPropagation();
		return false;
	};

	VideoPlayer.prototype.stop = function stop(e) {
		this.setState({ play: false });
		if (e) e.stopPropagation();
		return false;
	};

	VideoPlayer.prototype.componentDidUpdate = function componentDidUpdate() {
		var _this3 = this;

		if (this.state.play) {
			setTimeout(function () {
				return _this3.base.querySelector('video').play();
			}, 100);
		}
	};

	VideoPlayer.prototype.render = function render(_ref3, _ref4) {
		var src = _ref3.src,
		    posterSrc = _ref3.posterSrc;
		var play = _ref4.play;

		this.playing = play;

		return (0, _preact.h)(
			'div',
			{ 'class': 'video-player', 'optimized-visibility': true },
			(0, _preact.h)(
				'div',
				{ 'class': 'poster', onClick: this.play },
				(0, _preact.h)('img', { src: (0, _optimisticHttps2.default)(posterSrc) }),
				(0, _preact.h)(_preactMdl.Icon, { icon: 'play circle outline' })
			),
			play ? (0, _preact.h)('video', { src: (0, _optimisticHttps2.default)(src), onPause: this.stop, onEnd: this.stop, autoplay: true, autobuffer: true, autostart: true }) : null
		);
	};

	return VideoPlayer;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'play', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'play'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'stop', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'stop'), _class.prototype)), _class);
exports.default = VideoPlayer;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__(0);

var _decko = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @TODO use a placeholder/poster image and clicking brings in the spotify embed (for performance)


var MusicPlayer = function (_Component) {
	_inherits(MusicPlayer, _Component);

	function MusicPlayer() {
		_classCallCheck(this, MusicPlayer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	MusicPlayer.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
		var id = _ref.id,
		    title = _ref.title,
		    spotifyData = _ref.spotifyData;
		var props = this.props;

		return id !== props.id || title !== props.title || this.getId(spotifyData) !== this.getId(props.spotifyData);
	};

	MusicPlayer.prototype.getId = function getId(spotifyData) {
		return spotifyData && spotifyData.track && spotifyData.track.id;
	};

	MusicPlayer.prototype.render = function render(_ref2) {
		var title = _ref2.title,
		    spotifyData = _ref2.spotifyData;

		var id = this.getId(spotifyData),
		    url = 'https://embed.spotify.com/?uri=spotify:track:' + encodeURIComponent(id);
		return (0, _preact.h)(
			'div',
			{ 'class': 'music-player' },
			(0, _preact.h)(
				'h6',
				null,
				title
			),
			(0, _preact.h)(
				'div',
				{ 'class': 'music-player-inner', 'optimized-visibility': true, 'more-optimized': true, style: 'max-width:300px; margin:0 auto; width:100%; height:380px;' },
				id ? (0, _preact.h)('iframe', { src: url, frameborder: '0', allowtransparency: 'true', style: 'width:100%; height:380px;' }) : null
			)
		);
	};

	return MusicPlayer;
}(_preact.Component);

exports.default = MusicPlayer;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ExploreConnections = exports.Connections = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _preactRouter = __webpack_require__(6);

var _decko = __webpack_require__(1);

var _post = __webpack_require__(7);

var _post2 = _interopRequireDefault(_post);

var _connection = __webpack_require__(39);

var _connection2 = _interopRequireDefault(_connection);

var _loadingScreen = __webpack_require__(8);

var _loadingScreen2 = _interopRequireDefault(_loadingScreen);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var EMPTY = {};

var Connections = exports.Connections = (_class = function (_Component) {
	_inherits(Connections, _Component);

	function Connections() {
		var _temp, _this, _ret;

		_classCallCheck(this, Connections);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.counter = 0, _this.explore = false, _this.state = { loading: true }, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Connections.prototype.componentDidMount = function componentDidMount() {
		if (!this.lastUpdate || Date.now() - this.lastUpdate > 30000) {
			this.update();
		} else if (!this.explore && _peach2.default.store.getState().connections) {
			this.update();
		}
		(0, _pubsub.on)('refresh', this.forceUpdate);
	};

	Connections.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('refresh', this.forceUpdate);
	};

	Connections.prototype.forceUpdate = function forceUpdate() {
		this.update({ force: true });
	};

	Connections.prototype.update = function update() {
		var _this2 = this;

		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY,
		    _ref$force = _ref.force,
		    force = _ref$force === undefined ? false : _ref$force;

		var id = ++this.counter,
		    _peach$store$getState = _peach2.default.store.getState(),
		    connections = _peach$store$getState.connections;

		this.lastUpdate = Date.now();

		if (!this.explore && !force && connections && connections.length) {
			// seed the cache
			connections.forEach(_peach2.default.cacheStream);
			this.setState({ loading: false, connections: connections });
			return;
		}

		this.setState({ loading: true });

		var fn = this.explore ? _peach2.default.connections.explore : _peach2.default.connections;
		fn(function (error, _ref2) {
			var connections = _ref2.connections;

			if (id !== _this2.counter) return;

			// seed the cache
			if (connections) connections.forEach(_peach2.default.cacheStream);

			_this2.setState({ loading: false, error: error, connections: connections });
		});
	};

	Connections.prototype.linkTo = function linkTo(url) {
		return function () {
			return (0, _pubsub.emit)('go', { url: url });
		};
	};

	Connections.prototype.handleRead = function handleRead(id) {
		_peach2.default.markAsRead(id);

		var connections = this.state.connections;

		for (var i = connections.length; i--;) {
			if (connections[i].id === id) {
				connections[i].unreadPostCount = 0;
				break;
			}
		}
		this.setState({ connections: connections });
	};

	Connections.prototype.handleScroll = function handleScroll() {
		(0, _pubsub.emit)('update-visibility');
	};

	Connections.prototype.componentDidUpdate = function componentDidUpdate() {
		(0, _pubsub.emit)('update-visibility');
	};

	Connections.prototype.render = function render(_ref3, _ref4) {
		var _this3 = this;

		var loading = _ref4.loading,
		    error = _ref4.error,
		    _ref4$connections = _ref4.connections,
		    connections = _ref4$connections === undefined ? [] : _ref4$connections;

		_objectDestructuringEmpty(_ref3);

		// filter out connections who have not posted since reading.
		connections = connections.filter(function (c) {
			return c.unreadPostCount !== 0;
		});

		// truncate after 50 posts if needed

		var _peach$store$getState2 = _peach2.default.store.getState(),
		    prefs = _peach$store$getState2.prefs;

		if (prefs && prefs.limit && connections.length > 50) {
			connections.length = 50;
		}

		if (!connections.length && !loading) return (0, _preact.h)(
			'div',
			{ 'class': 'explore view' },
			(0, _preact.h)(
				'div',
				{ 'class': 'inner' },
				(0, _preact.h)(
					'div',
					{ 'class': 'nothing' },
					(0, _preact.h)(
						'p',
						null,
						'Nothing new here.'
					),
					(0, _preact.h)(
						'p',
						null,
						'Go ',
						(0, _preact.h)(
							_preactRouter.Link,
							{ href: '/explore' },
							'Explore'
						),
						', or ',
						(0, _preact.h)(
							_preactRouter.Link,
							{ href: '/friends' },
							'view older posts from friends'
						),
						'.'
					)
				)
			)
		);

		return (0, _preact.h)(
			'div',
			{ 'class': 'explore view', onScroll: this.handleScroll },
			(0, _preact.h)(
				'div',
				{ 'class': 'inner' },
				connections.map(function (connection) {
					return (0, _preact.h)(_connection2.default, _extends({ key: connection.id }, connection, { meta: !_this3.explore, onRead: _this3.handleRead, onClick: _this3.linkTo('/profile/' + encodeURIComponent(connection.id)) }));
				}),
				!connections.length && loading ? (0, _preact.h)(_loadingScreen2.default, { overlay: true }) : null
			)
		);
	};

	return Connections;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'forceUpdate', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'forceUpdate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'linkTo', [_decko.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'linkTo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleRead', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'handleRead'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleScroll', [_decko.debounce], Object.getOwnPropertyDescriptor(_class.prototype, 'handleScroll'), _class.prototype)), _class);

var ExploreConnections = exports.ExploreConnections = function (_Connections) {
	_inherits(ExploreConnections, _Connections);

	function ExploreConnections() {
		var _temp2, _this4, _ret2;

		_classCallCheck(this, ExploreConnections);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, _Connections.call.apply(_Connections, [this].concat(args))), _this4), _this4.explore = true, _temp2), _possibleConstructorReturn(_this4, _ret2);
	}

	return ExploreConnections;
}(Connections);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _post = __webpack_require__(7);

var _post2 = _interopRequireDefault(_post);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Connection = (_class = function (_Component) {
	_inherits(Connection, _Component);

	function Connection() {
		_classCallCheck(this, Connection);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Connection.prototype.shouldComponentUpdate = function shouldComponentUpdate(props, _ref) {
		var read = _ref.read;

		for (var i in props) {
			if (i !== 'posts' && i !== '_fetched' && props[i] !== this.props[i]) return true;
		}return false;
	};

	Connection.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
		var id = _ref2.id;

		if (id !== this.props.id) this.read = null;
	};

	Connection.prototype.onClick = function onClick(e) {
		var t = e.target;
		do {
			if (String(t.nodeName).toUpperCase() === 'A') {
				e.stopPropagation();
				return;
			}
		} while (t = t.parentNode);
		this.props.onClick(e);
	};

	Connection.prototype.markRead = function markRead(e) {
		var _props = this.props,
		    id = _props.id,
		    onRead = _props.onRead;

		if (onRead) onRead(id);
		if (e) e.stopPropagation();
		return false;
	};

	Connection.prototype.render = function render(_ref3) {
		var id = _ref3.id,
		    displayName = _ref3.displayName,
		    _ref3$posts = _ref3.posts,
		    posts = _ref3$posts === undefined ? [] : _ref3$posts,
		    _ref3$unreadPostCount = _ref3.unreadPostCount,
		    unreadPostCount = _ref3$unreadPostCount === undefined ? 0 : _ref3$unreadPostCount,
		    avatarSrc = _ref3.avatarSrc,
		    meta = _ref3.meta;

		return (0, _preact.h)(
			_preactMdl.Card,
			{ shadow: 2, 'class': 'centered stream-connection', onClick: this.onClick },
			(0, _preact.h)(
				_preactMdl.Card.Title,
				null,
				(0, _preact.h)('div', { 'class': 'avatar', style: avatarSrc && 'background-image: url(' + (0, _optimisticHttps2.default)(avatarSrc) + ');' }),
				(0, _preact.h)(
					_preactMdl.Card.TitleText,
					null,
					displayName,
					' ',
					(0, _preact.h)(
						'span',
						{ 'class': 'unread-count' },
						'(',
						unreadPostCount || 0,
						')'
					)
				),
				meta ? (0, _preact.h)(
					'div',
					{ 'class': 'connection-meta' },
					(0, _preact.h)(
						_preactMdl.Button,
						{ icon: true, onClick: this.markRead },
						(0, _preact.h)(_preactMdl.Icon, { icon: 'done' })
					)
				) : null
			),
			(0, _preact.h)(
				_preactMdl.Card.Text,
				null,
				posts.length ? (0, _preact.h)(_post2.default, _extends({ comment: false, authorId: id }, posts[posts.length - 1])) : null
			)
		);
	};

	return Connection;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'markRead', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'markRead'), _class.prototype)), _class);
exports.default = Connection;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _preactRouter = __webpack_require__(6);

var _friend = __webpack_require__(41);

var _friend2 = _interopRequireDefault(_friend);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var toId = function toId(_ref) {
	var id = _ref.id,
	    createdTime = _ref.createdTime,
	    body = _ref.body;
	return id || body.postID + '-' + createdTime;
};

var Friends = (_class = function (_Component) {
	_inherits(Friends, _Component);

	function Friends() {
		var _temp, _this, _ret;

		_classCallCheck(this, Friends);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			hasUpdated: false,
			connections: []
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Friends.prototype.componentDidMount = function componentDidMount() {
		(0, _pubsub.on)('refresh', this.update);
		_peach2.default.store.subscribe(this.handleUpdate);
		this.handleUpdate(_peach2.default.store.getState());
		if (!this.lastUpdate || Date.now() - this.lastUpdate > 30000) {
			this.update();
		}
	};

	Friends.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('refresh', this.update);
		_peach2.default.store.unsubscribe(this.handleUpdate);
	};

	Friends.prototype.handleUpdate = function handleUpdate(_ref2) {
		var _ref2$connections = _ref2.connections,
		    connections = _ref2$connections === undefined ? [] : _ref2$connections;

		this.setState({ hasUpdated: true });
		if (connections && connections !== this.state.connections) {
			var ids = connections.map(toId).join(',');
			if (ids !== this.state.ids) {
				this.setState({ ids: ids, connections: connections });
			}
		}
	};

	Friends.prototype.update = function update() {
		this.lastUpdate = Date.now();
		_peach2.default.updateConnections();
	};

	Friends.prototype.renderNoFriends = function renderNoFriends() {
		return (0, _preact.h)(
			'div',
			{ 'class': 'nothing' },
			(0, _preact.h)(
				'p',
				null,
				'You don\'t seem to have any Peach contacts.'
			),
			(0, _preact.h)(
				'p',
				null,
				'Find people in ',
				(0, _preact.h)(
					_preactRouter.Link,
					{ href: '/explore' },
					'Explore'
				),
				', or tap ',
				(0, _preact.h)(
					_preactMdl.Button,
					{ icon: true },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'person add' })
				),
				' to add.'
			)
		);
	};

	Friends.prototype.render = function render(_ref3, _ref4) {
		var hasUpdated = _ref4.hasUpdated,
		    connections = _ref4.connections;

		_objectDestructuringEmpty(_ref3);

		return (0, _preact.h)(
			'div',
			{ 'class': 'friends-list view view-scroll' },
			(0, _preact.h)(
				'div',
				{ 'class': 'friends' },
				(0, _preact.h)(
					'div',
					{ 'class': 'inner' },
					connections.length ? connections.map(function (friend) {
						return (0, _preact.h)(_friend2.default, friend);
					}) : hasUpdated ? this.renderNoFriends() : null
				)
			)
		);
	};

	return Friends;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleUpdate', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'handleUpdate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype)), _class);
exports.default = Friends;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _decko = __webpack_require__(1);

var _pubsub = __webpack_require__(3);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Friend = (_class = function (_Component) {
	_inherits(Friend, _Component);

	function Friend() {
		_classCallCheck(this, Friend);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Friend.prototype.goAuthor = function goAuthor(e) {
		var id = this.props.id;

		(0, _pubsub.emit)('go', { url: '/profile/' + encodeURIComponent(id) });
	};

	Friend.prototype.render = function render(_ref) {
		var avatarSrc = _ref.avatarSrc,
		    bio = _ref.bio,
		    displayName = _ref.displayName,
		    name = _ref.name,
		    unreadPostCount = _ref.unreadPostCount;

		return (0, _preact.h)(
			'div',
			{ 'class': 'friend', 'unread-count': unreadPostCount || null, onClick: this.goAuthor },
			(0, _preact.h)('div', { 'class': 'avatar', style: avatarSrc ? 'background-image: url(\'' + (0, _optimisticHttps2.default)(avatarSrc) + '\');' : null }),
			(0, _preact.h)(
				'h2',
				null,
				displayName,
				' ',
				(0, _preact.h)(
					'span',
					{ 'class': 'unread-count' },
					'(',
					unreadPostCount || 0,
					')'
				)
			),
			(0, _preact.h)(
				'h4',
				null,
				'@',
				name
			),
			(0, _preact.h)(
				'footer',
				null,
				bio || null
			)
		);
	};

	return Friend;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'goAuthor', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'goAuthor'), _class.prototype)), _class);
exports.default = Friend;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _loadingScreen = __webpack_require__(8);

var _loadingScreen2 = _interopRequireDefault(_loadingScreen);

var _decko = __webpack_require__(1);

var _pubsub = __webpack_require__(3);

var _post = __webpack_require__(7);

var _post2 = _interopRequireDefault(_post);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _parseMessage = __webpack_require__(15);

var _parseMessage2 = _interopRequireDefault(_parseMessage);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var EMPTY = {};

var Profile = (_class = function (_Component) {
	_inherits(Profile, _Component);

	function Profile() {
		var _temp, _this, _ret;

		_classCallCheck(this, Profile);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._counter = 0, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Profile.prototype.componentDidMount = function componentDidMount() {
		this.update();
		(0, _pubsub.on)('refresh', this.update);
		(0, _pubsub.on)('did-post', this.updateIfMe);
	};

	Profile.prototype.componentWillUnmount = function componentWillUnmount() {
		(0, _pubsub.off)('refresh', this.update);
		(0, _pubsub.off)('did-post', this.updateIfMe);
	};

	Profile.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
		var id = _ref.id;

		if (id !== this.state.id) this.update(id);
	};

	Profile.prototype.updateIfMe = function updateIfMe() {
		var id = this.props.id,
		    me = _peach2.default.store.getState().profile.id;

		if (id === 'me' || id === me) {
			this.update();
		}
	};

	Profile.prototype.update = function update() {
		var _this2 = this;

		var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.id;

		var myId = _peach2.default.store.getState().profile.id;
		id = id || 'me';
		if (id === 'me') id = myId;

		if (this.state.loading === true && this.state.id === id) return;

		var cached = _peach2.default.streamCache[id],
		    different = id !== this.state.id,
		    loadingNew = different && !cached,
		    c = ++this._counter;

		if (different) this.scrollToTop();

		this.setState({ id: id, error: null, loading: true, loadingNew: loadingNew, stream: cached || EMPTY, followPending: false });

		_peach2.default.user.stream({ id: id, optimistic: true }, function (error, stream) {
			if (c !== _this2._counter) return;
			_this2.setState({ loading: false, loadingNew: false, error: error, stream: stream });
		});

		// in parallel
		if (id !== 'me' && id !== myId) {
			_peach2.default.markAsRead(id);
		}
	};

	Profile.prototype.scrollToTop = function scrollToTop() {
		this.base.scrollTop = 0;
	};

	Profile.prototype.wave = function wave(type) {
		(0, _pubsub.emit)('wave', { to: this.props.id });
	};

	Profile.prototype.follow = function follow() {
		var _this3 = this;

		var stream = this.state.stream;

		_peach2.default.addFriend(stream.name, function (error) {
			if (error) alert('Error: ' + error);else _this3.setState({ followPending: true });
		});
	};

	Profile.prototype.unfollow = function unfollow() {
		var _this4 = this;

		var stream = this.state.stream;

		_peach2.default.removeFriend(stream.id, function (error) {
			if (error) alert('Error: ' + error);
			_this4.setState({});
		});
	};

	Profile.prototype.private = function _private() {
		alert('This person\'s profile is only visible to friends.');
	};

	Profile.prototype.followsYou = function followsYou() {
		alert('This person follows you.');
	};

	Profile.prototype.handleScroll = function handleScroll() {
		(0, _pubsub.emit)('update-visibility');
	};

	Profile.prototype.componentDidUpdate = function componentDidUpdate() {
		(0, _pubsub.emit)('update-visibility');
	};

	Profile.prototype.render = function render(_ref2, _ref3) {
		var error = _ref3.error,
		    loading = _ref3.loading,
		    loadingNew = _ref3.loadingNew,
		    stream = _ref3.stream,
		    _ref3$followPending = _ref3.followPending,
		    followPending = _ref3$followPending === undefined ? false : _ref3$followPending;

		_objectDestructuringEmpty(_ref2);

		if (error) return (0, _preact.h)(
			'div',
			{ 'class': 'profile view' },
			(0, _preact.h)(
				_preactMdl.Card,
				{ shadow: 2, 'class': 'centered' },
				(0, _preact.h)(
					_preactMdl.Card.Title,
					null,
					(0, _preact.h)(
						_preactMdl.Card.TitleText,
						null,
						'Error'
					)
				),
				(0, _preact.h)(
					_preactMdl.Card.Text,
					null,
					error
				)
			)
		);

		if (!stream || !stream.name || loading && loadingNew) return (0, _preact.h)(
			'div',
			{ 'class': 'profile view' },
			(0, _preact.h)(_loadingScreen2.default, null)
		);

		var profile = _peach2.default.store.getState().profile || {},
		    isMe = stream.name === profile.name;
		return (0, _preact.h)(
			'div',
			{ 'class': 'profile view view-scroll', onScroll: this.handleScroll },
			(0, _preact.h)(
				'div',
				{ 'class': 'inner' },
				(0, _preact.h)(
					'header',
					null,
					(0, _preact.h)('div', { 'class': 'avatar', style: stream.avatarSrc ? 'background-image: url(' + (0, _optimisticHttps2.default)(stream.avatarSrc) + ');' : null }),
					(0, _preact.h)(
						'h4',
						null,
						'@',
						stream.name
					),
					(0, _preact.h)(
						'h3',
						null,
						stream.displayName
					),
					(0, _preact.h)(
						'small',
						null,
						stream.bio && (0, _parseMessage2.default)(stream.bio) || null
					),
					isMe ? null : (0, _preact.h)(
						'div',
						{ 'class': 'opts' },
						isMe ? (0, _preact.h)(
							'span',
							{ 'class': 'tag is-you' },
							'You!'
						) : (0, _preact.h)(
							_preactMdl.Button,
							{ icon: true, primary: true, onClick: this.wave },
							'\uD83D\uDC4B'
						),
						!isMe && stream.followsYou ? (0, _preact.h)(
							_preactMdl.Button,
							{ icon: true, primary: true, onClick: this.followsYou },
							(0, _preact.h)(_preactMdl.Icon, { 'class': 'follows-you', icon: 'people', title: 'Follows You' })
						) : null,
						stream.isPublic ? null : (0, _preact.h)(
							_preactMdl.Button,
							{ icon: true, primary: true, onClick: this.private },
							(0, _preact.h)(_preactMdl.Icon, { 'class': 'private', icon: 'lock', title: 'Private' })
						),
						stream.youFollow ? (0, _preact.h)(
							_preactMdl.Button,
							{ primary: true, 'class': 'unfollow', onClick: this.unfollow },
							'Unfollow'
						) : (0, _preact.h)(
							_preactMdl.Button,
							{ primary: true, 'class': 'follow', disabled: followPending || null, onClick: this.follow },
							'Follow'
						)
					)
				),
				(0, _preact.h)(
					'div',
					{ 'class': 'posts' },
					(0, _preact.h)(
						'div',
						{ 'class': 'posts-inner' },
						(stream.posts || []).slice().reverse().map(function (post) {
							return (0, _preact.h)(_post2.default, _extends({ authorId: stream.id }, post));
						})
					)
				),
				loading ? (0, _preact.h)(_loadingScreen2.default, { overlay: false }) : null
			)
		);
	};

	return Profile;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'updateIfMe', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'updateIfMe'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'scrollToTop', [_decko.debounce], Object.getOwnPropertyDescriptor(_class.prototype, 'scrollToTop'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'wave', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'wave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'follow', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'follow'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'unfollow', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'unfollow'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleScroll', [_decko.debounce], Object.getOwnPropertyDescriptor(_class.prototype, 'handleScroll'), _class.prototype)), _class);
exports.default = Profile;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactRouter = __webpack_require__(6);

var _connectionRequest = __webpack_require__(44);

var _connectionRequest2 = _interopRequireDefault(_connectionRequest);

var _decko = __webpack_require__(1);

var _pubsub = __webpack_require__(3);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var toId = function toId(_ref) {
	var id = _ref.id,
	    createdTime = _ref.createdTime,
	    body = _ref.body;
	return id || body.postID + '-' + createdTime;
};

var Notifications = (_class = function (_Component) {
	_inherits(Notifications, _Component);

	function Notifications() {
		_classCallCheck(this, Notifications);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Notifications.prototype.componentDidMount = function componentDidMount() {
		_peach2.default.store.subscribe(this.handleUpdate);
		this.handleUpdate(_peach2.default.store.getState());
		this.update();
		(0, _pubsub.on)('refresh', this.update);
	};

	Notifications.prototype.componentWillUnmount = function componentWillUnmount() {
		_peach2.default.store.unsubscribe(this.handleUpdate);
		(0, _pubsub.off)('refresh', this.update);
	};

	Notifications.prototype.handleUpdate = function handleUpdate(_ref2) {
		var inboundFriendRequests = _ref2.inboundFriendRequests;

		if (inboundFriendRequests && inboundFriendRequests !== this.state.inboundFriendRequests) {
			var ids = inboundFriendRequests.map(toId).join(',');
			if (ids !== this.state.ids) {
				this.setState({ ids: ids, inboundFriendRequests: inboundFriendRequests });
			}
		}
	};

	Notifications.prototype.update = function update() {
		_peach2.default.updateConnections();
	};

	Notifications.prototype.onAcceptOrDeny = function onAcceptOrDeny(id) {
		var _state = this.state,
		    accepted = _state.accepted,
		    inboundFriendRequests = _state.inboundFriendRequests;

		this.setState({
			accepted: inboundFriendRequests.filter(function (r) {
				return r.id === id;
			}).concat(accepted || [])
		});
		_peach2.default.store.setState({
			inboundFriendRequests: (_peach2.default.store.getState().inboundFriendRequests || []).filter(function (r) {
				return r.id !== id;
			})
		});
	};

	Notifications.prototype.render = function render(_ref3, _ref4) {
		var _this2 = this;

		var _ref4$accepted = _ref4.accepted,
		    accepted = _ref4$accepted === undefined ? [] : _ref4$accepted,
		    _ref4$inboundFriendRe = _ref4.inboundFriendRequests,
		    inboundFriendRequests = _ref4$inboundFriendRe === undefined ? [] : _ref4$inboundFriendRe,
		    _ref4$outboundFriendR = _ref4.outboundFriendRequests,
		    outboundFriendRequests = _ref4$outboundFriendR === undefined ? [] : _ref4$outboundFriendR;

		_objectDestructuringEmpty(_ref3);

		var total = inboundFriendRequests.length + accepted.length;
		return (0, _preact.h)(
			'div',
			{ 'class': 'notifications' },
			total ? (0, _preact.h)(
				'div',
				{ 'class': 'scroll-list' },
				inboundFriendRequests.map(function (_ref5) {
					var id = _ref5.id,
					    stream = _ref5.stream;
					return (0, _preact.h)(_connectionRequest2.default, { id: id, stream: stream, onAct: _this2.onAcceptOrDeny });
				}),
				accepted.map(function (_ref6) {
					var id = _ref6.id,
					    stream = _ref6.stream;
					return (0, _preact.h)(_connectionRequest2.default, { id: id, stream: stream, acted: true });
				}),
				(0, _preact.h)(
					'div',
					{ 'class': 'nothing' },
					(0, _preact.h)(
						'p',
						null,
						'There\'s more stuff in ',
						(0, _preact.h)(
							_preactRouter.Link,
							{ href: '/stream' },
							'your stream'
						),
						'.'
					)
				)
			) : (0, _preact.h)(
				'div',
				{ 'class': 'nothing' },
				(0, _preact.h)(
					'p',
					null,
					'No new notifications!'
				),
				(0, _preact.h)(
					'p',
					null,
					'There\'s more stuff in ',
					(0, _preact.h)(
						_preactRouter.Link,
						{ href: '/stream' },
						'your stream'
					),
					'.'
				)
			)
		);
	};

	return Notifications;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleUpdate', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'handleUpdate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onAcceptOrDeny', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'onAcceptOrDeny'), _class.prototype)), _class);
exports.default = Notifications;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _pubsub = __webpack_require__(3);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var ConnectionRequest = (_class = function (_Component) {
	_inherits(ConnectionRequest, _Component);

	function ConnectionRequest() {
		_classCallCheck(this, ConnectionRequest);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ConnectionRequest.prototype.accept = function accept(e) {
		this.act('accept');
		return e.stopPropagation(), false;
	};

	ConnectionRequest.prototype.deny = function deny(e) {
		this.act('deny');
		return e.stopPropagation(), false;
	};

	ConnectionRequest.prototype.act = function act(method) {
		var _props = this.props,
		    id = _props.id,
		    onAct = _props.onAct;

		onAct(id);
		_peach2.default[method + 'FriendRequest'](id, function (err) {
			if (err) return alert('Error: ' + err);
		});
	};

	ConnectionRequest.prototype.toProfile = function toProfile(e) {
		var stream = this.props.stream;

		_peach2.default.cacheStream(stream);
		(0, _pubsub.emit)('go', '/profile/' + stream.id);
		return false;
	};

	ConnectionRequest.prototype.render = function render(_ref) {
		var id = _ref.id,
		    stream = _ref.stream,
		    onAct = _ref.onAct,
		    _ref$acted = _ref.acted,
		    acted = _ref$acted === undefined ? false : _ref$acted,
		    props = _objectWithoutProperties(_ref, ['id', 'stream', 'onAct', 'acted']);

		return (0, _preact.h)(
			'div',
			_extends({ 'class': 'scroll-list-item', onClick: this.toProfile, style: acted ? 'opacity:0.5' : null }, props),
			(0, _preact.h)('div', { 'class': 'avatar', style: stream.avatarSrc ? 'background-image: url(' + (0, _optimisticHttps2.default)(stream.avatarSrc) + ');' : null }),
			acted ? null : (0, _preact.h)(
				'button-bar',
				null,
				(0, _preact.h)(
					_preactMdl.Button,
					{ 'class': 'deny', icon: true, colored: true, onClick: this.deny },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'clear' })
				),
				(0, _preact.h)(
					_preactMdl.Button,
					{ 'class': 'accept', icon: true, colored: true, onClick: this.accept },
					(0, _preact.h)(_preactMdl.Icon, { icon: 'check' })
				)
			),
			(0, _preact.h)(
				'h4',
				null,
				stream.displayName
			),
			(0, _preact.h)(
				'h5',
				null,
				'@',
				stream.name
			)
		);
	};

	return ConnectionRequest;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'accept', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'accept'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deny', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'deny'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toProfile', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'toProfile'), _class.prototype)), _class);
exports.default = ConnectionRequest;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _preferences = __webpack_require__(46);

var _preferences2 = _interopRequireDefault(_preferences);

var _decko = __webpack_require__(1);

var _praline = __webpack_require__(10);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _chooseFiles = __webpack_require__(13);

var _chooseFiles2 = _interopRequireDefault(_chooseFiles);

var _optimisticHttps = __webpack_require__(5);

var _optimisticHttps2 = _interopRequireDefault(_optimisticHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Settings = (_class = function (_Component) {
	_inherits(Settings, _Component);

	function Settings() {
		_classCallCheck(this, Settings);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Settings.prototype.componentDidMount = function componentDidMount() {
		this.update();
	};

	Settings.prototype.update = function update() {
		var _this2 = this;

		this.setState({ loading: true });
		(0, _praline.parallel)([_peach2.default.getVisibility, _peach2.default.user.me], function (error, visibility, _ref) {
			var name = _ref.name,
			    displayName = _ref.displayName,
			    bio = _ref.bio,
			    avatarSrc = _ref.avatarSrc,
			    isPublic = _ref.isPublic;

			_this2.setState({ loading: false, error: error, visibility: visibility, name: name, displayName: displayName, bio: bio, avatarSrc: avatarSrc });
		});
	};

	Settings.prototype.setVisibility = function setVisibility(e) {
		var _this3 = this;

		var visibility = this.state.visibility;

		visibility.friendsOnly = e.target.checked;
		this.setState({ loading: true });
		_peach2.default.setVisibility(visibility, function (error) {
			_this3.setState({ loading: false, error: error, visibility: visibility });
		});
	};

	Settings.prototype.setName = function setName() {
		this.set('name');
	};

	Settings.prototype.setDisplayName = function setDisplayName() {
		this.set('displayName');
	};

	Settings.prototype.setBio = function setBio() {
		this.set('bio');
	};

	Settings.prototype.set = function set(what) {
		var _peach$n,
		    _this4 = this;

		var v = this.state[what],
		    n = 'set' + what.charAt(0).toUpperCase() + what.substring(1);
		this.setState({ loading: true });
		_peach2.default[n]((_peach$n = {}, _peach$n[what] = v, _peach$n), function (error) {
			_this4.setState({ loading: false, error: error });
			if (!error) {
				var _this4$updateLocalPro;

				_this4.updateLocalProfile((_this4$updateLocalPro = {}, _this4$updateLocalPro[what] = v, _this4$updateLocalPro));
			}
		});
	};

	Settings.prototype.updateLocalProfile = function updateLocalProfile(state) {
		_peach2.default.store.setState({
			profile: _extends({}, _peach2.default.store.getState().profile || {}, state)
		});
	};

	Settings.prototype.changeAvatar = function changeAvatar() {
		var _this5 = this;

		(0, _chooseFiles2.default)(function (files) {
			if (!files || !files[0]) return;
			_this5.setState({ loading: true });
			_peach2.default.uploadAvatar(files[0], function (error) {
				var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    avatarSrc = _ref2.avatarSrc;

				_this5.setState({ loading: false, error: error });
				// console.log({ error, avatarSrc });
				if (!error && avatarSrc) {
					_this5.updateLocalProfile({ avatarSrc: avatarSrc });
					_this5.setState({ avatarSrc: avatarSrc });
				}
			});
		});
	};

	Settings.prototype.render = function render(_ref3, _ref4) {
		var loading = _ref4.loading,
		    error = _ref4.error,
		    _ref4$visibility = _ref4.visibility,
		    visibility = _ref4$visibility === undefined ? {} : _ref4$visibility,
		    name = _ref4.name,
		    displayName = _ref4.displayName,
		    bio = _ref4.bio,
		    avatarSrc = _ref4.avatarSrc;

		_objectDestructuringEmpty(_ref3);

		return (0, _preact.h)(
			'div',
			{ 'class': 'settings' },
			(0, _preact.h)(
				_preactMdl.Card,
				{ shadow: '2', 'class': 'centered has-image' },
				(0, _preact.h)(
					'div',
					{ style: 'position:absolute;right:10px;top:10px;' },
					loading ? (0, _preact.h)(_preactMdl.Spinner, null) : null
				),
				(0, _preact.h)(
					_preactMdl.Card.Title,
					null,
					(0, _preact.h)(
						_preactMdl.Card.TitleText,
						null,
						'Account Settings'
					)
				),
				(0, _preact.h)(
					_preactMdl.Card.Text,
					null,
					(0, _preact.h)(
						'div',
						{ 'class': { error: 1, showing: error } },
						error || ' '
					),
					(0, _preact.h)(
						'form',
						{ action: 'javascript:' },
						(0, _preact.h)(
							_preactMdl.CheckBox,
							{ checked: visibility.friendsOnly, onClick: this.setVisibility },
							'Visible to Friends Only'
						)
					),
					(0, _preact.h)(
						'form',
						{ action: 'javascript:' },
						(0, _preact.h)(_preactMdl.TextField, {
							'floating-label': true,
							label: 'Display Name',
							value: displayName,
							onInput: this.linkState('displayName') }),
						(0, _preact.h)(
							_preactMdl.Button,
							{ colored: true, raised: true, onClick: this.setDisplayName },
							'Set Display Name'
						)
					),
					(0, _preact.h)(
						'form',
						{ action: 'javascript:' },
						(0, _preact.h)(_preactMdl.TextField, {
							'floating-label': true,
							label: 'Name',
							value: name,
							onInput: this.linkState('name') }),
						(0, _preact.h)(
							_preactMdl.Button,
							{ colored: true, raised: true, onClick: this.setName },
							'Set Name'
						)
					),
					(0, _preact.h)(
						'form',
						{ action: 'javascript:' },
						(0, _preact.h)(_preactMdl.TextField, {
							'floating-label': true,
							multiline: true,
							label: 'Bio',
							value: bio,
							maxlength: '200',
							onInput: this.linkState('bio') }),
						(0, _preact.h)(
							_preactMdl.Button,
							{ colored: true, raised: true, onClick: this.setBio },
							'Set Bio'
						)
					),
					(0, _preact.h)(
						'form',
						{ action: 'javascript:' },
						(0, _preact.h)(
							'h6',
							null,
							'Avatar'
						),
						(0, _preact.h)('div', { 'class': 'avatar', onClick: this.changeAvatar, style: 'background-image: url("' + (0, _optimisticHttps2.default)(avatarSrc || '/assets/icon-300.png') + '");' }),
						(0, _preact.h)(
							_preactMdl.Button,
							{ colored: true, raised: true, onClick: this.changeAvatar },
							'Change'
						)
					)
				)
			),
			(0, _preact.h)(_preferences2.default, null)
		);
	};

	return Settings;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'update', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setVisibility', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'setVisibility'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setName', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'setName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setDisplayName', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'setDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setBio', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'setBio'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'set', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'set'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeAvatar', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'changeAvatar'), _class.prototype)), _class);
exports.default = Settings;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _preactMdl = __webpack_require__(2);

var _decko = __webpack_require__(1);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Preferences = (_class = function (_Component) {
	_inherits(Preferences, _Component);

	function Preferences() {
		_classCallCheck(this, Preferences);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Preferences.prototype.transformOut = function transformOut(_ref) {
		var limit = _ref.limit,
		    prefs = _objectWithoutProperties(_ref, ['limit']);

		prefs.limit = limit ? 50 : false;
		return prefs;
	};

	Preferences.prototype.transformIn = function transformIn(_ref2) {
		var limit = _ref2.limit,
		    prefs = _objectWithoutProperties(_ref2, ['limit']);

		prefs.limit = !!limit;
		return prefs;
	};

	Preferences.prototype.componentWillMount = function componentWillMount() {
		var prefs = this.transformIn(_peach2.default.store.getState().prefs || {});
		this.setState(prefs);
	};

	Preferences.prototype.componentWillUpdate = function componentWillUpdate(_ref3, prefs) {
		_objectDestructuringEmpty(_ref3);

		prefs = this.transformOut(prefs);
		_peach2.default.store.setState({ prefs: prefs });
	};

	Preferences.prototype.getCacheSize = function getCacheSize() {
		var size = (localStorage.getItem('peach-client') || '').length / 1000;
		if (size > 1500) return (size / 1000).toFixed(2) + 'mb';
		return Math.round(size) + 'kb';
	};

	Preferences.prototype.clearCache = function clearCache() {
		var _this2 = this;

		var data = _peach2.default.store.data,
		    preserve = ['id', 'email', 'password', 'token', 'prefs', 'profile'];

		for (var i in data) {
			if (data.hasOwnProperty(i) && data[i] && preserve.indexOf(i) < 0) {
				if (Array.isArray(data[i])) {
					data[i] = [];
				} else if (_typeof(data[i]) === 'object') {
					data[i] = {};
				} else {
					console.warn('Unknown cache value ' + i + ' (' + _typeof(data[i]) + ')');
				}
			}
		}
		_peach2.default.store.setState({});
		setTimeout(function () {
			return _this2.setState({});
		}, 750);
	};

	Preferences.prototype.logout = function logout() {
		if (!confirm('Really sign out?')) return;
		localStorage.removeItem('peach-client');
		location.href = '/';
	};

	Preferences.prototype.render = function render(_ref4, _ref5) {
		var limit = _ref5.limit,
		    plainBackground = _ref5.plainBackground,
		    _ref5$showNotificatio = _ref5.showNotifications,
		    showNotifications = _ref5$showNotificatio === undefined ? true : _ref5$showNotificatio;

		_objectDestructuringEmpty(_ref4);

		return (0, _preact.h)(
			_preactMdl.Card,
			{ shadow: '2', 'class': 'centered' },
			(0, _preact.h)(
				_preactMdl.Card.Title,
				null,
				(0, _preact.h)(
					_preactMdl.Card.TitleText,
					null,
					'App Settings'
				)
			),
			(0, _preact.h)(
				_preactMdl.Card.Text,
				{ 'class': 'byline' },
				'These only apply to this device.'
			),
			(0, _preact.h)(
				_preactMdl.Card.Text,
				null,
				(0, _preact.h)(
					'form',
					{ action: 'javascript:;' },
					(0, _preact.h)(
						_preactMdl.CheckBox,
						{ checked: limit, onChange: this.linkState('limit') },
						'Limit to 50 unread updates'
					)
				),
				(0, _preact.h)(
					'form',
					{ action: 'javascript:;' },
					(0, _preact.h)(
						_preactMdl.CheckBox,
						{ checked: showNotifications, onChange: this.linkState('showNotifications') },
						'Show Notifications?'
					)
				),
				(0, _preact.h)(
					'form',
					{ action: 'javascript:;' },
					(0, _preact.h)(
						_preactMdl.CheckBox,
						{ checked: plainBackground, onChange: this.linkState('plainBackground') },
						'Plain background'
					)
				),
				(0, _preact.h)(
					'form',
					{ action: 'javascript:;' },
					(0, _preact.h)(
						'p',
						null,
						'Cache Data: ',
						this.getCacheSize()
					),
					(0, _preact.h)(
						_preactMdl.Button,
						{ colored: true, onClick: this.clearCache },
						'Clear Cache'
					)
				),
				(0, _preact.h)(
					'form',
					{ action: 'javascript:;' },
					(0, _preact.h)(
						'p',
						null,
						'Done Exploring?'
					),
					(0, _preact.h)(
						_preactMdl.Button,
						{ colored: true, onClick: this.logout },
						'Sign Out'
					)
				)
			)
		);
	};

	return Preferences;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'clearCache', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'clearCache'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'logout', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'logout'), _class.prototype)), _class);
exports.default = Preferences;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _desc, _value, _class;

var _preact = __webpack_require__(0);

var _decko = __webpack_require__(1);

var _preactMdl = __webpack_require__(2);

var _peach = __webpack_require__(4);

var _peach2 = _interopRequireDefault(_peach);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Login = (_class = function (_Component) {
	_inherits(Login, _Component);

	function Login() {
		var _temp, _this, _ret;

		_classCallCheck(this, Login);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			type: 'register'
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Login.prototype.componentWillMount = function componentWillMount() {
		if (Object.keys(_peach2.default.store.getState()).length) {
			this.setState({ type: 'login' });
		}
		(0, _pubsub.emit)('track', this.state.type);
	};

	Login.prototype.submit = function submit(e) {
		var _this2 = this;

		var _state = this.state,
		    type = _state.type,
		    name = _state.name,
		    email = _state.email,
		    password = _state.password,
		    creds = { name: name, email: email, password: password };

		if (type === 'login') delete creds.name;
		for (var i in creds) {
			if (!creds[i] || creds[i].length < 3) {
				return this.setState({ error: 'Invalid ' + i });
			}
		}_peach2.default[type](creds, function (error, session) {
			if (error) {
				if (String(error).match(/generic db error/i)) {
					error = 'Name or email is invalid or already registered.';
				}
				return _this2.setState({ error: error });
			}

			if (type === 'register') {
				// auto-follow @nectarineapp so that we can see "friends of friends" in the explore tab
				// the reason this uses @nectarineapp is because it has peachme set up to automatically accept our follow request.
				// worst-case the request fails. then we time out after 10s and redirect to explore, but Peach is not fun without friends :(
				_peach2.default.addFriend('nectarineapp', function () {
					var timedOut = false;
					var timer = setTimeout(function () {
						timedOut = true;
						(0, _pubsub.emit)('go', '/explore');
					}, 10000);
					_peach2.default.rawRequest({
						method: 'POST',
						url: 'https://peachme.nectarine.rocks/follow',
						body: JSON.stringify({ name: name }),
						headers: { 'Content-Type': 'application/json' }
					}, function () {
						clearTimeout(timer);
						if (timedOut) (0, _pubsub.emit)('refresh');else (0, _pubsub.emit)('go', '/explore');
					});
				});
			}
		});
		if (e) return e.preventDefault(), false;
	};

	Login.prototype.switchMode = function switchMode() {
		var type = this.state.type === 'register' ? 'login' : 'register';
		(0, _pubsub.emit)('track', type);
		this.setState({ type: type });
	};

	Login.prototype.checkEmail = function checkEmail() {
		var _this3 = this;

		var _state2 = this.state,
		    type = _state2.type,
		    email = _state2.email;

		_peach2.default.isEmailRegistered({ email: email }, function (err, data) {
			var taken = !!(data && data.error && data.error.code === 1201 || String(err).match(/already exists/i)),
			    type = _this3.state.type;

			if (type === 'login' !== taken) {
				_this3.switchMode();
			}
		});
	};

	Login.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
		var type = _ref.type;

		if (type) this.setState({ type: type });
	};

	Login.prototype.render = function render(_ref2, _ref3) {
		var type = _ref3.type,
		    name = _ref3.name,
		    email = _ref3.email,
		    password = _ref3.password,
		    error = _ref3.error;

		_objectDestructuringEmpty(_ref2);

		return (0, _preact.h)(
			_preactMdl.Layout,
			{ id: 'login', 'fixed-header': true, js: false },
			(0, _preact.h)(
				_preactMdl.Layout.Header,
				null,
				(0, _preact.h)(
					_preactMdl.Layout.HeaderRow,
					null,
					(0, _preact.h)(
						_preactMdl.Layout.Title,
						null,
						'Nectarine'
					),
					(0, _preact.h)(_preactMdl.Layout.Spacer, null),
					(0, _preact.h)(
						_preactMdl.Button,
						{ icon: true },
						'\uD83C\uDF51'
					),
					(0, _preact.h)(_preactMdl.Layout.Spacer, null),
					(0, _preact.h)(
						_preactMdl.Button,
						{ icon: true, onClick: this.submit },
						(0, _preact.h)(_preactMdl.Icon, { icon: 'arrow forward' })
					)
				)
			),
			(0, _preact.h)(
				_preactMdl.Layout.Content,
				null,
				(0, _preact.h)(
					_preactMdl.Card,
					{ shadow: 2, 'class': 'centered' },
					(0, _preact.h)(
						_preactMdl.Card.Text,
						null,
						(0, _preact.h)(
							'form',
							{ action: 'javascript:', onSubmit: this.submit },
							(0, _preact.h)(
								'h4',
								null,
								type === 'register' ? 'Sign Up' : 'Sign In'
							),
							(0, _preact.h)(
								'div',
								{ 'class': { error: 1, showing: error } },
								error || null
							),
							(0, _preact.h)(
								'div',
								{ style: { maxHeight: type === 'register' ? 100 : 0, transition: 'all 500ms ease', overflow: 'hidden' } },
								(0, _preact.h)(_preactMdl.TextField, {
									label: 'Username',
									'floating-label': true,
									pattern: '^[a-z0-9_.-]+$',
									required: type === 'register' && !!error || null,
									onInput: this.linkState('name'),
									value: name })
							),
							(0, _preact.h)(_preactMdl.TextField, {
								label: 'Email',
								type: 'email',
								required: !!error || null,
								'floating-label': true,
								onInput: this.linkState('email'),
								onChange: this.checkEmail,
								value: email }),
							(0, _preact.h)(_preactMdl.TextField, {
								type: 'password',
								label: 'Password',
								required: !!error || null,
								'floating-label': true,
								onInput: this.linkState('password'),
								value: password }),
							(0, _preact.h)(
								'button-bar',
								null,
								(0, _preact.h)(
									_preactMdl.Button,
									{ raised: true, colored: true, onClick: this.submit },
									type === 'register' ? 'Sign Up' : 'Log In'
								)
							),
							(0, _preact.h)(
								'button-bar',
								null,
								(0, _preact.h)(
									'a',
									{ onClick: this.switchMode },
									type === 'register' ? 'Already have an account?' : 'Need to sign up?'
								)
							)
						)
					)
				)
			)
		);

		/*
  return (
  	<div id="login">
  		<div class="list">
  			<label class="item item-input item-stacked-label" visible={type==='register'}>
  				<span class="input-label">Name</span>
  				<input type="text" placeholder="John Doe"
  					value={name} onChange={this.linkState('name')} />
  			</label>
  				<label class="item item-input item-stacked-label">
  				<span class="input-label">Email</span>
  				<input type="email" placeholder="you@example.com"
  					value={email} onChange={this.linkState('email')} />
  			</label>
  				<label class="item item-input item-stacked-label">
  				<span class="input-label">Password</span>
  				<input type="password"
  					value={password} onChange={this.linkState('password')} />
  			</label>
  		</div>
  			<div class="padding">
  			<button class="button button-block button-positive" onClick={this.submit}>
  				{ type==='register' ? 'Sign Up' : 'Log In' }
  			</button>
  		</div>
  			<div class="padding">
  			<a onClick={this.switchMode}>{ type==='register' ? 'Already have an account?' : 'Need to sign up?' }</a>
  		</div>
  	</div>
  );
  */
	};

	return Login;
}(_preact.Component), (_applyDecoratedDescriptor(_class.prototype, 'submit', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'submit'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'switchMode', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'switchMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'checkEmail', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'checkEmail'), _class.prototype)), _class);
exports.default = Login;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.init = init;
exports.notify = notify;

var _store = __webpack_require__(11);

var _store2 = _interopRequireDefault(_store);

var _pubsub = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY_ARR = [];

var EMPTY = {};

var prevState = void 0;

function handleStoreUpdate(_ref) {
	var activityItems = _ref.activityItems,
	    inboundFriendRequests = _ref.inboundFriendRequests,
	    _ref$prefs = _ref.prefs;
	_ref$prefs = _ref$prefs === undefined ? {} : _ref$prefs;
	var showNotifications = _ref$prefs.showNotifications;

	// activityItems = activityItems.slice();
	// inboundFriendRequests = inboundFriendRequests.slice();

	if (prevState) {
		if (!prevState.showNotifications && showNotifications === true) {
			requestPermission();
		}

		var fr = findNew(inboundFriendRequests, prevState.inboundFriendRequests);
		if (fr) {
			notify(fr.length + ' new friend request' + (fr.length === 1 ? '' : 's'), fr.slice(0, 3).map(toDisplayName).join(', ') + (fr.length > 3 ? ' + ' + (fr.length - 3) + ' more' : ''), '/notifications');
		}

		var updates = findNew(activityItems, prevState.activityItems);
		if (updates) {
			var types = updates.map(function (p) {
				return p.type;
			}).filter(function (t, i, a) {
				return a.indexOf(t) === i;
			});
			notify(updates.length + ' ' + (types.length === 1 ? types[0] : 'update') + (updates.length === 1 ? '' : 's'), 'From ' + updates.slice(0, 3).map(toDisplayName).join(', ') + (updates.length > 3 ? ' + ' + (updates.length - 3) + ' more' : ''), '/stream');
		}
	}

	prevState = { activityItems: activityItems, inboundFriendRequests: inboundFriendRequests, showNotifications: showNotifications };
}

function init() {
	var _store$getState = _store2.default.getState(),
	    prefs = _store$getState.prefs;

	if (prefs && prefs.showNotifications === false) return;

	requestPermission();

	_store2.default.subscribe(handleStoreUpdate);
}

function requestPermission() {
	try {
		if (Notification.permission !== 'granted') {
			Notification.requestPermission(function (permission) {
				if (permission !== 'granted') {
					var _store$getState2 = _store2.default.getState(),
					    _store$getState2$pref = _store$getState2.prefs,
					    prefs = _store$getState2$pref === undefined ? {} : _store$getState2$pref;

					prefs.showNotifications = false;
					_store2.default.setState({ prefs: prefs });
				}
			});
		}
	} catch (err) {}
}

function allowed() {
	var _store$getState3 = _store2.default.getState(),
	    prefs = _store$getState3.prefs;

	return (!prefs || prefs.showNotifications !== false) && window.Notification && window.Notification.permission === 'granted';
}

function findNew(newArr, oldArr) {
	var oldIds = (oldArr || EMPTY_ARR).map(toId),
	    out = void 0;
	newArr = newArr || [];
	for (var i = 0; i < newArr.length; i++) {
		var p = newArr[i];
		if (oldIds.indexOf(toId(p)) === -1) {
			if (!out) out = [p];else out.push(p);
		}
	}
	return out || false;
}

var toId = function toId(_ref2) {
	var id = _ref2.id,
	    createdTime = _ref2.createdTime,
	    body = _ref2.body;
	return id || body.postID + '-' + createdTime;
};

var toDisplayName = function toDisplayName(_ref3) {
	var stream = _ref3.stream,
	    body = _ref3.body;
	return (stream || body && body.authorStream || EMPTY).displayName;
};

function notify(title, body, url) {
	if (!allowed() || !window.Notification) return;

	try {
		var n = new Notification(title, {
			icon: '/assets/icon-300.png',
			tag: 'peach',
			body: body
		});
		n.onclick = function () {
			n.close();
			window.focus();
			if (url) (0, _pubsub.emit)('go', url);
		};
	} catch (err) {}
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.363647a0a8024038ab06.js